import { GoogleAnalyticsService } from './../../../google-analytics.service';
import {
   Component, OnInit, ViewChild, Input, ElementRef, AfterViewInit, Output, EventEmitter, OnDestroy
} from '@angular/core';
import {IdexService} from '../../../idex.service';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Toast} from '../../../shared/toast/toast';
import {LeftPanelComponent} from './../left-panel/left-panel.component';
import {RegisterSignatureComponent} from '../../register-signature/register-signature.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {ViewFlowComponent} from '../../view-flow/view-flow.component';
import {ViewDocumentComponent} from './../view-document/view-document.component';
import {TranslateService} from '@ngx-translate/core';
import {TwofactorComponent} from '../../../account/twofactor/twofactor.component';
import {ConfirmDialogComponent} from '../../confirm-dialog/confirm-dialog.component';
import {SetpasswordDialogComponent} from '../../setpassword-dialog/setpassword-dialog.component';
import {RejectTaskDialogComponent} from '../../reject-task-dialog/reject-task-dialog.component';
import {Mimetype} from '../../../shared/mimetype';
import {PdfRenditionWatcher} from '../../../shared/pdf-rendition-watcher';
import {CommentboxComponent} from '../../comment-pdf/commentbox/commentbox.component';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AnnotationControllerComponent } from 'app/dms/annotation-controller/annotation-controller.component';
import { DocumentData } from '../../../dms/annotation-controller/document-data.type';
import { Section } from 'app/e-form/model/eform-type';
import { DynamicFormBuilderComponent } from 'app/e-form/form-generate/dynamic-form-builder/dynamic-form-builder.component';
import { EformService } from 'app/e-form/service/eform.service';
import { MomentPipe } from 'app/shared/moment.pipe';
import { EformAPI } from 'app/e-form/e-form.api';
import { Form, TaskAttribute } from '../../create-task/create-task.type';
import {ExternalSignatureComponent} from "../../external-signature/external-signature.component";

declare let $: any;
declare let SVG: any;
declare let moment: any;

let changeImage;
let onDrag;
let typeName;
let isZoom;
const widthInit = 100;
const widthInitial = 80;
const heightInit = 50;
const heightInitial = 40;
const widthAttachInit = 64;
const heightAttachInit = 64;
declare let EnjoyHint: any;
let enjoyhint_instance: any;
let itemSignW = 100;
let itemInitSignW = 80;
let itemSignH = 50;
let itemInitSignH = 40;
let giveYcal = 0;
let giveYcalInit = 0;
const widthIconInit = 25;
const heightIconInit = 25;

@Component({
   selector: 'app-sign-task',
   templateUrl: './sign-task.component.html',
   styleUrls: ['./sign-task.component.css', '../../../../assets/font_stylesheet.css']
})
export class SignTaskComponent implements OnInit, AfterViewInit, OnDestroy {
   @Input() typeName: string;
   @Input() taskAttribute: TaskAttribute;
   @Input() btnAction;
   @Input() isShowAttachFile: boolean;
   @Input() isToggleRightOpened;
   @Output() updatefile2 = new EventEmitter<any>();
   @Input() isToggleLeftOpened;
   @Input() isShow = true;
   @Input() isFormName: boolean;
   @Input() sections: Section[]
   @Input() onSubmit: boolean;
   @Input() formValue: any;
   @Input() taskStatus: string;
   @Input() isExtSign: boolean;
   @Output() checkUnSelectAll = new EventEmitter<any>();
   @Output() listClickEvent = new EventEmitter<any>();
   @Output() getThumbnail = new EventEmitter<any>();
   @Output() scrollThumbnail = new EventEmitter<any>();
   @Output() flagRotateByPage = new EventEmitter<any>();
   @Output() loadPageEnd = new EventEmitter<any>();
   @Output() downloadAll = new EventEmitter<any>();
   @Output() toggleRight = new EventEmitter<any>();
   @Output() toggleLeft = new EventEmitter<any>();
   @ViewChild('drawer') drawer;
   @ViewChild('mainDrawer') mainDrawer;
   @ViewChild('btnToggleNav') btnToggleNav;
   @ViewChild('groupPageTrans') groupPageTrans: ElementRef;
   @ViewChild('groupAction') groupAction: ElementRef;
   @ViewChild('allImages') allImages: ElementRef;
   @ViewChild('print') print: ElementRef;
   @ViewChild('sideNavContent') sideNavContent: ElementRef;
   @ViewChild(LeftPanelComponent, { static: true }) leftPanelComp: LeftPanelComponent;
   @ViewChild(ViewDocumentComponent, { static: true }) viewDocumentComp: ViewDocumentComponent;
   @ViewChild(CommentboxComponent) commentboxComp: CommentboxComponent ;
   @ViewChild('canvasOriginal', { static: true }) public canvasOriginal: ElementRef;
   @ViewChild('canvasPatternTmp', { static: true }) public canvasPatternTmp: ElementRef;
   @ViewChild(AnnotationControllerComponent) annoComp: AnnotationControllerComponent;
   @ViewChild(DynamicFormBuilderComponent) dynamicFormComp: DynamicFormBuilderComponent;

   STATUS_2FA = 591;
   siteId: any;
   myFiles = "My Files";
   item: any;
   timeout = 0;
   type: any;
   isAttFile: any;
   pageNo1 = 1;
   toggleLeftFlag = true;
   flagiframe = false;
   position = 0;
   numprint: any;
   page = 1;
   pageSign = 1;
   mytime: any;
   numIndex = 0;
   itemIndex = 0;
   canNotPreview: boolean;
   renditionWatcher = new PdfRenditionWatcher();
   private lastToSign: any;

   /** เอกสารที่กำลังแสดงยังแปลงเป็น PDF ไม่เสร็จ */
   get isConverting(): boolean {
      return PdfRenditionWatcher.isConverting(this._dataPages?.[this.currentIndex]);
   }
   canNotFound = false;
   flagfocuspage = true;
   listPageNo = 1;
   flagprintt = 0;
   maxheightprint = 0;
   checkpositionpage = true;
   checkheightpage = 0;
   loadbypage = true;
   checkload = false;
   isLoopPage = false;
   isExpandedd: boolean;
   isClickPage = false;
   errorMessage: string;
   mimType: any;
   docidlist: any;
   namelist: any;
   initSignature = false;
   pageNo : any;
   pdfUrl: SafeResourceUrl;
   docUrl: any;
   checkNotSave: any;
   documentData: DocumentData;
   saveInProgress = false;
   isHideForm = false;

   public checkButton = false;
   public _docId;
   public _docName;
   public _signObjects = [];
   public _totalPages;
   public _docListItem;
   public signMenuClick;
   public signMenuDrag;
   public signActionClick;
   public saveActionClick;
   public sendActionClick;
   public isHideAction = false; // set for hide when waiting for other
   public isHideArrowLeft = false;
   public isHideArrowRight = true;
   public isInitail = false;
   public isDrawing = false;
   public startDrawing = false;
   public images;
   public picSign;
   public picInitSign;
   public picComment;
   public picAttachImg;
   public picCheckBox;
   public picSignature;
   public picInitSignature;
   public imgUrl: any;
   public maxWidth = 0;
   public maxHeight = 0;
   public width = 384;
   public height = 594;
   public currentIndex = 0;
   public signerSelected;
   public pageType = 'CP';
   public positionType = 'CT';
   public chkName: boolean;
   public chkDate: boolean;
   public chkApplyAll: boolean;
   public certId;
   public fontDetail = {
      'fontStyle': 'THSarabunNew',
      'fontSize': 9,
      'fontColor': '#000000',
      'fontBold': false,
      'fontItalic': false,
      'fontUnderline': false,
      'textRequired': false
   }
   public isHideDeleteBtn = false;
   public isHideRequire = true;
   public isHideProperties = false;
   public isHideCommentPdf = false;
   public currentPageNo; // TODO : change when docList Click
   public widthSignItem;
   public heightSignItem;
   public transformHeight;
   public isHideViewDocument = true;
   public zoomRatio = 1.0;
   public isZoom = false;
   public isFitPage = false;
   public isPageLoadFinish = false;
   public watermark: any;
   public colors = [
      '#8b0000',
      '#daa520',
      '#778899',
      '#800080',
      '#ff00ff',
      '#008080',
      '#556b2f',
      '#32cd32',
      '#3EA99F',
      '#0000cd',
      '#ff69b4',
      '#ff0000',
      '#bdb76b',
      '#FFD700',
      '#7FFFD4',
      '#FF4500',
      '#32CD32',
      '#FF8B8B',
      '#9932CC',
      '#A0522D',
      '#00CED1',
      '#2F4F4F',
      '#98AFC7',
      '#566D7E',
      '#FBE7A1',
      '#728FCE',
      '#4863A0',
      '#2B547E',
      '#81D8D0',
      '#2554C7',
      '#1589FF',
      '#00BFFF',
      '#87CEEB',
      '#C6DEFF',
      '#B0E0E6',
      '#16E2F5',
      '#045F5F',
      '#31906E',
      '#50C878',
      '#006400',
      '#32CD32',
      '#DAEE01',
      '#FFFACD',
      '#57FEFF',
      '#FED8B1',
      '#FFFF00',
      '#D9F1F1',
      '#B6E3E9',
      '#D1EAF5',
      '#C3DDE0',
      '#A5CEDB',
      '#95C8D7',
      '#AACCE2',
      '#789CCE',
      '#FBD4AD',
      '#F8D7C1',
      '#EDAB94',
      '#FFAE92',
      '#DADDC5',
      '#A5B89C',
      '#C1D7D0',
      '#CAE3CC',
      '#E0F8E8',
      '#D9EDE7',
      '#BDDED1',
      '#B7B7FF',
      '#E7D2EF',
      '#EFE5EE',
      '#C4B3C3',
      '#C6A5C7',
      '#E2D0DC',
      '#D9B0CD',
      '#DFA5D6',
      '#E5A9DE',
      '#FEF4F3',
      '#FCDEE2',
      '#FFD6DA',
      '#FFC6CF',
      '#FFE4E3',
      '#FFD3D3',
      '#FFCDCD',
      '#FFB7B7',
      '#FBF1D5',
      '#FFE2AE',
      '#F4CC84',
      '#F7D07A'
   ];
   public _isComment;
   public docType: any;

   private _isHideProp = false;
   private _isBreak = false;
   private _isDialogShow = false;
   private _isShowDialogSignAll = false;
   private _isDeselect = true;
   private _isChangeSigner = false;
   private _giveNullElement;
   private _objectSVG = [];
   private _docIds = [];
   private _signItem;
   private _user = this.service.user;
   private _password;
   private _margin = 30;
   private _marginn = 30;
   private _draw;
   private _objDraw;
   public _isVisible;
   private _imgFocus: any;
   private _widthInit = 100;
   private _widthInitialSign = 80;
   private _widthInitName = 49;
   private _widthInitDate = 54;
   private _widthInitTextarea = 100;
   private _widthInitIcon = 25;
   private _widthInitAttach = 64;
   private _widthInitCheckBox = 22.5;
   private _widthInitBox = 13.5;
   private _widthInitCheck = 10;
   private _heightInit = 50;
   private _heightInitialSign = 40;
   private _heightInitNameDate = 9;
   private _heightInitTextarea = 25;
   private _widthSignature = 30;
   private _widthInitSignature = 18;
   private _heightInitSignature = 13;
   private _heightInitIcon = 25;
   private _heightInitAttach = 64;
   private _heightInitCheckBox = 22.5;
   private _heightInitBox = 12;
   private _heightInitCheck = 10;
   private _y = -4;
   private _fontSize = 9;
   private _yMarginSign = 4;
   private _isHaveThai = false;
   private _eventMouseOver;
   private _objectDrag: any;
   private _onDrag;
   private _onClickDelete;
   private _onClickSignOff;
   private _onDeleteComment;
   private _signature = 'Signature';
   private _initialze = 'Initial Sign';
   private _fullName = 'Song Manse';
   private _date = 'DATE';
   private _text = 'TEXT';
   private _image = 'IMAGE';
   private _idSignitems;
   private _heightDialogShowPage = 500;
   private _itemPages;
   public _dataPages;
   public _statusInitial = [];
   // Attribute Signature Items
   private _signer;
   public _taskContactId;
   _fieldType = 'signature';
   private _pageNum = '1';
   private _moveOnPage = false;
   private _dragIcon;
   private _isDrag = false;
   private _imgFocusCal;
   private _signItems = [];
   private _textItems = [];
   private _itemSignItems = [];
   private _itemTextItems = [];
   private _textRequired = false;
   private _recursive = 0;
   private _keyFieldType = {
      signature: 'signature',
      initSignature: 'initSignature',
      name: 'name',
      date: 'date',
      text: 'text',
      comment: 'comment',
      image: 'image',
      checkbox: 'checkbox',
      signatureForm: 'signature-form'
   };
   private _hasSignature;
   private _hasInitial;
   private signatureId: any;
   private initialId: any;
   private _flagMouseOver;
   private _fName;
   private _lName;
   private _isTwofacGoogle;
   private _isTwofacSign;
   private _isFirstSingIn = false;
   private _pageCount = 1;
   private countZoom = 0;
   private giveScroll = 0;
   private registerSignDialog: MatDialogRef<RegisterSignatureComponent>;
   private externalSignDialog: MatDialogRef<ExternalSignatureComponent>
   private changePasswordDialog: MatDialogRef<SetpasswordDialogComponent>;
   private viewFlow: MatDialogRef<ViewFlowComponent>;
   private twofactor: MatDialogRef<TwofactorComponent>;
   private dialogSignedAll: MatDialogRef<ConfirmDialogComponent>;
   private textPageOf;
   private includeName: any;
   private includeDate: any;
   private chunkSize = 500000;
   private IdAttachItem: any;
   private itemImageId;
   private currentDate: Date;
   ext: any;
   private stepOrder;
   private taskContactId;
   private _isfirstTextFinish = true;
   fileFormName = '';
   public key: string;

   constructor(public service: IdexService, private toast: Toast, private router: Router,
               private dialog: MatDialog,
               private translate: TranslateService,
               private sanitizer: DomSanitizer,private googleAnalyticsService:GoogleAnalyticsService,
               private eformService: EformService, private api: EformAPI,
               private route: ActivatedRoute) {

      this.signMenuClick = new Subject();
      this.signMenuDrag = new Subject();
      this.signActionClick = new Subject();
      this.saveActionClick = new Subject();
      this.sendActionClick = new Subject();
      this._signer = this._user.email;
      this._isHaveThai = this.checkThaiLanguage(this._user.name);
      this._signItem = {
         'signer': this._signer
         , 'fieldType': this._fieldType
         , 'pageType': this.pageType
         , 'pageNum': this._pageNum
         , 'positionType': this.positionType
         , 'chkName': this.chkName
         , 'chkDate': this.chkDate
         , 'certId': this.certId
         , 'coordinateX': '150'
         , 'coordinateY': '470'
         , 'fieldWidth': this._widthInit
         , 'fieldHeight': this._heightInit
         , 'idSignItem': ''
         , 'flagSign': false
         , 'order': 0
         , 'content': ''
         , 'idImageItem': ''
         , 'fontStyle': 'THSarabunNew'
         , 'fontSize': 9
         , 'fontColor': '#000000'
         , 'fontBold': false
         , 'fontItalic': false
         , 'fontUnderline': false
         , 'textRequired': false
         , 'flagCheckbox': false
         , 'stepOrder': 0
         , 'taskContactId': 0
      };
      this._dragIcon = document.createElement('img');
      this._flagMouseOver = false;
      this.picComment = 'assets/icons/comment.png';
      this.picAttachImg = 'assets/icons/attachImg.png';
      this.picCheckBox = 'assets/icons/tick.png';
      this.picSignature = 'assets/images/signature.png';
      this.picInitSignature = 'assets/images/initials.png';
      this.translate.get('flow.of').subscribe(s => {
         this.textPageOf =  s.toString();
      });
      this.currentDate = new Date();
   }

   ngOnInit() {
      this.handleMenuClick();
      this.handleMenuDrag();
      this.handleGetTranslateSignItem();
      this.handleCheckLanguage();
      if (this.isExtSign) {
         this.getProfileExtUser();
      } else {
         this.getProfile();
      }
      this.handleToggleClosed();
      this.getWatermark();
      typeName = this.typeName;
      if (!localStorage.getItem('isReload')) {
         localStorage.setItem('isReload', 'false')
         location.reload()
      } else {
         localStorage.removeItem('isReload');
      }
      this.route.params.forEach((params: Params) => {
         this.key = params['key'];;
      });
   }

   handleWaitActionPrint(isShow) {
      if (isShow) {
         $('#pano-sign-task').show();
         $('#main-page').addClass('blur');
      } else {
         $('#pano-sign-task').hide();
         $('#main-page').removeClass('blur');
      }
   }

   ngAfterViewInit() {
      this._giveNullElement = this.allImages.nativeElement;
   }

   getWatermark() {
      this.service.getWatermark('Web',this.siteId).subscribe((data) => {
         this.watermark = data;
      });
   }

   /** เมื่อเปิดเข้ามาในหน้า เซ็นอกสารทำการเรียก service transform เพื่อดึงข้อมูลรูปภาพมาวางไว้ตั้งต้นก่อน */
   changeDrawPage(index, toSign) {
      this.docType = this.taskAttribute.docList[index].docName.split('.').pop()
      this.clearAllZoom();
      this.clearAllPage();
      this.commentboxComp.clearCommentComponent();
      const token = this.service.user.token;
      if (this._hasSignature) {
         this.picSign = this.getPicSign();
      }
      if (this._hasInitial) {
         this.picInitSign = this.getPicSignInit();
      }
      this._docIds = [];
      if (this.taskAttribute.docList.length > 0) {
         this.setDocName(this.taskAttribute.docList[index].docName);
         this.setDocId(this.taskAttribute.docList[index].docId);
         this.listClickEvent.emit(this.getDocId());
         for (const document of this.taskAttribute.docList) {
            this._docIds.push(document.docId);
         }
         this.handleWaitAction(true);
         this.lastToSign = toSign;
         this.service.transformPdf(this._docIds, this.taskAttribute.taskId, true)
            .subscribe((data) => {
                  this.watchRendition(data);
                  if (data.length > 0) {
                     let checkTypeList = data.map(value => value.name)
                     let typeIndex = checkTypeList.findIndex(v => v.endsWith('.zdox'))

                     if (typeIndex !== -1 && this.taskAttribute.docList[typeIndex].docName.endsWith('.zdox')) {
                        data[typeIndex] = {
                           "docId": this.taskAttribute.docList[typeIndex].docId,
                           "mimType": "text/xml",
                           "name": this.taskAttribute.docList[typeIndex].docName,
                           "totalPages": 0,
                           "maxWidth": 0,
                           "maxHeight": 0,
                           "canTransform": false
                        }
                     }

                     this.canNotFound = false;
                     this.itemIndex = 0;
                     this.listPageNo = 1;
                     this._pageCount = 1;
                     this._statusInitial = [];
                     this.transformHeight = 0;
                     this._dataPages = data;
                     this.checkButton = false;
                     this.isAttFile = this.taskAttribute.docList[this.currentIndex].isAttachFile;
                     this.mimType = this._dataPages[this.currentIndex].mimType;
                     this.namelist = this._dataPages[this.currentIndex].name;
                     this.docidlist = this._dataPages[this.currentIndex].docId;
                     if ((this.mimType === 'application/msword' || this.mimType === 'application/pdf' || this.mimType === 'application/vnd.ms-excel' || this.mimType === 'application/vnd.ms-powerpoint'
                        || this.mimType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                        || this.mimType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        || this.mimType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || this.mimType === 'image/tiff'
                        || this.mimType === 'image/jpeg' || this.mimType === 'image/png' || this.mimType === 'image/bmp' || this.mimType.indexOf('text/') === 0)
                        && this._dataPages[this.currentIndex].totalPages > 0) {
                        this.canNotPreview = false;
                        this.isHideCommentPdf = false;
                     } else {
                        this.canNotPreview = true;
                        this.isHideCommentPdf = true;
                     }
                     this._totalPages = this._dataPages[index].totalPages;
                     if (this._totalPages > 0) {
                        if (this.maxWidth < this._dataPages[index].maxWidth) {
                           this.maxWidth = this._dataPages[index].maxWidth;
                        }
                        this.maxHeight += this._dataPages[index].maxHeight;
                     }
                     this.setLeftComment();
                     for (let i = 0; i < this._totalPages; i++) {
                        this._statusInitial.push({'isInitial': false});
                     }

                     if (this._dataPages[this.currentIndex].name.endsWith('.zdox')) {
                        this._statusInitial.push({'isInitial': false});
                     }

                     for (let i = 0; i < this.taskAttribute.docList.length; i++) {
                        if (this._dataPages[i]) {
                           this.taskAttribute.docList[i].totalPages = this._dataPages[i].totalPages;
                        }
                     }
                     this.checkpositionpage = true;
                     for (let i = 0; i < this._totalPages; i++) {
                        if (this._dataPages[index].pages[i].width > this._dataPages[index].pages[i].height) {
                           this.checkpositionpage = false;
                           break;
                        }
                     }
                     if (this._totalPages > 0) {
                        this.addItemPage(this._dataPages[index], 0);
                     } else {
                        this.handleWaitAction(false);
                     }
                     if (this.taskAttribute.taskStatus !== 'Need to sign') {
                        this.isHideCommentPdf = true;
                     }
                     this.taskStatus = this.taskAttribute.taskStatus;
                     if (this._dataPages[index].name.endsWith('.zdox')) {
                        this.onListClick({
                           docId: this.taskAttribute.docList[index].docId,
                           index: index
                        });
                     } else {
                        if (toSign) {
                           if (this.taskAttribute.docList[index].signItems) {
                              const signItems = this.taskAttribute.docList[index].signItems;
                              this._signItems = this.filterSignItemsAll(signItems,  this.service.user.email);
                              this._itemSignItems = this.filterSignItemsAll(signItems, this.service.user.email);
                              if (this._signItems.length > 0) {
                                 if (!this.isHideAction) {
                                    this.focusSignItem(-1);
                                 }
                              } else {
                                 if (this.taskAttribute.taskStatus === 'Need to sign') {
                                    const indexPageNotSign = this.getPageNotSign(this.taskAttribute.docList);
                                    if (indexPageNotSign !== -1) {
                                       this.onListClick({
                                          docId: this.taskAttribute.docList[indexPageNotSign].docId,
                                          index: indexPageNotSign
                                       });
                                    }
                                 }
                              }
                           } else {
                              if (this.taskAttribute.taskStatus === 'Need to sign') {
                                 const indexPageNotSign = this.getPageNotSign(this.taskAttribute.docList);
                                 if (indexPageNotSign !== -1) {
                                    this.onListClick({
                                       docId: this.taskAttribute.docList[indexPageNotSign].docId,
                                       index: indexPageNotSign
                                    });
                                 }
                              }
                           }
                        }
                     }
                  } else {
                     this.canNotFound = true;
                     this.isHideCommentPdf = true;
                  }
                  this.handleWaitAction(false);
                  this.isPageLoadFinish = true;
                  this.loadPageEnd.emit();
                  this.page = 1;
                  if (localStorage.getItem('first_sign-task_open') !== 'true') {
                     this.onStartTutorial();
                     localStorage.setItem('first_sign-task_open', 'true');
                  }
                  setTimeout(() => {
                     if (this.isToggleRightOpened) {
                        this._isComment = true;
                        this.toggleRight.emit();
                     }
                  }, 0);
               },
               err => {
                  this.handleWaitAction(false);
                  console.error(err);
               });
         this.isInitail = true;
      }
   }

   /** เมื่อทำการกดที่รายการเอกสารจะทำการ bind data เป็นค่าเริ่มต้นใหม่ */
   /** poll เอกสารที่ยังแปลงไม่เสร็จ แสดงผลทันทีเมื่อเอกสารที่เปิดอยู่แปลงเสร็จ */
   private watchRendition(data: any[]) {
      const taskId = this.taskAttribute.taskId;
      this.renditionWatcher.watch(data, ids => this.service.transformPdf(ids, taskId, true), (doc, i) => {
         if (!this._dataPages) {
            return;
         }
         this._dataPages[i] = doc;
         if (this.taskAttribute.docList[i]) {
            this.taskAttribute.docList[i].totalPages = doc.totalPages;
         }
         if (i === this.currentIndex) {
            this.changeDrawPage(i, this.lastToSign);
         }
      }, () => this.currentIndex);
   }

   ngOnDestroy() {
      // ออกจากหน้า/cancel: เอาไฟล์ที่ยังรอแปลงออกจากคิวของ backend (ไฟล์ที่กำลังแปลงอยู่จะทำต่อจนเสร็จ)
      this.renditionWatcher.release(ids => this.service.releasePdfTransform(ids));
   }

   refreshPage(index) {
      // เอกสารเพิ่งแปลงเสร็จหลังโหลดหน้า หรือยังแปลงอยู่: โหลดสถานะใหม่และเริ่ม poll รอบใหม่
      if (this.renditionWatcher.isStale(this.currentIndex) || this.isConverting) {
         this.changeDrawPage(this.currentIndex, this.lastToSign);
         return;
      }
      this.clearAllZoom();
      this.clearAllPage();
      this.commentboxComp.clearCommentComponent();
      const token = this.service.user.token;
      if (this._hasSignature) {
         this.picSign = this.getPicSign();
      }
      if (this._hasInitial) {
         this.picInitSign = this.getPicSignInit();
      }
      if (this.taskAttribute.docList.length > 0 && this._dataPages) {
         this.handleWaitAction(true);
         this.itemIndex = 0;
         this.listPageNo = 1;
         this._pageCount = 1;
         this._statusInitial = [];
         this.transformHeight = 0;
         if (this._dataPages) {
            this.canNotFound = false;
            this.mimType = this._dataPages[this.currentIndex].mimType;
            this.namelist = this._dataPages[this.currentIndex].name;
            this.docidlist = this._dataPages[this.currentIndex].docId;
            if ((this.mimType === 'application/msword' || this.mimType === 'application/pdf' || this.mimType === 'application/vnd.ms-excel' || this.mimType === 'application/vnd.ms-powerpoint'
               || this.mimType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || this.mimType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
               || this.mimType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || this.mimType === 'image/tiff'
               || this.mimType === 'image/jpeg' || this.mimType === 'image/png' || this.mimType === 'image/bmp' || this.mimType.indexOf('text/') === 0)
               && this._dataPages[this.currentIndex].totalPages > 0) {
               this.canNotPreview = false;
               this.isHideCommentPdf = false;
            } else {
               this.canNotPreview = true;
               this.isHideCommentPdf = true;
            }
         } else {
            this.canNotFound = true;
            this.isHideCommentPdf = true;
         }
         this._totalPages = this._dataPages[index].totalPages;
         if (this._totalPages > 0) {
            if (this.maxWidth < this._dataPages[index].maxWidth) {
               this.maxWidth = this._dataPages[index].maxWidth;
            }
            this.maxHeight += this._dataPages[index].maxHeight;
         }
         this.setLeftComment();
         for (let i = 0; i < this._totalPages; i++) {
            this._statusInitial.push({'isInitial': false});
         }
         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            if (this._dataPages[i]) {
               this.taskAttribute.docList[i].totalPages = this._dataPages[i].totalPages;
            }
         }
         this.checkpositionpage = true;
         for (let i = 0; i < this._totalPages; i++) {
            if (this._dataPages[index].pages[i].width > this._dataPages[index].pages[i].height) {
               this.checkpositionpage = false;
               break;
            }
         }
         if (this._totalPages > 0) {
            this.addItemPage(this._dataPages[index], 0);
         }
         if (this.taskAttribute.taskStatus !== 'Need to sign') {
            this.isHideCommentPdf = true;
         }
         this.taskStatus = this.taskAttribute.taskStatus;
         if (this.taskAttribute.docList[index].signItems) {
            const signItems = this.taskAttribute.docList[index].signItems;
            this._signItems = this.filterSignItemsAll(signItems, this.service.user.email);
            this._itemSignItems = this.filterSignItemsAll(signItems, this.service.user.email);
            if (this._signItems.length > 0) {
               if (!this.isHideAction) {
                  setTimeout(() => {
                     this.focusSignItem(-1);
                  }, 0);
               } else {
                  this.scrollThumbnail.emit(this.page);
               }
            } else {
               this.scrollThumbnail.emit(this.page);
            }
         } else {
            if (this.taskAttribute.taskStatus === 'Need to sign') {
               const indexPageNotSign = this.getPageNotSign(this.taskAttribute.docList);
               if (indexPageNotSign !== -1) {
                  this.onListClick({
                     docId: this.taskAttribute.docList[indexPageNotSign].docId,
                     index: indexPageNotSign
                  });
               } else {
                  this.scrollThumbnail.emit(this.page);
               }
            } else {
               this.scrollThumbnail.emit(this.page);
            }
         }
         this.handleWaitAction(false);
         this.isPageLoadFinish = true;
         this.loadPageEnd.emit();
         this.page = 1;
         setTimeout(() => {
            if (this.isToggleRightOpened) {
               this._isComment = true;
               this.toggleRight.emit();
            }
         }, 0);
         this.isInitail = true;
      }
   }

   /** add รูปภาพต่อท้ายรูปที่แสดงทั้งหมดในปัจจุบัน */
   append(imgUrl: string, width: number, height: number, tranHeight: number, pageNo: number, maxWidth: number) {
      if (this.isZoom || this.isFitPage || !this.isToggleRightOpened) {
         width *= this.getCountZoom();
         height *= this.getCountZoom();
         tranHeight *= this.getCountZoom();
         maxWidth *= this.getCountZoom();
      }
      if (this.checkpositionpage) {
         if (maxWidth > width) {
            this.position = (maxWidth - width) / 2;
         } else {
            this.position = 0;
         }
      }
      if (!this.checkpositionpage) {
         if (width >= height) {
            this.position = 0;
         } else {
            this.position = (maxWidth - width) / 2;
         }
      }

      const $_img = $('#img_' + pageNo);
      if ($_img.length === 0) {
         this.allImages.nativeElement
            .insertAdjacentHTML('beforeEnd', '<g class="imageSign" draggable="false" id="img_'
               + pageNo + '" transform="matrix(1,0,0,1,' + this.position + ', ' + tranHeight + ')" >' +
               '<image draggable="false" width=' + width + ' height=' + height + ' href=' + imgUrl + ' class=center />' +
               '<text class="doNotPrint" style="text-align: center"  y=' + this.calculateYtext(height) + ' x=' +
               this.calculateXtext(width, pageNo, this._totalPages) + '>' +
               pageNo + ' ' + this.textPageOf + ' ' + this._totalPages + '</text>' + this.createWatermark(pageNo, width, height) + '</g>'
            ); // TODO : change to dynamic append and prepend
      } else {
         $($_img.find('image')[0]).attr('href', imgUrl);
      }
   }

   createWatermark(pageNo, width, height) {
      let watermarkHTML = '';
      if (this.watermark && this.watermark != null) {
         let fontFamily = 'sans-serif';
         let color = '#33BBE6';
         let fontSize = '60';
         let opacity = 0.25;
         if (this.watermark.fontFamily) {
            fontFamily = this.watermark.fontFamily;
         }
         if (this.watermark.color) {
            color = this.watermark.color;
         }
         if (this.watermark.fontSize) {
            fontSize = this.watermark.fontSize;
         }
         if (this.watermark.opacity) {
            opacity = this.watermark.opacity / 100;
         }

         watermarkHTML = '<text dominant-baseline="middle" text-anchor="middle" ' +
            'fill="' + color + '" transform="translate(' + (width / 2) + ',' + (height / 2) + ') rotate(-45)" ' +
            'fill-opacity="' + opacity + '" font-size="' + (parseInt(fontSize, 10) * this.getCountZoom()) + '" font-family="' + fontFamily + '">' + this.watermark.text + '</text>';
      }
      return watermarkHTML;
   }

   appendPrint(imgUrl: string, width: number, height: number, tranHeight: number, pageNo: number) {
      if (pageNo === 1) {
         this.numprint = 20;
      } else {
         this.numprint = 25;
      }
      this.print.nativeElement
         .insertAdjacentHTML('beforeEnd',
            '<img src=' + imgUrl + ' width=' + '100%' + ' height=' + '170%' +
            ' style="padding-top:' + this.numprint + 'px" class="marginprint">'
         );
   }

   /** ลบรูปภาพสุดท้ายออก */
   remove() {
      this.allImages.nativeElement.lastChild.remove(); // TODO : remove element
   }

   /** เมื่อแทบ navigation มีการเปลี่ยนแปลงจะเข้า function callback นี้ */
   navChange(component, drawer) {
      this._isVisible = drawer._elementRef.nativeElement.style.visibility;
      if (drawer.opened) { // TODO : change position of menu on headerbar
         this.isHideArrowLeft = true;
         this.isHideArrowRight = false;
         this.handleToggleOpend();
         if (!this.isZoom && this.isToggleRightOpened) {
            this.isFitPage = true;
            this.handleFitPage(true);
         }
      } else {
         this.isHideArrowLeft = false;
         this.isHideArrowRight = true;
         this.handleToggleClosed();
         if (!this.isZoom && this.isToggleRightOpened) {
            this.isFitPage = false;
            this.handleFitPage(false);
         }
      }
   }

   /** ตั้งค่าเริ่มต้นให้ object ที่ถูกส่งมาตาม signItem ใน taskAttribute */
   InitialDrawSvg(item) {
      const id = 'img_' + item.pageNum;
      this._draw = null;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (id === object.id) {
               this._draw = object.svg;
               break;
            }
         }
      }
      if (item.fieldType === this._keyFieldType.initSignature) {this.initSignature = true; }
      if (this._draw) {
         if (item.fieldType !== this._keyFieldType.signature && item.fieldType !== this._keyFieldType.initSignature) {
            this.initialTypeSign(item, this.numIndex, id);
         } else {
            if (item.signer.toLowerCase() === this.service.user.email.toLowerCase()) {
               if (!item.flagSign) {
                  this.initialTypeNotSign(item, this.numIndex, this.itemIndex);
                  this.itemIndex++;
               } else {
                  this.initialSignDraw(item, this.numIndex, id);
                  return;
               }
            } else {
               this.initialTypeSign(item, this.numIndex, id);
            }
         }
         if (!this.isHideAction
            && item.signer.toLowerCase() === this.service.user.email.toLowerCase()
            && parseInt(item.taskContactId, 10) === parseInt(this._taskContactId, 10)
            && !(item.comment
               && !(item.comment.postBy.id === this.service.user.email
                  && item.stepOrder === this.taskAttribute.currentLevel))) { // check item reassign
            this._objDraw.on('click', (e) => {
               if (item.fieldType === this._keyFieldType.checkbox) {
                  this.setVisibleProperty(!item.isExists);
                  this.isHideProperties = true;
                  this._isHideProp = item.isExists;
               } else if (item.fieldType === this._keyFieldType.comment) {
                  this.setVisibleProperty(true);
                  this.isHideProperties = true;
                  this._isHideProp = false;
               } else {
                  this.setVisibleProperty(true);
                  this.isHideProperties = false;
                  this._isHideProp = false;
               }
               if (item.fieldType === this._keyFieldType.signature || item.fieldType === this._keyFieldType.initSignature && !item.flagSign) {
                  this._isBreak = false;
                  this.setDeselectItem('');
                  this.finishSVG('');

                  if (!this.isExtSign) {
                     if ((this._hasSignature && !this.initSignature) || (this._hasInitial && this.initSignature)) {
                        this.clickSignAll(item, e);
                     } else {
                        this.openUpdateSignatureDraw(this._fName + ' ' + this._lName, e, item);
                     }
                  } else {
                     if ((item.fieldType === this._keyFieldType.signature && !this._hasSignature || item.fieldType === this._keyFieldType.initSignature  && !this._hasInitial)) {
                        this.openSignatureExtSignItem(item, e);
                     } else {
                        this.clickSignExtSign(item, e);
                     }
                  }
               }
            });

            this._objDraw.on('beforedrag', (e) => {
               this.handleChangeTab();
               if (!this.isDrawing) {
                  this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
                  this.commentboxComp.setDeselectComment(false);
               }
               this._objectDrag = e.target;
               const $id = e.target.id;
               this.deselectAllWithOutMatchId($id);
               if (this.taskAttribute.docList[this.currentIndex].signItems) {
                  for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
                     if (signItem.idSignItem === $id) {
                        this.setProperties(signItem, $id);
                        if (this.leftPanelComp.toolsComp && this.leftPanelComp.toolsComp.signers) {
                           const index = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail.toLowerCase() === signItem.signer.toLowerCase() || data.reassignEmail.toLowerCase() === signItem.signer.toLowerCase());
                           this.leftPanelComp.toolsComp.selected = index;
                           this.signerSelected.signer = this.leftPanelComp.toolsComp.signers[index];
                           this.signerSelected.index = index;
                        }
                        if (item.isExists) {
                           this.isHideDeleteBtn = item.isExists;
                           this.isHideProperties = item.isExists;
                           if (item.fieldType === this._keyFieldType.checkbox) {
                              this.setVisibleProperty(!item.isExists);
                              this._isHideProp = item.isExists;
                           } else {
                              this.setVisibleProperty(true);
                              this._isHideProp = false;
                           }
                        } else {
                           this.setVisibleProperty(true);
                           this.isHideDeleteBtn = false;
                           if (item.fieldType === this._keyFieldType.comment
                              || item.fieldType === this._keyFieldType.checkbox) {
                              this.isHideProperties = true;
                           } else {
                              this.isHideProperties = false;
                           }
                        }
                        break;
                     }
                  }
               }
            });
            this._objDraw.on('beforedrag', function (e) {
               if (!item.flagSign) {
                  if (this.type === 'image') {
                     this.attr({'cursor': 'move'});
                     this.selectize({
                        points: false,
                        rotationPoint: false
                     });
                  } else {
                     this.attr({'cursor': 'move'});
                     this.children()[0].attr({'cursor': 'move'});
                     this.children()[1].attr({'cursor': 'move'});
                     this.selectize({
                        points: false,
                        rotationPoint: false
                     });
                  }
               }
            });
            this._objDraw.on('dragstart.namespace', (e) => {
               this._onDrag = true;
               onDrag = true;
               this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
            });
            this._objDraw.on('dragmove.namespace', function (e) { // need to calculdate diffent Y
               if (changeImage) {
                  e.preventDefault();
                  this.move(e.detail.event.offsetX, e.detail.event.offsetY);
               }
            });
            this._objDraw.on('dragend.namespace', function (e) {
               if (typeName === 'sign' || typeName === 'signTask') {
                  this.attr({'cursor': 'pointer'});
                  if (item.fieldType === 'comment') {
                     this.selectize({
                        points: ['lt', 'rt', 'rb', 'lb'],
                        rotationPoint: false
                     });
                  } else if (this.type === 'image') {
                     this.selectize({
                        points: ['lt', 'rt', 'rb', 'lb'],
                        rotationPoint: false
                     }).resize({saveAspectRatio: true});
                  } else {
                     this.selectize({
                        points: false,
                        rotationPoint: false
                     });
                  }
               } else {
                  this.attr({'cursor': 'pointer'});
                  this.children()[0].attr({'cursor': 'pointer'});
                  this.children()[1].attr({'cursor': 'pointer'});
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
               changeImage = false;
               onDrag = false;
            });
            this._objDraw.on('dragend.namespace', (e) => {
               if (item.fieldType === this._keyFieldType.comment
               || item.fieldType === this._keyFieldType.checkbox) {
                  this.isHideProperties = true;
                  this._isHideProp = item.isExists;
               } else {
                  this.isHideProperties = false;
                  this._isHideProp = false;
               }
               this.checkImgFocus(e);
               this._onDrag = false;
               this.isDrawing = false;
               if ((item.fieldType === this._keyFieldType.image)
                  || (item.fieldType === this._keyFieldType.checkbox)) {
                  this.calculateOutBoundItemImage(e);
               } else {
                  this.calculateOutBoundItem(e);
               }
               if (item.fieldType === this._keyFieldType.text) {
                  this.setTextStyle();
               }
               this.updateItemsSignCurrentPage();
               this.finishSVG('');
            });
            this._objDraw.on('resizing', (e) => { // เมื่อทำการ resize object จะเข้า action นี้
               if (!this.isDrawing) {
                  this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
               }
               this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
            });
            this._objDraw.on('resizedone', (e) => { // เมื่อ resize จบจะเข้า action นี้
               this.updateItemsSignCurrentPage();
            });
            if (item.fieldType === this._keyFieldType.signature || item.fieldType === this._keyFieldType.initSignature) {
               this._objDraw.draggable(false);
            } else {
               this._objDraw.draggable();
            }
            item.idSignItem = this._objDraw.attr('id');
            if (item.fieldType === this._keyFieldType.text) {
               this.setTextStyle();
            }
            if (item.fieldType === 'signature') {
               if (item.chkName || item.chkDate) {
                  this._objDraw.attr('x', 200);
                  const rect = this._objDraw.children()[0];
                  rect.attr('width', item.fieldWidth);
                  const text = this._objDraw.children()[1];
                  const textId = text.attr('id');
                  const tspan = $('#' + textId).children();
                  tspan.attr('x', 50);
               }
            }
         } else {
            this._objDraw.on('click', (e) => {
               const $id = e.target.id;
               if (this._objectSVG) {
                  for (const object of this._objectSVG) {
                     if (object.svg) {
                        for (const itemObj of object.svg.children()) {
                           if ((itemObj.type === 'g' || itemObj.type === 'text' || itemObj.type === 'image')) {
                              const itemObjId = $($(itemObj.node)).attr('id');
                              if (itemObjId === $id) {
                                 this._objectDrag = itemObj.node;
                                 itemObj.selectize({
                                    points: ['lt', 'rt', 'rb', 'lb'],
                                    rotationPoint: false,
                                 });
                                 break;
                              }
                           }
                        }
                     }
                  }
               }
               this.setVisibleProperty(true);
            });
         }
      }
   }

   /** วาด object ลายเซ็น ชื่อ วันที่ พร้อม ผูก event ให้แต่ละ object */
   drawSVG($event) {
      if (!this._eventMouseOver) {
         this._eventMouseOver = $event;
      }
      if (this.startDrawing) {
         if ($event.target.parentNode.id && !this.isDrawing) {
            this.setInitialPositionType();
            this.setInitialPageType();
            const id = this.checkImgFocus($event);
            if (this._objectSVG) {
               for (const object of this._objectSVG) {
                  if (id === object.id) {
                     this._draw = object.svg;
                     break;
                  }
               }
            }
            this.drawTypeSign(id, cb => {
               this.updateItemSign(this.currentIndex);
            });

            this._objDraw.on('beforedrag', (e) => { // หลัง object วาดเสร็จตั้งค่า event เมื่อคลิกที่ object
               this.isHideDeleteBtn = false;
               this.handleChangeTab();
               if (!this.isDrawing) {
                  this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
                  this.commentboxComp.setDeselectComment(false);
               }
               this._objectDrag = e.target;
               const $id = $(e.target).attr('id');
               this.deselectAllWithOutMatchId($id);
               if (this.taskAttribute.docList[this.currentIndex].signItems) {
                  for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
                     if (item.idSignItem === $id) {
                        this.setProperties(item, $id);
                        if (this.leftPanelComp.toolsComp && this.leftPanelComp.toolsComp.signers) {
                           const index = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail.toLowerCase() === item.signer.toLowerCase());
                           this.leftPanelComp.toolsComp.selected = index;
                        }
                        if (item.fieldType === this._keyFieldType.checkbox) {
                           this.setVisibleProperty(!item.isExists);
                           this.isHideProperties = true;
                           this._isHideProp = item.isExists;
                        } else if (item.fieldType === this._keyFieldType.comment) {
                           this.setVisibleProperty(true);
                           this.isHideProperties = true;
                           this._isHideProp = item.isExists;
                        } else {
                           this.setVisibleProperty(true);
                           this.isHideProperties = false;
                           this._isHideProp = false;
                        }
                        break;
                     }
                  }
               }
            });
            this._objDraw.on('beforedrag', function (e) { // หลัง object วาดเสร็จตั้งค่า event เมื่อคลิกที่ object
               if (typeName === 'sign' || typeName === 'signTask') {
                  this.attr({'cursor': 'move'});
               } else {
                  this.attr({'cursor': 'move'});
                  this.children()[0].attr({'cursor': 'move'});
                  this.children()[1].attr({'cursor': 'move'});
               }
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            });
            this._objDraw.on('dragstart.namespace', (e) => { // เมื่อเริ่มลาก object จะทำ event ตามนี้
               this.setVisibleTextProperties(e);
               if (this._draw) {
                  for (const item of this._draw.children()) {
                     if (item.type !== 'g') { // ซ่อนกรอบ select object อื่นทิ้ง
                        item.selectize(false);
                     }
                  }
               }
               this._onDrag = true; // ตั้งค่าตัวแปร flag drag
               onDrag = true;
               this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
            });
            this._objDraw.on('dragmove.namespace', function (e) { // คำนวณการเคลื่อนไหวไหมของ object
               if (changeImage) {
                  e.preventDefault();
                  this.move(e.detail.event.offsetX, e.detail.event.offsetY);
               }
            });
            this._objDraw.on('dragend.namespace', function (e) { // เมื่อการลาก object จบจะเข้า event นี้
               if (typeName === 'sign' || typeName === 'signTask') {
                  this.attr({'cursor': 'pointer'}); // เปลี่ยนรูปเมาส์กลับเป็นปกติ
                  if ($(this.node).attr('fieldType') === 'comment') { // ให้ resize ได้เฉพาะมุมเท่านั้น โดยคง ration ให้คงเดิม
                     this.selectize({
                        points: ['lt', 'rt', 'rb', 'lb'],
                        rotationPoint: false
                     });
                  } else if (this.type === 'image') {
                     this.selectize({
                        points: ['lt', 'rt', 'rb', 'lb'],
                        rotationPoint: false
                     }).resize({saveAspectRatio: true});
                  } else {
                     this.selectize({
                        points: false,
                        rotationPoint: false
                     });
                  }
               } else {
                  this.attr({'cursor': 'pointer'}); // เปลี่ยนรูปเมาส์กลับเป็นปกติ
                  this.children()[0].attr({'cursor': 'pointer'});
                  this.children()[1].attr({'cursor': 'pointer'});
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
               changeImage = false;
               onDrag = false; // ตั้งค่าตัวแปร flag ของ drag เพื่อให้รู้ว่า drag จบแล้ว
               if (this.attr('x') < 0) {
                  this.attr('x', 0);
               }
            });
            this._objDraw.on('dragend.namespace', (e) => { // เมื่อการลาก object จบจะเข้า event นี้
               this.isDrawing = false; // ตั้งค่าตัวแปร flag ของ drawing เพื่อให้รู้ว่า drawing จบแล้ว
               if($(e.target).attr('fieldType') === this._keyFieldType.image || $(e.target).attr('fieldType') === this._keyFieldType.checkbox) {
                  this.calculateOutBoundItemImage(e);
               } else {
                  this.calculateOutBoundItem(e);
               }
               if ($(e.target).attr('fieldType') === this._keyFieldType.text) {
                  this.setTextStyle();
               }
               this.updateItemsSignCurrentPage();
               this.finishSVG('');
               this.setVisibleTextProperties(e);
               this._onDrag = false; // ตั้งค่าตัวแปร flag ของ drag เพื่อให้รู้ว่า drag จบแล้ว
            });
            this._objDraw.on('dragover', (e) => { // เมื่อลาก object มาวางไว้ที่หน้าเอกสารต้องเคลียร์ event ให้ไม่ขึ้นรูปห้าม drag
               e.preventDefault();
               e.stopPropagation();
            });
            this._objDraw.on('resizing', (e) => { // เมื่อทำการ resize object จะเข้า action นี้
               if (!this.isDrawing) {
                  this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
               }
               this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
            });
            this._objDraw.on('resizedone', (e) => { // เมื่อ resize จบจะเข้า action นี้
               this.updateItemsSignCurrentPage();
            });
            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.text) {
               this.setTextStyle();
            }
            if ($(this._objDraw.node).attr('fieldType') === 'comment') {
               this._objDraw.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               });
            } else if (this._objDraw.type === 'image') {
               this._objDraw.selectize({ // ให้ resize ได้เฉพาะมุมเท่านั้น โดยคง ration ให้คงเดิม
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            } else {
               this._objDraw.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
            this._objDraw.draggable(); // ตั้งค่าให้ object สามารถ drag ได้
            if (!this._isDrag) { // เช็คกรณีที่วาดรูปลงหน้าเอกสาร
               this.isDrawing = true; // ตั้งค่า flag drawing เพื่อให้รู้ว่ากำลังวาด object อยู่
            } else {
               this.calculateMove($event);
               this._isDrag = false;
               this.isDrawing = false;
               this.updateItemsSignCurrentPage();
            }
            this.startDrawing = false; // ตั้งค่า flag เพื่อให้รู้ว่าเริ่มการวาดแล้ว
            this._idSignitems = $(this._objDraw.node).attr('id'); // เก็บค่า id ของ object ล่าสุด
            this._isHideProp = false; // ตั้งค่า flag ว่าจะให้ซ่อนตัวตั้งค่า properties ไหม
            this.isHideDeleteBtn = false; // ตั้งค่า flag ว่าจะให้ซ่อนปุ่ม delete ไหม
            this._isChangeSigner = false; // ตั้งค่า flag ว่ามีการเปลี่ยน signer ไหม
            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.comment
               || $(this._objDraw.node).attr('fieldType') === this._keyFieldType.checkbox) {
               this.isHideProperties = true;
            } else {
               this.isHideProperties = false;
            }
         }
      }
   }

   /** วาดรูป object ในรูปแบบที่เป็นรูป */
   drawTypeSign(id, cb) {
      let ratio, strLen, rect, image;
      if (!this.chkApplyAll) {
         this.chkName = this.includeName;
         this.chkDate = this.includeDate;
      }
      const ratioZoom = this.getCountZoom(), pageNum = id.split('_')[1];
      const that = this;
      switch (this._fieldType) {
         case 'signature':
            this._objDraw = this._draw.image(this.getPicSign()).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
               ratio = loader.width / widthInit;
               let width = 0;
               let height = 0;
               if (that.includeName || that.includeDate) {
                  width = 100;
                  height = 25;
               }
               if (loader.height / ratio <= heightInit) {
                  this.size((widthInit + width) * ratioZoom, ((loader.height / ratio) + height) * ratioZoom);
               } else {
                  ratio = loader.height / heightInit;
                  this.size(((loader.width / ratio) + width) * ratioZoom, (heightInit + height) * ratioZoom);
               }
               cb();
            }).attr({
               fill: 'none', stroke: this.colors[0], 'stroke-width': 10, 'signer': this.service.user.email,
               'positionType': this.positionType, 'pageType': this.pageType, 'cursor': 'pointer',
               'pageNum': pageNum, 'fieldType': this._keyFieldType.signature,
               'isExists': false, 'chkName': this.chkName, 'chkDate': this.chkDate, 'stepOrder': this.taskAttribute.currentLevel, 'taskContactId': this._taskContactId
            });
            that.editSignature(that._objDraw,that.chkName,that.chkDate);
            break;
         case 'initSignature':
            this._objDraw = this._draw.image(this.getPicSignInit()).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
               ratio = loader.width / widthInitial;
               if (loader.height / ratio <= heightInitial) {
                  this.size(widthInitial * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightInitial;
                  this.size((loader.width / ratio) * ratioZoom, heightInitial * ratioZoom);
               }
               cb();
            }).attr({
               fill: 'none', stroke: this.colors[0], 'stroke-width': 10, 'signer': this.service.user.email,
               'positionType': this.positionType, 'pageType': this.pageType, 'cursor': 'pointer',
               'pageNum': pageNum, 'fieldType': this._keyFieldType.initSignature,
               'isExists': false, 'stepOrder': this.taskAttribute.currentLevel, 'taskContactId': this._taskContactId
            });
            break;
         case 'name':
            strLen = this._user.name.length;
            this._objDraw = this._draw.text(this._user.name).addClass(this._keyFieldType.name).attr({
               'signer': this.service.user.email, 'positionType': this.positionType, 'pageType': this.pageType,
               'cursor': 'pointer', 'pageNum': pageNum, 'width': this.calculateLenStrSign(this._user.name),
               'height': 13, 'fieldType': 'name', 'isExists': false, 'stepOrder': this.taskAttribute.currentLevel, 'taskContactId': this._taskContactId
            });
            this._objDraw.font({size: this._fontSize * ratioZoom, family: 'THSarabunNew'});
            break;
         case 'date':
            const day = moment().format('DD/MM/YYYY');
            strLen = day.toString().length;
            this._objDraw = this._draw.text(day).addClass(this._keyFieldType.date).attr({
               'signer': this.service.user.email, 'positionType': this.positionType, 'pageType': this.pageType,
               'cursor': 'pointer', 'pageNum': pageNum, 'width': this.calculateLenStrSign(day.toString()),
               'height': 13, 'fieldType': 'date', 'isExists': false, 'stepOrder': this.taskAttribute.currentLevel, 'taskContactId': this.taskContactId
            });
            this._objDraw.font({size: this._fontSize * ratioZoom, family: 'THSarabunNew'});
            break;
         case 'text':
            const txt = this._text;
            strLen = txt.length;
            this._objDraw = this._draw.text(txt).addClass(this._keyFieldType.text).attr({
               'signer': this.service.user.email, 'positionType': this.positionType, 'pageType': this.pageType,
               'cursor': 'pointer', 'pageNum': pageNum, 'width': this.calculateLenStrSign(txt),
               'height': 13, 'fieldType': 'text', 'isExists': false,
               'fontStyle': 'THSarabunNew',
               'fontSize': this._fontSize,
               'fontColor': '#000000',
               'fontBold': false,
               'fontItalic': false,
               'fontUnderline': false,
               'textRequired': false,
               'stepOrder': this.taskAttribute.currentLevel,
               'taskContactId': this._taskContactId
            });
            this._objDraw.font({size: this._fontSize * ratioZoom, family: 'THSarabunNew'});
            this.generateTextControl(this._objDraw, this._text);
            break;
         case 'comment':
            this._objDraw =  this._draw.image(this.picComment).loaded(function (loader) {
               ratio = loader.width / widthIconInit;
               if (loader.height / ratio <= heightIconInit) {
                  this.size(widthIconInit * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightIconInit;
                  this.size((loader.width / ratio) * ratioZoom, heightIconInit * ratioZoom);
               }
            }).addClass(this._keyFieldType.comment)
               .attr({
                  fill: 'none', stroke: this.colors[0], 'stroke-width': 10, 'signer': this.service.user.email,
                  'positionType': this.positionType, 'pageType': this.pageType, 'cursor': 'pointer',
                  'pageNum': pageNum, 'fieldType': this._keyFieldType.comment, 'stepOrder': this.taskAttribute.currentLevel, 'taskContactId': this._taskContactId
               });
            break;
         case 'image':
            rect = this._draw.rect(this._widthInitAttach * ratioZoom,
               this._heightInitAttach * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
               });
            image = this._draw.image(this.picAttachImg).loaded(function (loader) {
                  ratio = loader.width / widthAttachInit;
                  if (loader.height / ratio <= heightAttachInit) {
                     this.size(widthAttachInit * ratioZoom, (loader.height / ratio) * ratioZoom);
                  } else {
                     ratio = loader.height / heightAttachInit;
                     this.size((loader.width / ratio) * ratioZoom, heightAttachInit * ratioZoom);
                  }
               }).attr({
                  fill: 'none',
                  stroke: this.colors[0],
                  'stroke-width': 10,
                  'cursor': 'pointer',
                  'class': 'image'
               });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.image).attr({
               'positionType': this.positionType,
               'pageType': this.pageType,
               'fieldType': this._keyFieldType.image,
               'isExists': false,
               'class': 'image',
               'stepOrder': this.taskAttribute.currentLevel,
               'taskContactId': this._taskContactId
            });
            this._objDraw.attr({'signer': this.service.user.email, 'pageNum': pageNum});
            this._objDraw.add(rect);
            this._objDraw.add(image);
            break;
         case 'checkbox':
            rect = this._draw.rect(this._heightInitCheckBox * ratioZoom, this._widthInitCheckBox * ratioZoom).fill('transparent');
            const moveX = (this._widthInitCheckBox / 2) - (this._widthInitBox / 2);
            const moveY = (this._heightInitCheckBox / 2) - (this._heightInitBox / 2);
            const checkbox = this._draw.rect(this._widthInitBox * ratioZoom,
               this._heightInitBox * ratioZoom).move(moveX * ratioZoom, moveY * ratioZoom)
               .fill('transparent').stroke({ color: '#000', width: 1 });
            const flag = this._draw.image(this.picCheckBox).loaded(function (loader) {
               ratio = loader.width / that._widthInitCheck;
               if (loader.height / ratio <= that._heightInitCheck) {
                  this.size(that._widthInitCheck * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / that._heightInitCheck;
                  this.size((loader.width / ratio) * ratioZoom, that._heightInitCheck * ratioZoom);
               }
            }).attr({
               x: ((this._widthInitCheckBox / 2) - (this._widthInitCheck / 2))  * ratioZoom,
               y: ((this._heightInitCheckBox / 2) - (this._heightInitCheck / 2))  *  ratioZoom,
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer',
               'class': 'image'
            });


            this._objDraw = this._draw.group().addClass(this._keyFieldType.checkbox).attr({
               'signer': this.service.user.email,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'cursor': 'pointer',
               'pageNum': pageNum,
               'width': this._widthInitBox * ratioZoom,
               'height': this._heightInitBox * ratioZoom,
               'fieldType': this._keyFieldType.checkbox,
               'isExists': false,
               'stepOrder': this.taskAttribute.currentLevel,
               'taskContactId': this._taskContactId
            });

            this.renderCheckBox(this._objDraw, checkbox, flag);

            this._objDraw.add(rect);
            this._objDraw.add(checkbox);
            this._objDraw.add(flag);
            break;
         default:
            break;
      }
   }

    /// วาด image ขึ้นมาใหม่หลังจากมีการแก้ไขพร้อมตั้งค่าต่าง ๆ ให้กับ element
   drawAttachImage(e: any, id: string, pageSign: string){
   for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
      if(item.fieldType === 'image' && item.idSignItem === id) {
         this.startDrawing = true;
         this.setVisibleProperty(false);
         const ratioZoom = this.getCountZoom();
         let ratio = 0, maxWidth = 250, maxHeight = 250;
         this._objDraw = this._draw.image(e.target.result).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
            if (loader.width > maxWidth) { // Check if the current width is larger than the max
               ratio = maxWidth / loader.width;
               this.size(maxWidth * ratioZoom, (loader.height * ratio) * ratioZoom);
               loader.height = loader.height * ratio;
               loader.width = loader.width * ratio;
            } else if (loader.height > maxHeight) { // Check if current height is larger than max
               ratio = maxHeight / loader.height;
               this.size((loader.width * ratio) * ratioZoom, maxHeight * ratioZoom);
               loader.width = loader.width * ratio;
               loader.height = loader.height * ratio;
            }
            if (item) {
               this.move((item.coordinateX), (item.coordinateY));
            }
         }).attr({
            'signer': this.service.user.email,
            'positionType': item.positionType,
            'pageType': item.pageType,
            'certId': item.certId,
            'cursor': 'pointer',
            'pageNum': item.pageNum,
            'order': item.order,
            'orderSignPage': pageSign,
            'fieldType': item.fieldType,
            'taskSignId': item.taskSignId,
            'isExists': item.isExists,
            'class': 'image',
            'stepOrder': item.stepOrder,
            'taskContactId': item.taskContactId
         });
         this.controllAttachImage(item);
         break;
      }
   }
}

   /** วาดรูป sign ที่เป็นรูปแทนที่ sign ที่เป็น template ที่ให้คลิก */
   drawTypeSignTask(item, cb, pageSign?, x?, y?) {
      this.setVisibleProperty(false);
      const xCal = 0, ratioZoom = this.getCountZoom();
      let ratio, xNew, yNew, yCal = 0;
      let picture;
      let fieldType;
      if (item.fieldType === 'signature') {
         picture = this.getPicSign();
         fieldType = this._keyFieldType.signature;
      }
      if (item.fieldType === 'initSignature') {
         picture = this.getPicSignInit();
         fieldType = this._keyFieldType.initSignature;
      }
      this._objDraw = this._draw.image(picture).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
         let baseWidth, baseHeight, extraWidth = 0, extraHeight = 0;
         if (item.fieldType === 'signature') {
            baseWidth = widthInit;
            baseHeight = heightInit;
            if (item.chkName || item.chkDate) {
               extraWidth = 100;
               extraHeight = 25;
            }
         } else {
            baseWidth = widthInitial;
            baseHeight = heightInitial;
         }
         ratio = loader.width / baseWidth;
         if (loader.height / ratio <= baseHeight) {
            yCal = (item.fieldHeight - ((loader.height / ratio) + extraHeight));
            if (yCal < 0) { yCal = 0; }
            this.size((baseWidth + extraWidth) * ratioZoom, ((loader.height / ratio) + extraHeight) * ratioZoom);
            itemSignW = baseWidth + extraWidth;
            itemSignH = (loader.height / ratio) + extraHeight;
         } else {
            ratio = loader.height / baseHeight;
            this.size(((loader.width / ratio) + extraWidth) * ratioZoom, (baseHeight + extraHeight) * ratioZoom);
            itemSignW = (loader.width / ratio) + extraWidth;
            itemSignH = baseHeight + extraHeight;
         }
         if (item) {
            this.move((item.coordinateX + xCal) * ratioZoom, (item.coordinateY + yCal) * ratioZoom);
            xNew = item.coordinateX + xCal;
            yNew = item.coordinateY + yCal;
         } else {
            this.move((x + xCal) * ratioZoom, (y + yCal) * ratioZoom);
         }
         giveYcal = yCal;
         cb();
      }).attr({
         fill: 'none',
         stroke: this.colors[0],
         'stroke-width': 10,
         'signer': this.service.user.email,
         'positionType': item.positionType,
         'pageType': item.pageType,
         'chkName': item.chkName,
         'chkDate': item.chkDate,
         'certId': item.certId,
         'cursor': 'pointer',
         'pageNum': item.pageNum,
         'order': item.order,
         'orderSignPage': pageSign,
         'fieldType': fieldType,
         'taskSignId': item.taskSignId,
         'isExists': item.isExists,
         'stepOrder': item.stepOrder,
         'taskContactId': item.taskContactId
      });
      if (item.fieldType === 'signature') {
         let chkName, chkDate;
         if (!this.chkApplyAll) {
            chkName = this._objDraw.attr('chkName') === 'true';
            chkDate = this._objDraw.attr('chkDate') === 'true';
         } else {
            chkName = this.chkName;
            chkDate = this.chkDate;
            this._objDraw.attr('chkName', chkName);
            this._objDraw.attr('chkDate', chkDate);
         }
         this.editSignature(this._objDraw,chkName,chkDate);
      }
   }

   /** วาดรูป object sign ที่เป็นรูปกรณีนี้ที่เมื่อกดคลิกที่เป็น template ให้ sign แล้วคลิกเปลี่ยนเอกสารไปมา */
   drawTypeSignTaskInit(item, numIndex, x?, y?) {
      this.setVisibleProperty(false);
      const pageSign = item.pageNum + '_' + numIndex, ratioZoom = this.getCountZoom();
      let ratio;
      let picture;
      if (item.fieldType === 'signature') {
         picture = this.getPicSign();
      }
      if (item.fieldType === 'initSignature') {
         picture = this.getPicSignInit();
      }
      if (item.fieldType === 'image') {
         picture = this.picAttachImg;
      }
      this._objDraw = this._draw.image(picture).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
         if (item.fieldType === 'signature') {
            ratio = loader.width / widthInit;
         }
         if (item.fieldType === 'initSignature') {
            ratio = loader.width / widthInitial;
         }
         if (item.fieldType === 'image') {
            ratio = loader.width / widthAttachInit;
         }
         if (loader.height / ratio <= heightInit && item.fieldType === 'signature') {
            this.size(widthInit * ratioZoom, (loader.height / ratio) * ratioZoom);
         } else if (loader.height / ratio <= heightInitial && item.fieldType === 'initSignature') {
            this.size(widthInitial * ratioZoom, (loader.height / ratio) * ratioZoom);
         } else if (loader.height / ratio <= heightAttachInit && item.fieldType === 'image') {
            this.size(widthAttachInit * ratioZoom, (loader.height / ratio) * ratioZoom);
         } else {
            ratio = loader.height / heightInit;
            this.size((loader.width / ratio) * ratioZoom, heightInit * ratioZoom);
         }
         if (item) {
            this.move(item.coordinateX * ratioZoom, item.coordinateY * ratioZoom);
            let extraW = 0;
            let extraH = 0;
            if (item.fieldType === 'signature' && (item.chkName || item.chkDate)) {
               extraW = 100;
               extraH = 25;
            }
            if (item.fieldType === 'signature') {
               ratio = loader.width / widthInit;
               if (loader.height / ratio <= heightInit) {
                  this.size((widthInit + extraW) * ratioZoom, ((loader.height / ratio) + extraH) * ratioZoom);
               } else {
                  ratio = loader.height / heightInit;
                  this.size(((loader.width / ratio) + extraW) * ratioZoom, (heightInit + extraH) * ratioZoom);
               }
            } else if (item.fieldType === 'initSignature') {
               ratio = loader.width / widthInitial;
               if (loader.height / ratio <= heightInitial) {
                  this.size(widthInitial * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightInitial;
                  this.size((loader.width / ratio) * ratioZoom, heightInitial * ratioZoom);
               }
            } else if (item.fieldType === 'image') {
               ratio = loader.width / widthAttachInit;
               if (loader.height / ratio <= heightAttachInit) {
                  this.size(item.fieldWidth * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / item.fieldHeight;
                  this.size((loader.width / ratio) * ratioZoom, item.fieldHeight * ratioZoom);
               }
            }
         } else {
            this.move(x * ratioZoom, y * ratioZoom);
         }
      });
      if (item.order !== undefined && item.order > 0) {
         this._objDraw.attr({
            fill: 'none', stroke: this.colors[0], 'stroke-width': 10, 'signer': this.service.user.email,
            'positionType': item.positionType, 'pageType': item.pageType, 'cursor': 'pointer', 'pageNum': item.pageNum,
            'order': item.order, 'orderSignPage': pageSign, 'isExists': item.isExists, 'taskSignId': item.taskSignId, 'fieldType': item.fieldType,
            'chkName': item.chkName, 'chkDate': item.chkDate, 'stepOrder': item.stepOrder, 'taskContactId': item.taskContactId
         });
      } else {
         this._objDraw.attr({
            fill: 'none', stroke: this.colors[0], 'stroke-width': 10, 'signer': this.service.user.email,
            'positionType': item.positionType, 'pageType': item.pageType, 'cursor': 'pointer', 'pageNum': item.pageNum,
            'order': item.order, 'isExists': item.isExists, 'taskSignId': item.taskSignId, 'fieldType': item.fieldType,
            'chkName': item.chkName, 'chkDate': item.chkDate, 'stepOrder': item.stepOrder, 'taskContactId': item.taskContactId
         });
      }
      if (item.fieldType === 'signature') {
         let chkName, chkDate;
         if (!this.chkApplyAll) {
            chkName = this._objDraw.attr('chkName') === 'true';
            chkDate = this._objDraw.attr('chkDate') === 'true';
         } else {
            chkName = this.chkName;
            chkDate = this.chkDate;
            this._objDraw.attr('chkName', chkName);
            this._objDraw.attr('chkDate', chkDate);
         }
         this.editSignature(this._objDraw,chkName,chkDate);
      }
   }

   /** วาดรูปค่าตั้งต้นเป็นรูปปกติ */
   initialTypeSign(item, numIndex, id?) {
      let x, newX, strLen;
      const pageSign = item.pageNum + '_' + numIndex;
      const that = this;
      switch (item.fieldType) {
         case 'signature':
            this._objDraw = this._draw.image(this.getPicSign(), item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom())
               .attr({
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'pageNum': item.pageNum,
                  'orderSignPage': pageSign,
                  'chkName': item.chkName,
                  'chkDate': item.chkDate,
                  'certId': item.certId,
                  'fieldType': this._keyFieldType.signature,
                  'taskSignId': item.taskSignId,
                  'isExists': item.isExists,
                  'width': item.fieldWidth * this.getCountZoom(),
                  'height': item.fieldHeight * this.getCountZoom(),
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
            this._objDraw.fill(this.colors[this.signerSelected.index]);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'initSignature':
            this._objDraw = this._draw.image(this.getPicSignInit(), item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom())
               .attr({
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'pageNum': item.pageNum,
                  'orderSignPage': pageSign,
                  'chkName': item.chkName,
                  'chkDate': item.chkDate,
                  'certId': item.certId,
                  'fieldType': this._keyFieldType.initSignature,
                  'taskSignId': item.taskSignId,
                  'isExists': item.isExists,
                  'width': item.fieldWidth * this.getCountZoom(),
                  'height': item.fieldHeight * this.getCountZoom(),
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
            this._objDraw.fill(this.colors[this.signerSelected.index]);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'name':
            strLen = this._user.name.length;
            x = (this.calculateCoordinateX(item.coordinateX, this._user.name, id)) * this.getCountZoom();
            newX = item.coordinateX * this.getCountZoom() - x;
            this._objDraw = this._draw.text(this._user.name).addClass(this._keyFieldType.name)
               .attr({
                  'signer': this.service.user.email,
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'cursor': 'pointer',
                  'pageNum': item.pageNum,
                  'newX': x,
                  'width': this.calculateLenStrSign(this._user.name),
                  'height': 13,
                  'orderSignPage': pageSign,
                  'fieldType': this._keyFieldType.name,
                  'taskSignId': item.taskSignId,
                  'isExists': item.isExists,
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
            this._objDraw.font({size: this._fontSize * this.getCountZoom(), family: 'THSarabunNew'});
            this._objDraw.x(newX);
            if (this._isHaveThai && (item.positionType === 'TR' || item.positionType === 'TL')) {
               item.coordinateY += 3;
            }
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            item.flagSign = true;
            break;
         case 'date':
            const day = moment().format('DD/MM/YYYY');
            strLen = day.toString().length;
            x = (this.calculateCoordinateX(item.coordinateX, day.toString(), id)) * this.getCountZoom();
            newX = item.coordinateX * this.getCountZoom() - x;
            this._objDraw = this._draw.text(day).addClass(this._keyFieldType.date)
               .attr({
                  'signer': this.service.user.email,
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'cursor': 'pointer',
                  'pageNum': item.pageNum,
                  'newX': x,
                  'width': this.calculateLenStrSign(day.toString()),
                  'height': 13,
                  'orderSignPage': pageSign,
                  'fieldType': this._keyFieldType.date,
                  'taskSignId': item.taskSignId,
                  'isExists': item.isExists,
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
            this._objDraw.font({size: this._fontSize * this.getCountZoom(), family: 'THSarabunNew'});
            this._objDraw.x(newX);
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            item.flagSign = true;
            break;
         case 'text':
            let txt = '';
            if (item.content) {
               txt = item.content;
            } else {
               txt = this._text;
            }
            strLen = txt.length;
            let order = null;
            if(item.textRequired){ /// Set in order if Text required
               order = item.order;
            }
            x = (this.calculateCoordinateX(item.coordinateX, txt, id)) * this.getCountZoom();
            newX = item.coordinateX * this.getCountZoom() - x;
            this._objDraw = this._draw.text(txt).addClass(this._keyFieldType.text)
               .attr({
                  'signer': this.service.user.email,
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'cursor': 'pointer',
                  'pageNum': item.pageNum,
                  'newX': x,
                  'width': this.calculateLenStrSign(txt),
                  'height': 13,
                  'orderSignPage': pageSign,
                  'fieldType': this._keyFieldType.text,
                  'taskSignId': item.taskSignId,
                  'isExists': item.isExists,
                  'fontStyle': item.fontStyle,
                  'fontSize': Number(item.fontSize),
                  'fontColor': item.fontColor,
                  'fontBold': item.fontBold,
                  'fontItalic': item.fontItalic,
                  'fontUnderline': item.fontUnderline,
                  'textRequired': item.textRequired,
                  'order': order,
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
            this._objDraw.font({size: item.fontSize * this.getCountZoom(), family: item.fontStyle});
            this.generateTextControl(this._objDraw, this._text);
            this._objDraw.x(newX);
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            item.flagSign = true;
            break;
         case 'comment' :
            this._objDraw = this._draw.image(this.picComment, item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom()).addClass(this._keyFieldType.comment)
               .attr({
                  'signer': item.signer.toLowerCase(),
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'cursor': 'pointer',
                  'pageNum': item.pageNum,
                  'width': this._widthInitIcon * this.getCountZoom(),
                  'height': this._heightInitIcon * this.getCountZoom(),
                  'orderSignPage': pageSign,
                  'fieldType': this._keyFieldType.comment,
                  'isExists': item.isExists,
                  'taskSignId': item.taskSignId,
                  'comment': JSON.stringify(item.comment),
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            item.flagSign = true;
            this.drawCommentBox(item, this._objDraw, item.coordinateY * this.getCountZoom());
            break;
         case 'image' :
            if(item.idImageItem && item.idImageItem !== this.picAttachImg){
               this._objDraw = this._draw.image(this.getImageContent(item.idImageItem), item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom())
               .addClass(this._keyFieldType.image).attr({
                  'signer': item.signer.toLowerCase(),
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'cursor': 'pointer',
                  'pageNum': item.pageNum,
                  'width': item.fieldWidth * this.getCountZoom(),
                  'height': item.fieldHeight * this.getCountZoom(),
                  'orderSignPage': pageSign,
                  'fieldType': this._keyFieldType.image,
                  'isExists': item.isExists,
                  'taskSignId': item.taskSignId,
                  'cerId': item.certId,
                  'order': item.order,
                  'class': 'image',
                  'ref': item.idImageItem,
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
               this._objDraw.x(item.coordinateX * this.getCountZoom());
               this._objDraw.y(item.coordinateY * this.getCountZoom());
               break;
            } else {
               let newX = item.coordinateX * this.getCountZoom();
               let newY = item.coordinateY * this.getCountZoom();
               let rect = this._draw.rect(this._widthInitAttach * this.getCountZoom(),
               this._heightInitAttach * this.getCountZoom()).fill(this.colors[0]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
               });
               let image = this._draw.image(this.picAttachImg, widthAttachInit * this.getCountZoom(), heightAttachInit * this.getCountZoom())
               .attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
               });

               this._objDraw = this._draw.group().addClass(this._keyFieldType.image);
               this._objDraw.attr({
                  'signer': item.signer.toLowerCase(),
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'pageNum': item.pageNum,
                  'orderSignPage': pageSign,
                  'fieldType': this._keyFieldType.image,
                  'isExists': item.isExists,
                  'taskSignId': item.taskSignId,
                  'cerId': item.certId,
                  'order': item.order,
                  'class': 'image',
                  x: newX,
                  y: newY,
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
               this._objDraw.x(item.coordinateX * this.getCountZoom());
               this._objDraw.y(item.coordinateY * this.getCountZoom());
               this._objDraw.add(rect);
               this._objDraw.add(image);
            break;
            }
         case 'checkbox':
            const rect = this._draw.rect(this._heightInitCheckBox * this.getCountZoom(),
               this._widthInitCheckBox * this.getCountZoom()).fill('transparent');
            const moveX = (this._widthInitCheckBox / 2) - (this._widthInitBox / 2);
            const moveY = (this._heightInitCheckBox / 2) - (this._heightInitBox / 2);
            const checkbox = this._draw.rect(this._widthInitBox * this.getCountZoom(),
               this._heightInitBox * this.getCountZoom()).move(moveX * this.getCountZoom(), moveY * this.getCountZoom())
               .fill('transparent').stroke({ color: '#000', width: 1 });
            const flag = this._draw.image(this.picCheckBox, this._widthInitCheck * this.getCountZoom(), this._heightInitCheck * this.getCountZoom())
               .attr({
                  x: ((this._widthInitCheckBox / 2) - (this._widthInitCheck / 2)) * this.getCountZoom(),
                  y: ((this._heightInitCheckBox / 2) - (this._heightInitCheck / 2)) * this.getCountZoom(),
                  fill: 'none',
                  stroke: this.colors[0],
                  'stroke-width': 10,
                  'cursor': 'pointer',
                  'class': 'image'
               });


            this._objDraw = this._draw.group().addClass(this._keyFieldType.checkbox);
            this._objDraw.attr({
               'signer': item.signer.toLowerCase(),
               'positionType': item.positionType,
               'pageType': item.pageType,
               'cursor': 'pointer',
               'pageNum': item.pageNum,
               'width': this._widthInitBox * this.getCountZoom(),
               'height': this._heightInitBox * this.getCountZoom(),
               'orderSignPage': pageSign,
               'fieldType': this._keyFieldType.checkbox,
               'isExists': item.isExists,
               'taskSignId': item.taskSignId,
               'flagCheckbox': item.flagCheckbox,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            item.flagSign = true;
            this.renderCheckBox(this._objDraw, checkbox, flag);

            this._objDraw.add(rect);
            this._objDraw.add(checkbox);
            this._objDraw.add(flag);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         default:
            break;
      }
   }

   /** วาดรูปค่าตั้งต้นเป็น template ให้กด sign */
   initialTypeNotSign(item, numIndex, itemIndex) {
      let rect, text, image, indexColor, ratio;
      const pageSign = item.pageNum + '_' + numIndex;
      const that = this;
      if (item.fieldType !== this._keyFieldType.comment) {
         indexColor = this.setIndexColorDocList(item);
      }
      switch (item.fieldType) {
         case 'signature':
            if (this.includeDate || this.includeName) {
               if(!(item.chkDate || item.chkName)){//check add width chkDate or chkName not add more
                  item.fieldWidth = item.fieldWidth + 50;
               }
               item.chkDate = this.includeDate;
               item.chkName = this.includeName;
            }
            rect = this._draw.rect(item.fieldWidth* this.getCountZoom(), item.fieldHeight * this.getCountZoom())
               .fill(this.colors[indexColor])
               .attr({opacity: 0.5, 'cursor': 'pointer'});
            image = this._draw.image(this.picSignature, item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom()).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.signature);
            this._objDraw.attr({
               'signer': this.service.user.email,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'orderSignPage': pageSign,
               'chkName': item.chkName,
               'chkDate': item.chkDate,
               'certId': item.certId,
               x: item.coordinateX * this.getCountZoom(),
               y: item.coordinateY * this.getCountZoom(),
               'order': item.order,
               'pageNum': item.pageNum,
               'itemIndex': itemIndex,
               'fieldType': this._keyFieldType.signature,
               'taskSignId': item.taskSignId,
               'isExists': item.isExists,
               'width': item.fieldWidth * this.getCountZoom(),
               'height': item.fieldHeight * this.getCountZoom(),
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'initSignature':
            rect = this._draw.rect(item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom())
               .fill(this.colors[indexColor])
               .attr({opacity: 0.5, 'cursor': 'pointer'});
            image = this._draw.image(this.picInitSignature, item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom()).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.initSignature);
            this._objDraw.attr({
               'signer': this.service.user.email,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'orderSignPage': pageSign,
               'chkName': item.chkName,
               'chkDate': item.chkDate,
               'certId': item.certId,
               x: item.coordinateX * this.getCountZoom(),
               y: item.coordinateY * this.getCountZoom(),
               'order': item.order,
               'pageNum': item.pageNum,
               'itemIndex': itemIndex,
               'fieldType': this._keyFieldType.initSignature,
               'taskSignId': item.taskSignId,
               'isExists': item.isExists,
               'width': item.fieldWidth * this.getCountZoom(),
               'height': item.fieldHeight * this.getCountZoom(),
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'name':
            rect = this._draw.rect(this._widthInitName * this.getCountZoom(), this._heightInitNameDate * this.getCountZoom())
               .fill(this.colors[indexColor])
               .attr({opacity: 0.5, 'cursor': 'pointer'});
            text = this._draw.text(this._fullName)
               .attr({x: 0, y: this._y * this.getCountZoom(), 'font-weight': 'bold', 'cursor': 'pointer'})
               .font({size: this._fontSize * this.getCountZoom()});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.name);
            this._objDraw.attr({
               'signer': this.service.user.email, 'positionType': item.positionType, 'pageType': item.pageType,
               'pageNum': item.pageNum, 'orderSignPage': pageSign, 'fieldType': this._keyFieldType.name,
               'taskSignId': item.taskSignId, 'isExists': item.isExists, 'stepOrder': item.stepOrder, 'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'date':
            rect = this._draw.rect(this._widthInitDate * this.getCountZoom(), this._heightInitNameDate * this.getCountZoom())
               .fill(this.colors[indexColor])
               .attr({opacity: 0.5, 'cursor': 'pointer'});
            text = this._draw.text(this._date).attr({
               x: 0,
               y: this._y * this.getCountZoom(),
               'font-weight': 'bold',
               'cursor': 'pointer'
            })
               .font({size: this._fontSize * this.getCountZoom()});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.date);
            this._objDraw.attr({
               'signer': this.service.user.email, 'positionType': item.positionType, 'pageType': item.pageType,
               'pageNum': item.pageNum, 'orderSignPage': pageSign, 'fieldType': this._keyFieldType.date,
               'taskSignId': item.taskSignId, 'isExists': item.isExists, 'stepOrder': item.stepOrder, 'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'text':
            rect = this._draw.rect(this._widthInitTextarea * this.getCountZoom(),
               this._heightInitTextarea * this.getCountZoom()).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            let txtValue = '';
            if (item.content) {
               txtValue = item.content;
            } else {
               txtValue = this._text;
            }
            text = this._draw.text(txtValue).attr({
               x: 0,
               y: this._y * this.getCountZoom(),
               'font-weight': 'bold',
               'cursor': 'pointer'
            }).font({size: this._fontSize * this.getCountZoom()});
            let order = null;
            if (item.textRequired) { /// Set in order if Text required
               order = item.order;
            }
            this._objDraw = this._draw.group().addClass(this._keyFieldType.text);
            this._objDraw.attr({
               'signer': item.signer.toLowerCase(),
               'positionType': item.positionType,
               'pageType': item.pageType,
               'orderSignPage': pageSign,
               'pageNum': item.pageNum,
               'fieldType': this._keyFieldType.text,
               'taskSignId': item.taskSignId,
               'isExists': item.isExists,
               'fontStyle': item.fontStyle,
               'fontSize': Number(item.fontSize),
               'fontColor': item.fontColor,
               'fontBold': item.fontBold,
               'fontItalic': item.fontItalic,
               'fontUnderline': item.fontUnderline,
               'textRequired': item.textRequired,
               'order': order,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this.generateTextControl(this._objDraw, this._text);

            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'comment' :
            rect = this._draw.rect(this._widthInitIcon * this.getCountZoom(),
               this._heightInitIcon * this.getCountZoom()).fill(this.colors[indexColor]).attr({
               opacity: 0,
               'cursor': 'pointer'
            });
            image = this._draw.image(this.picComment, item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom())
               .attr({
                  fill: 'none',
                  stroke: this.colors[0],
                  'stroke-width': 10,
                  'cursor': 'pointer',
               });

            this._objDraw = this._draw.group().addClass(this._keyFieldType.comment);
            this._objDraw.attr({
               'signer': item.signer.toLowerCase(),
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'orderSignPage': pageSign,
               'fieldType': this._keyFieldType.comment,
               'isExists': item.isExists,
               'taskSignId': item.taskSignId,
               'comment': JSON.stringify(item.comment),
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            this.drawCommentBox(item, this._objDraw, item.setCoordinateY);
            break;
         case 'image' :
            rect = this._draw.rect(this._widthInitAttach * this.getCountZoom(),
            this._heightInitAttach * this.getCountZoom()).fill(this.colors[0]).attr({
            opacity: 0.5,
            'cursor': 'pointer'
            });
            image = this._draw.image(this.picAttachImg, widthAttachInit * this.getCountZoom(), heightAttachInit * this.getCountZoom())
            .attr({
            fill: 'none',
            stroke: this.colors[0],
            'stroke-width': 10,
            'cursor': 'pointer'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.image);
            this._objDraw.attr({
               'signer': item.signer.toLowerCase(),
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'orderSignPage': pageSign,
               'fieldType': this._keyFieldType.image,
               'isExists': item.isExists,
               'taskSignId': item.taskSignId,
               'class': 'image',
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());
            break;
         case 'checkbox':
            rect = this._draw.rect(this._heightInitCheckBox * this.getCountZoom(),
               this._widthInitCheckBox * this.getCountZoom()).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer',
            });
            const moveX = (this._widthInitCheckBox / 2) - (this._widthInitBox / 2);
            const moveY = (this._heightInitCheckBox / 2) - (this._heightInitBox / 2);
            const checkbox = this._draw.rect(this._widthInitBox * this.getCountZoom(),
               this._heightInitBox * this.getCountZoom()).move(moveX * this.getCountZoom(), moveY * this.getCountZoom())
               .fill('transparent').stroke({ color: '#000', width: 1 });
            const flag = this._draw.image(this.picCheckBox).loaded(function (loader) {
               ratio = loader.width / that._widthInitCheck;
               if (loader.height / ratio <= that._heightInitCheck) {
                  this.size(that._widthInitCheck * this.getCountZoom(), (loader.height / ratio) * this.getCountZoom());
               } else {
                  ratio = loader.height / that._heightInitCheck;
                  this.size((loader.width / ratio) * this.getCountZoom(), that._heightInitCheck * this.getCountZoom());
               }
            }).attr({
               x: ((this._widthInitCheckBox / 2) - (this._widthInitCheck / 2)) * this.getCountZoom(),
               y: ((this._heightInitCheckBox / 2) - (this._heightInitCheck / 2)) * this.getCountZoom(),
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer',
               'class': 'image'
            });


            this._objDraw = this._draw.group().addClass(this._keyFieldType.checkbox);
            this._objDraw.attr({
               'signer': item.signer.toLowerCase(),
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'orderSignPage': pageSign,
               'fieldType': this._keyFieldType.checkbox,
               'isExists': item.isExists,
               'taskSignId': item.taskSignId,
               'flagCheckbox': item.flagCheckbox,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });

            this.renderCheckBox(this._objDraw, checkbox, flag);

            this._objDraw.add(rect);
            this._objDraw.add(checkbox);
            this._objDraw.add(flag);
            this._objDraw.x(item.coordinateX * this.getCountZoom());
            this._objDraw.y(item.coordinateY * this.getCountZoom());

            break;
         default:
            break;
      }
   }

   getImageContent(id){
      if(id !== this.picAttachImg){
         return this.service.url + '/share-public/content?id=' + id;
      } else {
         return this.picAttachImg;
      }
   }

   /** ตั้งค่า event เริ่มต้นให้กับ object sign ที่ยังไม่ได้กด */
   initialSignDraw(item, numIndex, id?) {
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (id === object.id) {
               this._draw = object.svg;
               break;
            }
         }
      }
      this.drawTypeSignTaskInit(item, numIndex);
      this._objDraw.on('beforedrag', (e) => {
         if (item.isExists) {
            this.isHideDeleteBtn = item.isExists;
            this.isHideProperties = item.isExists;
            this.setVisibleProperty(!item.isExists);
            this._isHideProp = item.isExists;
         } else {
            this.isHideDeleteBtn = false;
            this._isHideProp = false;
            if (item.fieldType === this._keyFieldType.comment
               || item.fieldType === this._keyFieldType.checkbox) {
               this.isHideProperties = true;
            } else {
               this.isHideProperties = false;
            }
         }
         this.handleChangeTab();
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = e.target;
         const idTarget = $(e.target).attr('id');
         this.deselectAllWithOutMatchId(idTarget);
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (signItem.idSignItem === idTarget) {
                  this.setProperties(signItem, idTarget);
                  const index = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail.toLowerCase() === signItem.signer.toLowerCase() || data.reassignEmail.toLowerCase() === signItem.signer.toLowerCase());
                  this.leftPanelComp.toolsComp.selected = index;
               }
            }
         }
      });
      this._objDraw.on('beforedrag', function (e) {
         if (typeName === 'sign') {
            this.attr({'cursor': 'move'});
         } else {
            this.attr({'cursor': 'move'});
            if (this.type !== 'image') {
               this.children()[0].attr({'cursor': 'move'});
               this.children()[1].attr({'cursor': 'move'});
            }
         }
         this.selectize({
            points: false,
            rotationPoint: false
         });
      });
      this._objDraw.on('dragstart.namespace', (e) => {
         this.setVisibleTextProperties(e);
         if (this._draw) {
            for (const itemDraw of this._draw.children()) {
               if (itemDraw.type !== 'g') {
                  itemDraw.selectize(false);
               }
            }
         }
         this._onDrag = true;
         onDrag = true;
         this._objectDrag = e.target;
      });
      this._objDraw.on('dragmove.namespace', function (e) { // need to calculdate diffent Y
         if (changeImage) {
            e.preventDefault();
            this.move(e.detail.event.offsetX, e.detail.event.offsetY);
         }
      });
      this._objDraw.on('dragend.namespace', function (e) {
         if (typeName === 'sign') {
            this.attr({'cursor': 'pointer'});
            if (this.type === 'image') {
               this.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            } else {
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
         } else {
            this.attr({'cursor': 'pointer'});
            if (this.type !== 'image') {
               this.children()[0].attr({'cursor': 'pointer'});
               this.children()[1].attr({'cursor': 'pointer'});
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            } else {
               this.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            }
         }
         changeImage = false;
         onDrag = false;
      });
      this._objDraw.on('dragend.namespace', (e) => {
         this.checkImgFocus(e);
         this.setVisibleTextProperties(e);
         this.calculateOutBoundItem(e);
         this.updateItemsSignCurrentPage();
         this.isDrawing = false;
         this.finishSVG('');
         this._onDrag = false;
      });
      this._objDraw.on('resizedone', (e) => {
         this.updateItemsSignCurrentPage();
      });
      this._objDraw.draggable();
      this.startDrawing = false;
      item.idSignItem = this._objDraw.attr('id');
   }

   setIndexColorDocList(item) {
      const indexColor = 0;
      return indexColor;
   }

   /** ตั้งค่าผูก event ต่างๆใหม่หลังจากที่คลิก object sign ที่เป็น template มาให้คลิก */
   handleClickSignDraw(item, $event) {
      return new Observable((observer) => {
         let orderSignIndex;
         const index = this.findIndexById(item.idSignItem);
         if (index !== -1) {
            this.taskAttribute.docList[this.currentIndex].signItems[index].flagSign = true;
         }
         const id = this.checkImgFocus($event);
         if (this._objectSVG) {
            for (const object of this._objectSVG) {
               if (id === object.id) {
                  this._draw = object.svg;
                  break;
               }
            }
         }
         this.setInitialPageType();
         this.setInitialPositionType();
         if ($($event.currentTarget).attr('orderSignPage')) {
            orderSignIndex = $($event.currentTarget).attr('orderSignPage');
         }
         this.drawTypeSignTask(item, () => {
            this.updateItemsSignCurrentPage();
            observer.complete();
         }, orderSignIndex);
         this._objDraw.on('beforedrag', (e) => {
            this.isHideDeleteBtn = true;
            this.setVisibleTextProperties(e);
            if (item.fieldType !== this._keyFieldType.text && item.fieldType !== this._keyFieldType.comment) {
               this.setVisibleProperty(true);
            }
            this.handleChangeTab();
            if (!this.isDrawing) {
               this._objDraw = '';
            }
            this._objectDrag = e.target;
            const idTarget = $(e.target).attr('id');
            this.deselectAllWithOutMatchId(idTarget);
            if (this.taskAttribute.docList[this.currentIndex].signItems) {
               for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
                  if (signItem.idSignItem === idTarget) {
                     this.setProperties(signItem, idTarget);
                     const indexSinger = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail.toLowerCase() === signItem.signer.toLowerCase() || data.reassignEmail.toLowerCase() === signItem.signer.toLowerCase());
                     this.leftPanelComp.toolsComp.selected = indexSinger;
                  }
               }
            }
         });
         this._objDraw.on('beforedrag', function (e) {
            if (typeName === 'sign') {
               this.attr({'cursor': 'move'});
            } else {
               this.attr({'cursor': 'move'});
               if (this.type !== 'image') {
                  this.children()[0].attr({'cursor': 'move'});
                  this.children()[1].attr({'cursor': 'move'});
               }
            }
            this.selectize({
               points: false,
               rotationPoint: false
            });
         });
         this._objDraw.on('dragstart.namespace', (e) => {
            if (this._draw) {
               for (const itemDraw of this._draw.children()) {
                  if (itemDraw.type !== 'g') {
                     itemDraw.selectize(false);
                  }
               }
            }
            this._onDrag = true;
            onDrag = true;
            this._objectDrag = e.target;
         });
         this._objDraw.on('dragmove.namespace', function (e) { // need to calculdate diffent Y
            if (changeImage) {
               e.preventDefault();
               this.move(e.detail.event.offsetX, e.detail.event.offsetY);
            }
         });
         this._objDraw.on('dragend.namespace', function (e) {
            if (typeName === 'sign') {
               this.attr({'cursor': 'pointer'});
               if (this.type === 'image') {
                  this.selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  }).resize({saveAspectRatio: true});
               } else {
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
            } else {
               this.attr({'cursor': 'pointer'});
               if (this.type !== 'image') {
                  this.children()[0].attr({'cursor': 'pointer'});
                  this.children()[1].attr({'cursor': 'pointer'});
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               } else {
                  this.selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  }).resize({saveAspectRatio: true});
               }
            }
            changeImage = false;
            onDrag = false;
         });
         this._objDraw.on('dragend.namespace', (e) => {
            this.setVisibleTextProperties(e);
            this.calculateOutBoundItem(e);
            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.text) {
               this.setTextStyle();
            }
            this.updateItemsSignCurrentPage();
            this.isDrawing = false;
            this.finishSVG('');
            this._onDrag = false;
         });
         this._objDraw.on('resizedone', (e) => {
            this.updateItemsSignCurrentPage();
         });

         if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.text) {
            this.setTextStyle();
         }
         this._objDraw.draggable();
         this.startDrawing = false;
         this._idSignitems = $(this._objDraw.node).attr('id');
         this._isHideProp = true;
         this._objDraw = '';
         observer.next();
      });
   }

   setVisibleTextProperties(e) {
      const fieldType = $(e.target).attr('fieldType');
      if (fieldType === this._keyFieldType.comment
         || fieldType === this._keyFieldType.checkbox) {
         this.isHideProperties = true;
      } else {
         this.setVisibleProperty(true);
         this._isHideProp = false;
         this.isHideProperties = false;
      }
   }

   /** หา id ที่รูปที่เลือกอยู่ focus ไว้ */
   checkImgFocus($event) {
      this._imgFocus = $event;
      let id, imgTarget;
      if (this._imgFocus.target.parentNode.className !== 'imageSign') {
         imgTarget = this.findImageParent(this._imgFocus.target);
         id = imgTarget.parentNode.id;
         this._imgFocusCal = imgTarget;
      } else {
         id = this._imgFocus.target.parentNode.id;
         this._imgFocusCal = this._imgFocus.target;
      }
      return id;
   }

   /** เคลื่อนที่ของรูป object */
   moveSVG($event) {
      if (this.isDrawing) {
         if (this.isDrawing) {
            this._moveOnPage = true;
            this.calculateMove($event);
         }
      }
      if (this._onDrag) {
         const $objectDrag = $(this._objectDrag);
         const id = $objectDrag.attr('id');
         $objectDrag.attr('positionType', 'CT');
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.idSignItem === id) {
                  this.setInitialPositionType();
                  break;
               }
            }
         }
      }
   }

   /** คำนวณเคลื่อนที่ของรูป object มีการตรวจสอบว่าชิดขอบหรือไม่ชิดขอบ */
   calculateMove($event) {
      const id = this._imgFocusCal.parentNode.id;
      const h = this.calculatePageHeightMargin(id);
      const type = $(this._objDraw.node).attr('fieldType');
      const width = $(this._objDraw.node).attr('width');
      const height = $(this._objDraw.node).attr('height');
      const calDiffMaxWidth = (this.maxWidth * this.getCountZoom() - this._imgFocusCal.width.baseVal.value) / 2;
      const realX = $event.layerX - calDiffMaxWidth;
      let difX, difY, inBoundX, inBoundY;
      const borderWidth = 10 * this.getCountZoom();
      const borderHeight = 5 * this.getCountZoom();
      if (type === 'signature' || type === 'initSignature') {
         difX = (width / 2);
         difY = (height / 2);
         inBoundX = (width / 2);
         inBoundY = (height / 2);
         if ($event.layerY + inBoundY < this._imgFocusCal.height.baseVal.value + h
            && realX + inBoundX < this._imgFocusCal.width.baseVal.value && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX - borderWidth, $event.layerY - h - borderHeight);
         } else {
            if ($event.layerY + difY >= this._imgFocusCal.height.baseVal.value + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= this._imgFocusCal.width.baseVal.value) {
                     this._objDraw.center(realX, this._imgFocusCal.height.baseVal.value - difY);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, this._imgFocusCal.height.baseVal.value - difY);
                  }
               } else {
                  this._objDraw.center(difX, this._imgFocusCal.height.baseVal.value - difY);
               }
            } else if (realX + difX >= this._imgFocusCal.width.baseVal.value) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= this._imgFocusCal.height.baseVal.value + h) {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
                  }
               } else {
                  this._objDraw.center(this._imgFocus.target.width.baseVal.value - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {
                  this._objDraw.center(difX, $event.layerY - h);
               } else {
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) {
               this._objDraw.center(realX, difY);
            }
         }
      } else if (type === 'image') {
         let width = $($(this._objDraw.node).children()[0]).attr('width');
         let height = $($(this._objDraw.node).children()[0]).attr('height');
         difX = width / 2 * this.getCountZoom();
         difY = height / 2 * this.getCountZoom();
         inBoundX = width / 2 * this.getCountZoom();
         inBoundY = height / 2 * this.getCountZoom();
         if ($event.layerY + inBoundY < this._imgFocusCal.height.baseVal.value  + h && realX +
            inBoundX < this._imgFocusCal.width.baseVal.value && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX, $event.layerY - h);
         } else {
            if ($event.layerY + difY >= this._imgFocusCal.height.baseVal.value + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= this._imgFocusCal.width.baseVal.value) {
                     this._objDraw.center(realX, this._imgFocusCal.height.baseVal.value - difY);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, this._imgFocusCal.height.baseVal.value - difY);
                  }
               } else {
                  this._objDraw.center(difX, this._imgFocusCal.height.baseVal.value - difY);
               }
            } else if (realX + difX >= this._imgFocusCal.width.baseVal.value) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= this._imgFocusCal.height.baseVal.value + h) {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
                  }
               } else {
                  this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {
                  this._objDraw.center(difX, $event.layerY - h);
               } else {
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) {
               this._objDraw.center(realX, difY);
            }
         }
      } else {
         difX = width / 2 * this.getCountZoom();
         difY = 10 * this.getCountZoom();
         inBoundX = width / 2 * this.getCountZoom();
         inBoundY = 10 * this.getCountZoom();
         if ($event.layerY + inBoundY < this._imgFocusCal.height.baseVal.value + h
            && realX + inBoundX < this._imgFocusCal.width.baseVal.value && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX, $event.layerY - h);
         } else {
            if ($event.layerY + difY >= this._imgFocusCal.height.baseVal.value + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= this._imgFocusCal.width.baseVal.value) {
                     this._objDraw.center(realX, this._imgFocusCal.height.baseVal.value - difY);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, this._imgFocusCal.height.baseVal.value - difY);
                  }
               } else {
                  this._objDraw.center(difX, this._imgFocusCal.height.baseVal.value - difY);
               }
            } else if (realX + difX >= this._imgFocusCal.width.baseVal.value) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= this._imgFocusCal.height.baseVal.value + h) {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
                  }
               } else {
                  this._objDraw.center(this._imgFocus.target.width.baseVal.value - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {
                  this._objDraw.center(difX, $event.layerY - h);
               } else {
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) {
               this._objDraw.center(realX, difY);
            }
         }
      }
   }

   /** เมื่อวาด object เสร็จแล้วจะทำการตั้งค่าเริ่มต้นต่างๆให้กับ object นั้น */
   finishSVG($event) {
      if (this.startDrawing) {
         this._moveOnPage = false;
         this.isDrawing = false;
         if (this._objDraw) {
            this._objDraw.selectize({
               points: ['lt', 'rt', 'rb', 'lb'],
               rotationPoint: false
            });
         }
         this.startDrawing = false;
      }
      if (!this._isDeselect) {
         if (this.leftPanelComp.toolsComp) {
            this.leftPanelComp.toolsComp.isExpanded = true;
         }
         if (this._isHideProp) {
            this.setVisibleProperty(false);
         } else {
            this.setVisibleProperty(true);
         }
      }
      this._isDeselect = false;
   }

   /** ตั้งค่าเริ่มต้นต่างๆเมื่อวาง object ที่ drag ลง กรณีที่ปล่อยเมาส์ข้างนอกเอกสาร */
   outzoneSVG($event) {
      if (this._objDraw) {
         if (this.leftPanelComp.toolsComp) {
            this.leftPanelComp.toolsComp.isExpanded = true;
         }
         if (this._isHideProp) {
            this.setVisibleProperty(false);
         } else {
            this.setVisibleProperty(true);
         }
      }
   }

   /** ตั้งค่าเมื่อมีการยกเลิกการ select object นั้น */
   setDeselectItem($event) {
      this._isDeselect = true;
      if (this.leftPanelComp.toolsComp) {
         this.leftPanelComp.toolsComp.isExpanded = true;
      }
      this.leftPanelComp.visiblityState = false;
      if (!this.isDrawing) {
         this.deselectAll();
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = '';
      }
   }

   /** ยกเลิกการ select ของทุก object */
   deselectAll() {
      this.commentboxComp.setDeselectComment(false);
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                     if (item.attr('signer')) {
                        item.selectize(false);
                        if ((item.attr('fieldType') === this._keyFieldType.comment) && !item.attr('comment')) {
                           this._onDeleteComment = true;
                           this.onClickDelete({ fieldType: item.attr('fieldType')}, true);
                        }
                     }
                  }
               }
            }
         }
      }
   }

   /** ยกเลิกการ select ของทุก object ยกเว้น id ที่รับเข้ามา */
   deselectAllWithOutMatchId(id) {
      this.commentboxComp.setDeselectComment(false);
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                     if (item.attr('signer') && item.attr('id') !== id) {
                        item.selectize(false);
                        if ((item.attr('fieldType') === this._keyFieldType.comment) && !item.attr('comment')) {
                           this.onDeleteComment(item.attr('id'), item.attr('taskSignId'));
                           item.remove();
                        }
                     }
                  }
               }
            }
         }
      }
   }

   /** ตั้งค่าต่างๆเมื่อคลิกเมนูเพื่อทำการวาด object */
   handleMenuClick() {
      const signMenuClick = this.signMenuClick
         .subscribe((data) => {
            this._flagMouseOver = false;
            this._fieldType = data;
            this.startDrawing = true;
            this.isDrawing = false;
            this._objDraw = '';
            this._objectDrag = '';
            if (this.commentboxComp) {
               this.commentboxComp.setDeselectComment(false);
            }
            if (this._draw) {
               for (const item of this._draw.children()) {
                  if (item.type === 'image' || item.type === 'text' || item.type === 'g') {
                     if (item._event) {
                        item.selectize(false);
                        if ((item.attr('fieldType') === 'comment') && !item.attr('comment')) {
                           this.onDeleteComment(item.attr('id'), item.attr('taskSignId'));
                           item.remove();
                        }
                     }
                  }
               }
            }
         });
   }

   /** ตั้งค่าต่างๆเมื่อลากที่เมนูเพื่อทำการวาด object */
   handleMenuDrag() {
      const signMenuDrag = this.signMenuDrag
         .subscribe((data) => {
            this._fieldType = data;
            this._objDraw = '';
            this._objectDrag = '';
            if (this.commentboxComp) {
               this.commentboxComp.setDeselectComment(false);
            }
            if (this._draw) {
               for (const item of this._draw.children()) {
                  if (item.type === 'image' || item.type === 'text' || item.type === 'g') {
                     if (item._event) {
                        item.selectize(false);
                        if ((item.attr('fieldType') === 'comment') && !item.attr('comment')) {
                           this.onDeleteComment(item.attr('id'), item.attr('taskSignId'));
                           item.remove();
                        }
                     }
                  }
               }
            }
         });
   }

   /** ตั้งค่า object ให้ signItem ของ taskAttribute ที่จะทำการส่งไปฝั่ง service */
   setSignItem(signer, fieldType, pageType, pageNum, positionType, chkName, chkDate, certId, coordinateX, coordinateY, fieldWidth, fieldHeight, id, order, content?
      , flagSign?, taskSignId?, comment?, isExists?, idImageItem?, fontStyle?, fontSize?, fontColor?, fontBold?, fontItalic?, fontUnderline?, textRequired?, flagCheckbox?, stepOrder?, taskContactId?) {
      if (content === 'Input Text' || content === 'กรอกข้อความ') {
         content = '';
      }
      this._signItem = {
         'signer': signer
         , 'fieldType': fieldType
         , 'pageType': pageType
         , 'pageNum': pageNum
         , 'positionType': positionType
         , 'chkName': chkName
         , 'chkDate': chkDate
         , 'certId': certId
         , 'coordinateX': coordinateX
         , 'coordinateY': coordinateY
         , 'fieldWidth': fieldWidth
         , 'fieldHeight': fieldHeight
         , 'idSignItem': id
         , 'order': order
         , 'flagSign': flagSign
         , 'isExists': isExists
         , 'content': content
         , 'taskSignId': taskSignId
         , 'comment': comment
         , 'idImageItem': idImageItem
         , 'fontStyle': fontStyle
         , 'fontSize': fontSize
         , 'fontColor': fontColor
         , 'fontBold': fontBold
         , 'fontItalic': fontItalic
         , 'fontUnderline': fontUnderline
         , 'textRequired': textRequired
         , 'flagCheckbox': flagCheckbox
         , 'stepOrder': stepOrder
         , 'taskContactId': taskContactId
      };
   }

   /** ตั้งค่า doclist ของ taskAttribute ที่จะทำการส่งไปฝั่ง service */
   setDocListItem(docId, totalPages, signItems) {
      this._docListItem = {
         'docId': docId,
         'totalPages': totalPages,
         'signItems': signItems
      };
   }

   checkTextRequired(textItem:any){
      if(textItem.textContent || textItem.content || textItem.textRequired === false){
         return false;
      }
      const txtEle = document.getElementById(textItem.idSignItem);
      if (txtEle) { // add if check txtEle not null
         const eleValue = txtEle.textContent;
         if (!(eleValue === 'Input Text' || eleValue === 'กรอกข้อความ' || eleValue === '')) {
            return false;
         }
      }
      return true;
   }

   getTaskSignId(textItem:any){
      const txtEle = document.getElementById(textItem.idSignItem);
      if (txtEle) { // add if check txtEle not null
         return txtEle.getAttribute('taskSignId');
      }
      return ;
   }

   checkTextRequiredAll(move){
      let filterTextData = [];
      for(let p = 0; p < this.taskAttribute.docList.length; p++) {
         filterTextData = this.filterTextItemsAll(this.taskAttribute.docList[p].signItems , this.service.user.email);
         for (let i = 0; i < filterTextData.length; i++) {
            if (this.checkTextRequired(filterTextData[i])) {
               if(move) {
                  filterTextData[i].taskSignId = this.getTaskSignId(filterTextData[i]);
                  if(this.taskAttribute.docList[p].docId !== this.taskAttribute.docList[this.currentIndex].docId && this.taskAttribute.docList[p].signItems){ //change file
                     this.onListClick({docId: this.taskAttribute.docList[p].docId , index: p});
                     return false;
                  } else {
                     if (this.page < filterTextData[i].pageNum) { //move focus text item
                        this.focusTextItem(filterTextData[i]);
                     } else {
                        this.deselectAll();
                        this.moveFocusSignPage(filterTextData[i].pageNum, filterTextData[i].coordinateY, filterTextData[i].coordinateX);
                        this.focusSignIndexItem(filterTextData[i].pageNum, filterTextData[i].signer.toLowerCase(), filterTextData[i].signer, filterTextData[i].taskSignId);
                     }
                     return false;
                  }
               }
               return false;
            }
         }
      }
      return true;
   }

   focusTextItem(textItems){
      const currentFocusPage = textItems.pageNum - 1;
      let page = 1;
      if (currentFocusPage !== 0) {
         while (page <= currentFocusPage) {
            if (!this._statusInitial[page].isInitial) {
               this.addItemPage(this._dataPages[this.currentIndex], page);
               this._statusInitial[page].isInitial = true;
            }
            page++;
         }
      }
      this.deselectAll();
      this.moveFocusSignPage(textItems.pageNum, textItems.coordinateY, textItems.coordinateX);
      this.focusSignIndexItem(textItems.pageNum, textItems.signer.toLowerCase(), textItems.signer, textItems.taskSignId);
   }

   /** เมื่อทำการเซ็น ส่งข้อมูลไปให้ service */
   actionSignOff(btnAction: any, flagSignoff: boolean) {
      if (!this.isToggleLeftOpened) {
         this.toggleLeft.emit();
      }

      const indexForm = this.taskAttribute.docList.findIndex(o => o.docName.toLowerCase().endsWith('.zdox'));
      let isHaveForm = indexForm > -1;
      let isFormSignAll = false;
      if (indexForm > -1) {
         const form = this.taskAttribute.docList[indexForm];
         if (this.dynamicFormComp) {
               isFormSignAll = this.validateSignature(form);
               if (!isFormSignAll) {
                  this.handleToastError('signDoc.errorHaveSigned');
                  return;
               }
         } else {
            isFormSignAll = this.checkFormSign(form);
            if (!isFormSignAll) {
               this.onListClick({docId: this.taskAttribute.docList[indexForm].docId, index: indexForm});
               this.handleToastError('signDoc.errorHaveSigned');
               return;
            }
         }
      }
      if (this.taskAttribute.docList[this.currentIndex].docName.endsWith('.pdf')) {
         this.leftPanelComp.toolsComp.isExpanded = true;
      }
      this._onClickSignOff = true;
      this.btnAction = btnAction;
      let indexHaveSign = -1;
      let isHaveSigned = false;
      let isHaveNotSigned = false;
      let isHaveNotTextRequired = !this.checkTextRequiredAll(false);
      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         if (this.taskAttribute.docList[i].signItems !== undefined && this.taskAttribute.docList[i].signItems.length > 0) {
            for (let j = 0; j < this.taskAttribute.docList[i].signItems.length; j++) {
               if (parseInt(this.taskAttribute.docList[i].signItems[j].taskContactId, 10) === parseInt(this._taskContactId, 10)
                  && (this.taskAttribute.docList[i].signItems[j].fieldType === this._keyFieldType.signature
                     || this.taskAttribute.docList[i].signItems[j].fieldType === this._keyFieldType.initSignature
                     || this.taskAttribute.docList[i].signItems[j].fieldType === this._keyFieldType.signatureForm)) {
                  isHaveSigned = true;
                  indexHaveSign = i;
                  break;
               }
            }

            for (let j = 0; j < this.taskAttribute.docList[i].signItems.length; j++) {
               if (parseInt(this.taskAttribute.docList[i].signItems[j].taskContactId, 10) === parseInt(this._taskContactId, 10)
                  && this.taskAttribute.docList[i].signItems[j].fieldType === this._keyFieldType.signatureForm) {
                  this.taskAttribute.docList[i].signItems[j].flagSign = true;
               }
            }

            for (let j = 0; j < this.taskAttribute.docList[i].signItems.length; j++) {
               if (parseInt(this.taskAttribute.docList[i].signItems[j].taskContactId, 10) === parseInt(this._taskContactId, 10)
                  && (this.taskAttribute.docList[i].signItems[j].fieldType === this._keyFieldType.signature
                     || this.taskAttribute.docList[i].signItems[j].fieldType === this._keyFieldType.initSignature
                     || this.taskAttribute.docList[i].signItems[j].fieldType === this._keyFieldType.signatureForm)
                  && !this.taskAttribute.docList[i].signItems[j].flagSign) {
                  isHaveNotSigned = true;
                  break;
               }
            }
         }
      }
      if (isHaveSigned) {
         if (!this.isExtSign) {
            this.service.getProfile()
               .subscribe((data: any) => {
                  if (data.hasSignature || data.hasInitial) {
                     if ((this._signItems.length === 0 || this._textRequired) && this.taskAttribute.docList[indexHaveSign].signItems.length > 0
                        && !isHaveNotSigned && !isHaveNotTextRequired) {
                        if (isFormSignAll) {
                           if (this.dynamicFormComp) {
                              const tmp = {};
                              Object.keys(this.dynamicFormComp.form.controls).forEach(key => {
                                 tmp[key] = this.dynamicFormComp.form.controls[key].value;
                              });
                              let values = {...this.eformService.eForm.value.value,...tmp};
                              this.eformService.storeValue(values);
                           }
                           this.validateTwoFactor(btnAction, data.isTwoFactorSign, data.isTwoFactorSignGoogle, true);
                        } else {
                           this.validateTwoFactor(btnAction, data.isTwoFactorSign, data.isTwoFactorSignGoogle);
                        }
                     } else {
                        const index = this.getPageNotSign(this.taskAttribute.docList);
                        if (index !== -1) {
                           if (isHaveNotTextRequired && !isHaveNotSigned){
                              this.checkTextRequiredAll(true);
                              this.handleToastError('signDoc.errorNoTextRequired');
                           }else {
                              this.onListClick({docId: this.taskAttribute.docList[index].docId, index: index});
                              this.handleToastError('signDoc.errorHaveSigned');
                           }
                           btnAction.disabled = false;
                        }
                     }
                  } else {
                     this.openUpdateSignature(data.signatureId, data.initialId, data.fName + ' ' + data.lName, btnAction
                        , data.isTwoFactorSign, data.isTwoFactorSignGoogle);
                  }
               }, error => {
                  console.error(error);
                  btnAction.disabled = false;
               });
         } else {
            if (this._hasSignature || this._hasInitial) {
               if ((this._signItems.length === 0 || this._textRequired) && this.taskAttribute.docList[indexHaveSign].signItems.length > 0
                  && !isHaveNotSigned && !isHaveNotTextRequired) {
                  if (isFormSignAll) {
                     if (this.dynamicFormComp) {
                        const tmp = {};
                        Object.keys(this.dynamicFormComp.form.controls).forEach(key => {
                           tmp[key] = this.dynamicFormComp.form.controls[key].value;
                        });
                        let values = {...this.eformService.eForm.value.value,...tmp};
                        this.eformService.storeValue(values);
                     }
                     this.validateTwoFactor(btnAction, this._isTwofacSign, this._isTwofacGoogle, true);
                  } else {
                     this.validateTwoFactor(btnAction, this._isTwofacSign, this._isTwofacGoogle);
                  }
               } else {
                  const index = this.getPageNotSign(this.taskAttribute.docList);
                  if (index !== -1) {
                     if (isHaveNotTextRequired && !isHaveNotSigned){
                        this.checkTextRequiredAll(true);
                        this.handleToastError('signDoc.errorNoTextRequired');
                     }else {
                        this.onListClick({docId: this.taskAttribute.docList[index].docId, index: index});
                        this.handleToastError('signDoc.errorHaveSigned');
                     }
                     btnAction.disabled = false;
                  }
               }
            } else {
               this.openSignatureExtSign(btnAction);
            }
         }
      } else if (isHaveForm && this.countSignForm() === 1) {
         if (!this.isExtSign) {
            this.service.getProfile()
               .subscribe((data: any) => {
                  if (this.dynamicFormComp) {
                     const tmp = {};
                     Object.keys(this.dynamicFormComp.form.controls).forEach(key => {
                        tmp[key] = this.dynamicFormComp.form.controls[key].value;
                     });
                     let values = {...this.eformService.eForm.value.value,...tmp};
                     this.eformService.storeValue(values);
                     this.validateTwoFactor(btnAction, data.isTwoFactorSign, data.isTwoFactorSignGoogle, true);
                  } else if (this.eformService && this.eformService.eForm) {
                     this.validateTwoFactor(btnAction, data.isTwoFactorSign, data.isTwoFactorSignGoogle, true);
                  }
               }, error => {
                  console.error(error);
                  btnAction.disabled = false;
               });
         } else {
            if (this.dynamicFormComp) {
               const tmp = {};
               Object.keys(this.dynamicFormComp.form.controls).forEach(key => {
                  tmp[key] = this.dynamicFormComp.form.controls[key].value;
               });
               let values = {...this.eformService.eForm.value.value,...tmp};
               this.eformService.storeValue(values);
               this.validateTwoFactor(btnAction, this._isTwofacSign, this._isTwofacGoogle, true);
            } else if (this.eformService && this.eformService.eForm) {
               this.validateTwoFactor(btnAction, this._isTwofacSign, this._isTwofacGoogle, true);
            }
         }
      } else {
         let is_pdf_first = 0;
         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            if (this.taskAttribute.docList[i].docName.endsWith('.pdf')) {
               is_pdf_first = i;
               break;
            }
         }
         btnAction.disabled = false;
         this.handleToastError('signDoc.errorNoSign');
         if (this.taskAttribute.docList[this.currentIndex].isAttachFile) {
            this.onListClick({docId: this.taskAttribute.docList[is_pdf_first].docId, index: is_pdf_first});
         } else if (!this.taskAttribute.docList[this.currentIndex].docName.endsWith('.pdf')) {
            this.onListClick({docId: this.taskAttribute.docList[is_pdf_first].docId, index: is_pdf_first});
         }
      }
      this._onClickSignOff = false;
   }

   countSignForm(): number {
      let cnt = 0;
      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         if (this.taskAttribute.docList[i].isAttachFile) {
            continue;
         }
         if (this.taskAttribute.docList[i].docName.toLowerCase().endsWith('.zdox')) {
            cnt++;
         }
      }
      return cnt;
   }

   checkFormSign(form: any) {
      const replaceUndefinedEmptyString = (obj) => {
         for (let key in obj) {
            if (obj[key] === undefined) {
             obj[key] = "";
             delete obj[key];
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
             replaceUndefinedEmptyString(obj[key]);
            }
         }
       };
      let value = this.eformService.eForm.value.value;
      replaceUndefinedEmptyString(value);

      const username = this.service.user.username;
      const signList = form.signItems;
      let isSignDoc: boolean = true;
      if (signList && signList?.length > 0) {
         let signField = (signList.filter(o => o.signer === username).map((sign) => sign.fieldName));
         if (signField && signField?.length > 0) {
            for (let fieldName of signField) {
               if (!value[fieldName]) {
                  isSignDoc = false;
                  break;
               }
            }
         }
      }
      return isSignDoc;
   }

   validateSignature(form: any): boolean {
      const username = this.service.user.username;
      const signList = form.signItems;
      let signField: any[];
      if (signList) {
         if (signList.length) {
            signField = (signList.filter(o => o.signer === username).map((sign) => sign.fieldName));
         }
         if(signField && signField.length > 0) {
            return this.dynamicFormComp.validateSignature(signField);
         }
      }
      return true;
   }

   /** เปิด dialog เพื่อให้กำหนดรูปลายเซ็น */
   openUpdateSignature(signatureId: any, initialId: any, fullName: any, btnAction: any, isTwoFacSign: boolean, isTwoFactorSignGoogle: boolean) {
      this.setDialogRegistSignature(signatureId, initialId, fullName);
      this.registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            if (this._signItems.length === 0 && this.taskAttribute.docList[this.currentIndex].signItems.length > 0 && this.checkTextRequiredAll(false)) {
               this.validateTwoFactor(btnAction, isTwoFacSign, isTwoFactorSignGoogle);
            } else {
               this.getProfile();
               this.onListClick({docId: this.taskAttribute.docList[this.currentIndex].docId, index: this.currentIndex});
               if(!this.checkTextRequiredAll(true)){
                  this.handleToastError('signDoc.errorNoTextRequired');
               }else {
                  this.handleToastError('signDoc.errorHaveSigned');
               }
               btnAction.disabled = false;
               this.focusSignItem(-1);
            }
         } else {
            btnAction.disabled = false;
         }
      });
   }

   setDialogRegistSignature(signatureId: any, initialId: any, fullName: any) {
      this.registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         disableClose: true,
         data: this,
         autoFocus: false
      });
      this.registerSignDialog.componentInstance.signatureId = signatureId;
      this.registerSignDialog.componentInstance.initialId = initialId;
      this.registerSignDialog.componentInstance.includeName = this.includeName;
      this.registerSignDialog.componentInstance.includeDate = this.includeDate;
      this.registerSignDialog.componentInstance.hasSignature = this._hasSignature;
      this.registerSignDialog.componentInstance.hasInitial = this._hasInitial;

      if (!this._hasSignature) {
         this.registerSignDialog.componentInstance.registerInitialize = true;
         this.registerSignDialog.componentInstance.imageSignatureOriginal = 'assets/images/no_signature.png';
      } else {
         this.registerSignDialog.componentInstance.imageSignatureOriginal = this.picSign;
      }

      if (!this._hasInitial) {
         this.registerSignDialog.componentInstance.registerSignature = true;
         this.registerSignDialog.componentInstance.imageInitOriginal = 'assets/images/no_initials.png';
      } else {
         this.registerSignDialog.componentInstance.imageInitOriginal = this.picInitSign;
      }

      this.registerSignDialog.componentInstance.fullNameValue = fullName;
   }

   clickSignAll(item, e) {
      this.handleClickSignDraw(item, e).subscribe(
         () => {
            $(e.target).off('click'); // unbind before remove
            let groupTarget;
            if (item.fieldType === 'signature' && this._hasSignature) {
               groupTarget = this.findParentByClassName(e.target, this._keyFieldType.signature);
            } else if (item.fieldType === 'initSignature' && this._hasInitial) {
               groupTarget = this.findParentByClassName(e.target, this._keyFieldType.initSignature);
            } else if (item.fieldType === 'text' && item.textRequired) {
               groupTarget = this.findParentByClassName(e.target, this._keyFieldType.text);
            } else {
               if ((!this._hasSignature && this.initSignature) || (this._hasInitial && this.initSignature)) {
                  this.openUpdateSignatureItem(this._fName + ' ' + this._lName, e, item);
               }
            }
            const itemIndex = groupTarget.attr('itemIndex');
            if (this._itemSignItems[itemIndex]) {
               this._itemSignItems[itemIndex].flagSign = true;
            }
            this.removeSignItemsByOrder(this._signItems, groupTarget.attr('order'), groupTarget.attr('pageNum'));
            groupTarget.remove();
            if (this._isDialogShow) {
               this.focusSignItem(itemIndex);
            }
            this.showDialogSigned(item, itemIndex);
         },
         () => {
            // This is intentional.
         },
         () => {
            if (this.dialogSignedAll.componentInstance) {
               this.dialogSignedAll.componentInstance.disableSignButton = false;
            }
         });
   }

   /** เปิด dialog เพื่อให้กำหนดรูปลายเซ็น */
   openUpdateSignatureItem(fullName: any, e, item) {
      this.registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         disableClose: true,
         data: this,
         autoFocus: false
      });
      if (item.fieldType === 'signature') {
         this.registerSignDialog.componentInstance.registerInitialize = true;
      } else if (item.fieldType === 'initSignature') {
         this.registerSignDialog.componentInstance.registerSignature = true;
      }
      if (!this._hasSignature) {
         this.registerSignDialog.componentInstance.imageSignatureOriginal = 'assets/images/no_signature.png';
         this.signatureId = undefined;
      } else {
         this.registerSignDialog.componentInstance.imageSignatureOriginal = this.picSign;
      }

      if (!this._hasInitial) {
         this.registerSignDialog.componentInstance.imageInitOriginal = 'assets/images/no_initials.png';
         this.initialId = undefined;
      } else {
         this.registerSignDialog.componentInstance.imageInitOriginal = this.picInitSign;
      }

      this.registerSignDialog.componentInstance.includeName = this.includeName;
      this.registerSignDialog.componentInstance.includeDate = this.includeDate;
      this.registerSignDialog.componentInstance.hasSignature = this._hasSignature;
      this.registerSignDialog.componentInstance.hasInitial = this._hasInitial;
      this.registerSignDialog.componentInstance.signatureId = this.signatureId;
      this.registerSignDialog.componentInstance.initialId = this.initialId;
      this.registerSignDialog.componentInstance.fullNameValue = fullName;
      this.registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            setTimeout(() => {
               this.getProfile();
               setTimeout(() => { this.clickSignAll(item, e) },1000);
            },500);
         }
      });
   }

   /** เปิด dialog เพื่อให้กำหนดรูปลายเซ็น */
   openUpdateSignatureDraw(signatureId: any, fullName: any, $event) {
      this.registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         disableClose: true,
         data: this
      });

      if (!this._hasSignature) {
         this.registerSignDialog.componentInstance.registerInitialize = true;
         this.registerSignDialog.componentInstance.imageSignatureOriginal = 'assets/images/no_signature.png';
         this.signatureId = undefined;
      } else {
         this.registerSignDialog.componentInstance.imageSignatureOriginal = this.picSign;
      }

      if (!this._hasInitial) {
         this.registerSignDialog.componentInstance.registerSignature = true;
         this.registerSignDialog.componentInstance.imageInitOriginal = 'assets/images/no_initials.png';
         this.initialId = undefined;
      } else {
         this.registerSignDialog.componentInstance.imageInitOriginal = this.picInitSign;
      }

      this.registerSignDialog.componentInstance.signatureId = signatureId;
      this.registerSignDialog.componentInstance.initialId = this.initialId;
      this.registerSignDialog.componentInstance.includeName = this.includeName;
      this.registerSignDialog.componentInstance.includeDate = this.includeDate;
      this.registerSignDialog.componentInstance.hasSignature = this._hasSignature;
      this.registerSignDialog.componentInstance.hasInitial = this._hasInitial;
      this.registerSignDialog.componentInstance.fullNameValue = fullName;
      this.registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            this.getProfile();
            this.startDrawing = true;
            this.drawSVG($event);
            this._isDrag = false;
            this.startDrawing = false;
         }
      });
   }

   /** เปิด dialog เพื่อให้กำหนดรูปลายเซ็น external sign */
   openSignatureExtSign(btnAction: any) {
      this.externalSignDialog = this.dialog.open(ExternalSignatureComponent, {
         disableClose: true,
         data: this
      });
      const itemSelect = this.getFirstOrderSignItems(parseInt('-1', 10) + 1);

      let getFieldType;
      if (itemSelect && ((itemSelect.fieldType === this._keyFieldType.signature) || (itemSelect.fieldType === this._keyFieldType.initSignature))) {
         getFieldType = itemSelect.fieldType;
      } else {
         getFieldType = this._keyFieldType.signature;
      }
      this.externalSignDialog.componentInstance.signatureKey = this.key;
      this.externalSignDialog.componentInstance.fieldType = getFieldType;
      this.externalSignDialog.afterClosed().subscribe(result => {

         if (result) {
            if (getFieldType === this._keyFieldType.signature) {
               this._hasSignature = true;
            }
            if (getFieldType === this._keyFieldType.initSignature) {
               this._hasInitial = true;
            }

            this.leftPanelComp.hasSignature = this._hasSignature;
            this.leftPanelComp.hasInitial = this._hasInitial;

            if (this._signItems.length === 0 && this.taskAttribute.docList[this.currentIndex].signItems.length > 0 && this.checkTextRequiredAll(false)) {
               this.validateTwoFactor(btnAction, this._isTwofacSign, this._isTwofacGoogle);
            } else {
               this.onListClick({docId: this.taskAttribute.docList[this.currentIndex].docId, index: this.currentIndex});
               if(!this.checkTextRequiredAll(true)){
                  this.handleToastError('signDoc.errorNoTextRequired');
               }else {
                  this.handleToastError('signDoc.errorHaveSigned');
               }
               btnAction.disabled = false;
               this.focusSignItem(-1);
            }
         } else {
            btnAction.disabled = false;
         }
      });
   }

   /** เปิด dialog เพื่อให้กำหนดรูปลายเซ็น external sign item*/
   openSignatureExtSignItem(item, e) {
      this.externalSignDialog = this.dialog.open(ExternalSignatureComponent, {
         disableClose: true,
         data: this
      });

      this.externalSignDialog.componentInstance.signatureKey = this.key;
      this.externalSignDialog.componentInstance.fieldType = item.fieldType;
      this.externalSignDialog.afterClosed().subscribe(result => {
         if (result) {
            if (item.fieldType === this._keyFieldType.signature) {
               this._hasSignature = true;
            }
            if (item.fieldType === this._keyFieldType.initSignature) {
               this._hasInitial = true;
            }

            this.leftPanelComp.hasSignature = this._hasSignature;
            this.leftPanelComp.hasInitial = this._hasInitial;
            this.clickSignExtSign(item, e);
         }
      });
   }

   clickSignExtSign (item, e) {
      this.handleClickSignDraw(item, e).subscribe(
         () => {
            $(e.target).off('click'); // unbind before remove
            let groupTarget;
            if (item.fieldType === 'signature') {
               groupTarget = this.findParentByClassName(e.target, this._keyFieldType.signature);
            } else if (item.fieldType === 'initSignature') {
               groupTarget = this.findParentByClassName(e.target, this._keyFieldType.initSignature);
            }
            const itemIndex = groupTarget.attr('itemIndex');
            if (this._itemSignItems[itemIndex]) {
               this._itemSignItems[itemIndex].flagSign = true;
            }
            this.removeSignItemsByOrder(this._signItems, groupTarget.attr('order'), groupTarget.attr('pageNum'));
            groupTarget.remove();
            if (this._isDialogShow) {
               this.focusSignItem(itemIndex);
            }
         },
         () => {
            // This is intentional.
         },
         () => {

         });
   }

   setUpdateSignature($event) {
      this._hasSignature = $event;
   }

   setUpdateInitial($event) {
      this._hasInitial = $event;
   }

   /** เปิด Dialog เพื่อให้ตั้งค่า password */
   openChangePassword() {
      this.changePasswordDialog = this.dialog.open(SetpasswordDialogComponent, {
         disableClose: true,
         data: this,
         width: '350px'
      });
      this.changePasswordDialog.afterClosed().subscribe((result) => {
         this._isFirstSingIn = false;
         this.onStartTutorial();
      });
   }

   /** เปิด dialog twofactor authen */
   validateTwoFactor(btnAction: any, isTwoFacSign: boolean, isTwoFactorSignGoogle: boolean, isForm?: boolean) {
      this.setDeselectItem('');
      this.finishSVG('');
      this.handleWaitAction(true);
      this.addItemSign(this.currentIndex);
      this.revertDataToNormalSize(this.taskAttribute.docList, this.isZoom);
      let payload: any;
      if (isForm) {
         payload = this.eformSubmitPayload();
         const currentLevel = this.taskAttribute.currentLevel;
         const userEmail = this.service.user.email.toLowerCase();;
         const formSignItems = this.taskAttribute.docList[0].signItems.filter(o => o.signer.toLowerCase() === userEmail && o.stepOrder === currentLevel && o.flagSign);
         this.taskAttribute.docList[0].signItems = formSignItems;
      } else {
         payload = null;
      }
      this.service.signDocument(this.taskAttribute.taskId, this.taskAttribute.docList, '', null, payload) // เช็ค 2FA ที่ service signdoc
         .subscribe((response) => {
            this.signCompleted(btnAction, response);
         }, (error) => {
            console.error(error);
            if(error.status === this.STATUS_2FA) {
               this.openTwoFactor(btnAction, isTwoFacSign, isTwoFactorSignGoogle, error, payload);
            } else {
               this.handleWaitAction(false);
               btnAction.disabled = false;
               if (error.status === 400) {
                  this.toast.warn(error.message);
                  this.closePage();
               }
            }
         });
   }

   openTwoFactor(btnAction: any, isTwoFacSign: any, isTwoFactorSignGoogle: boolean, error: any, payload?: any) {
      this.twofactor = this.dialog.open(TwofactorComponent, {
         disableClose: true,
         data: {
            token: null,
            mode: 'sign',
            message: error.error,
            isTwoFactorSignGoogle: isTwoFactorSignGoogle,
            body: {taskId: this.taskAttribute.taskId, data: this.taskAttribute.docList, password: '', taskForm: payload }
         }
      });
      this.twofactor.afterClosed().subscribe(response => {
         if (response) {
            this.signCompleted(btnAction, response);
         } else {
            this.handleWaitAction(false);
            btnAction.disabled = false;
         }
      });
   }

   signCompleted(btnAction: any, response: any) {
      this.fnSaveDoc();
      this.validateImage(this.taskAttribute.taskId);
      btnAction.disabled = false;
      this.handleWaitAction(false);
      this.googleAnalyticsService.trackEvent('zdox-sign-task',{
         event_page: "sign-task",
         event_label: "sign document",
         event_action: "sign"
      });
      this.toast.success(response);
      this.closePage();
   }

   /** เปิด dialog twofac authen */
   validateTwoFactorAutoSign(isForm?: boolean) {
      this.setDeselectItem('');
      this.finishSVG('');
      this.btnAction.disabled = true;
      this.addItemSign(this.currentIndex, this._yMarginSign);
      this.handleWaitAction(true);
      this.revertDataToNormalSize(this.taskAttribute.docList, this.isZoom);
      let payload: any;
      if (isForm || (this.eformService.formValue.id || this.eformService.formValue.docId)) {
         payload = this.eformSubmitPayload();
         const currentLevel = this.taskAttribute.currentLevel;
         const userEmail = this.service.user.email.toLowerCase();;
         const formSignItems = this.taskAttribute.docList[0].signItems.filter(o => o.signer.toLowerCase() === userEmail && o.stepOrder === currentLevel && o.flagSign);
         this.taskAttribute.docList[0].signItemss = formSignItems;
      } else {
         payload = null;
      }

      this.service.signDocument(this.taskAttribute.taskId, this.taskAttribute.docList, '', null, payload)
         .subscribe((response) => {
            this.fnSaveDoc();
            this.btnAction.disabled = false;
            this.handleWaitAction(false);
            this.googleAnalyticsService.trackEvent('zdox-sign-task',{
               event_page: "sign-task",
               event_label: "auto sign document",
               event_action: "sign"
            });
            this.toast.success(response);
            $('#block-sign-page').removeClass('overlay');
            this.closePage();
         }, (error) => {
            if(error.status === this.STATUS_2FA) {
               this.openTwoFactorAutoSign(error, payload);
            } else {
               this.handleWaitAction(false);
               $('#block-sign-page').removeClass('overlay');
               this.btnAction.disabled = false;
               if (error.status === 400) {
                  this.toast.warn(error.message);
                  this.closePage();
               }
            }
         });
   }

   openTwoFactorAutoSign(error: any, payload?: any) {
      this.twofactor = this.dialog.open(TwofactorComponent, {
         disableClose: true,
         data: {
            token: null,
            mode: 'sign',
            message: error.error,
            isTwoFactorSignGoogle: this._isTwofacGoogle,
            body: {taskId: this.taskAttribute.taskId, data: this.taskAttribute.docList, password: '', taskForm: payload}
         }
      });
      this.twofactor.afterClosed().subscribe(response => {
         if (response) {
            this.autoSignCompleted(response);
         } else {
            this.handleWaitAction(false);
            $('#block-sign-page').removeClass('overlay');
            this.btnAction.disabled = false;
         }
      });
   }

   autoSignForm(callback): void {
      const indexForm = this.taskAttribute.docList.findIndex(o => o.docName.toLowerCase().endsWith('.zdox'));
      if (indexForm < 0) {
         callback();
      } else {
         const currentLevel = this.taskAttribute.currentLevel;
         const form = this.taskAttribute.docList[indexForm];
         const token = this.service.user.token;
         const url = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&init=false';

         this.service.toDataURL(url, (dataUrl) => {
            const picSign = dataUrl;
            this.sections?.map((sec) => {
               sec.fields?.map((field) => {
                  form?.signItems?.map((signItem) => {
                     if (signItem.fieldName === field.fieldName && signItem.signer === this.service.user.email
                        && signItem.stepOrder === currentLevel && field.type === 'signature') {
                        this.eformService.eForm.value.value[field.fieldName] = picSign;
                        signItem.flagSign = true;
                     }
                  })
               })
            });
            callback();
         });
      }
   }

   autoSignCompleted(response: any) {
      this.fnSaveDoc();
      this.btnAction.disabled = false;
      this.handleWaitAction(false);
      this.googleAnalyticsService.trackEvent('zdox-sign-task',{
         event_page: "sign-task",
         event_label: "auto sign document",
         event_action: "sign"
      });
      this.toast.success(response);
      $('#block-sign-page').removeClass('overlay');
      this.closePage();
   }

   //** ตรวจสอบไฟล์เอกสารแนบกรณีที่มีการแนบซ้ำ */
   validateImage(taskId: number) {
      let array_file = [];
      if(taskId===this.taskAttribute.taskId){
         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            if (this.taskAttribute.docList[i].signItems !== undefined && this.taskAttribute.docList[i].signItems.length > 0) {
               for (let j = 0; j < this.taskAttribute.docList[i].signItems.length; j++) {
                   if(this.taskAttribute.docList[i].signItems[j].idImageItem !== undefined){
                     array_file.push(this.taskAttribute.docList[i].signItems[j].idImageItem);
                   }
               }
            }
         }
         this.submitDeleteFile(array_file);
      }
   }

   fnSaveDoc() {
      this.service.getAnnotation(this.taskAttribute.docList[0].docId, true).subscribe(data => {
         if (data !== null) {
            this.service.insertDataToDatabase(this.taskAttribute.docList[0].docId, data.annotationId, data.annotationVersion, data.createdBy).subscribe( () => {});
         }
      });
   }

   /** เมื่อ sign complete จะทำการ bind data เข้า sign item ใหม่ */
   addItemSign(index, yMarginSign?) {
      let pageNo, countCurrent = 0, giveArray = [], img;
      if (!this._onClickDelete) {
         if (this._objectSVG) {
            for (const object of this._objectSVG) {
               if (object.svg) {
                  for (const item of object.svg.children()) {
                     if (item.attr('signer')) { // นับค่า object ที่พึ่งวาดลงเอง เพื่อทำการลบออกจาก signItem ให้ถูกต้อง
                        if (this._objDraw) {
                           if (this._objDraw.attr('id') !== item.attr('id')) {
                              countCurrent++;
                           } else if (this._isChangeSigner) {
                              countCurrent++;
                           }
                        } else {
                           countCurrent++;
                        }
                     }
                  }
               }
            }
         }
         if (this.taskAttribute.docList[index].signItems) {
            this.taskAttribute.docList[index].signItems.splice(0, countCurrent); // ลบออกตามจำนวนตามเงื่อนไขด้านบน
         }
         if (this.taskAttribute.docList[index].signItems) {
            giveArray = this.taskAttribute.docList[index].signItems.slice(); // copy ค่า array เอาไว้เพื่อที่จะไป bind data เข้าใหม่
         }
      }
      this.taskAttribute.docList[index].signItems = [];
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g') && $(item.node).attr('signer')) {
                     let fieldType, pageType, positionType, idSignItem, y, newX, x, isExists, chkName, chkDate, certId, content, taskSignId, comment, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox, stepOrder, taskContactId;
                     pageNo = $(item.node).attr('pageNum');
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = $(item.node).attr('chkName') === 'true';
                     chkDate = $(item.node).attr('chkDate') === 'true';
                     certId = $(item.node).attr('certId');
                     idSignItem = $(item.node).attr('id');
                     isExists = $(item.node).attr('isExists');
                     y = item.y();
                     newX = item.attr('newX');
                     x = item.x();
                     fieldType = $(item.node).attr('class');
                     content = '';
                     stepOrder = $(item.node).attr('stepOrder');
                     taskContactId = $(item.node).attr('taskContactId');
                     this._signer = $(item.node).attr('signer'); // check why signer Email change

                     if (fieldType === 'text') {
                        content = item.node.textContent;
                        fontStyle = $(item.node).attr('fontStyle');
                        fontSize = Number($(item.node).attr('fontSize'));
                        fontColor = $(item.node).attr('fontColor');
                        fontBold = ($(item.node).attr('fontBold') === 'true');
                        fontItalic = ($(item.node).attr('fontItalic') === 'true');
                        fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                        textRequired = ($(item.node).attr('textRequired') === 'true');
                     } else if (fieldType === 'comment') {
                        taskSignId = $(item.node).attr('taskSignId') ?  $(item.node).attr('taskSignId') : null;
                        comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
                     } else if (fieldType === 'image'){
                        idImageItem = $(item.node).attr('ref');
                     } else if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     if (item.type === 'g' && idImageItem !== undefined) {
                        if ($(item.node).attr('fieldType')  === 'signature') {
                           this.setSignItem(this._signer
                              , fieldType
                              , pageType
                              , pageNo
                              , positionType
                              , chkName
                              , chkDate
                              , certId
                              , x
                              , y + giveYcal * this.getCountZoom()
                              , item.width()
                              , item.height()
                              , idSignItem
                              , item.attr('order')
                              , content
                              , false
                              , taskSignId
                              , comment
                              , (isExists === 'true')
                              , idImageItem
                              , fontStyle
                              , fontSize
                              , fontColor
                              , fontBold
                              , fontItalic
                              , fontUnderline
                              , textRequired
                              , flagCheckbox
                              , stepOrder
                              , taskContactId
                           );
                        }
                        if ($(item.node).attr('fieldType')  === 'initSignature') {
                              this.setSignItem(this._signer
                                 , fieldType
                                 , pageType
                                 , pageNo
                                 , positionType
                                 , chkName
                                 , chkDate
                                 , certId
                                 , x
                                 , y + giveYcalInit * this.getCountZoom()
                                 , item.width()
                                 , item.height()
                                 , idSignItem
                                 , item.attr('order')
                                 , content
                                 , false
                                 , taskSignId
                                 , comment
                                 , (isExists === 'true')
                                 , idImageItem
                                 , fontStyle
                                 , fontSize
                                 , fontColor
                                 , fontBold
                                 , fontItalic
                                 , fontUnderline
                                 , textRequired
                                 , flagCheckbox
                                 , stepOrder
                                 , taskContactId
                              );
                        }

                        if ($(item.node).attr('fieldType')  === 'checkbox') {
                           this.setSignItem(this._signer
                              , fieldType
                              , pageType
                              , pageNo
                              , positionType
                              , chkName
                              , chkDate
                              , certId
                              , x
                              , y
                              , item.width()
                              , item.height()
                              , idSignItem
                              , item.attr('order')
                              , content
                              , true
                              , taskSignId
                              , comment
                              , (isExists === 'true')
                              , idImageItem
                              , fontStyle
                              , fontSize
                              , fontColor
                              , fontBold
                              , fontItalic
                              , fontUnderline
                              , textRequired
                              , flagCheckbox
                              , stepOrder
                              , taskContactId
                           );
                        }
                     } else {
                        if (!fieldType) {
                           switch (item.type) {
                              case 'image' :
                                 if ($(item.node).attr('fieldType')  === 'initSignature') {
                                    fieldType = 'initSignature';
                                 } else if ($(item.node).attr('fieldType')  === 'signature') {
                                    fieldType = 'signature';
                                 } else if ($(item.node).attr('fieldType')  === 'image') {
                                    fieldType = 'image';
                                 }
                                 break;
                              default:
                                 break;
                           }
                        }
                        if (item.type === 'text') {
                           this.setSignItem(this._signer
                              , fieldType
                              , pageType
                              , pageNo
                              , positionType
                              , chkName
                              , chkDate
                              , certId
                              , x
                              , y + 3
                              , item.width()
                              , item.height()
                              , idSignItem
                              , item.attr('order')
                              , content
                              , true
                              , taskSignId
                              , comment
                              , (isExists === 'true')
                              , idImageItem
                              , fontStyle
                              , fontSize
                              , fontColor
                              , fontBold
                              , fontItalic
                              , fontUnderline
                              , textRequired
                              , flagCheckbox
                              , stepOrder
                              , taskContactId
                           );
                        } else {
                           this.setSignItem(this._signer
                              , fieldType
                              , pageType
                              , pageNo
                              , positionType
                              , chkName
                              , chkDate
                              , certId
                              , x
                              , y
                              , item.width()
                              , item.height()
                              , idSignItem
                              , item.attr('order')
                              , ''
                              , true
                              , taskSignId
                              , comment
                              , (isExists === 'true')
                              , idImageItem
                              , fontStyle
                              , fontSize
                              , fontColor
                              , fontBold
                              , fontItalic
                              , fontUnderline
                              , textRequired
                              , flagCheckbox
                              , stepOrder
                              , taskContactId
                           );
                        }

                     }
                     this.taskAttribute.docList[index].signItems.push(this._signItem);
                     if (item.attr('class') === 'comment') {
                        this.updatePositionCommentBox(this._signItem, y);
                     }
                  }
               }
            }

         }
      }
      if (!this._onClickDelete) {
         for (const i in this.taskAttribute.docList) {
            if (Number(i) === index) {
               if (giveArray.length > 0) { // เก็บ data ที่ทำการ sign ไปแล้ว
                  for (const object of giveArray) {
                     if (object.fieldType === this._keyFieldType.signature) {
                        object.fieldWidth = itemSignW;
                        object.fieldHeight = itemSignH;
                        if (!object.flagSign) {
                           object.coordinateY += giveYcal;
                        }
                        object.flagSign = true;
                     }
                     this.taskAttribute.docList[index].signItems.push(object);
                  }
               }
               const fieldSign = this.taskAttribute.docList[index].signItems
                  .filter(sign => sign.fieldType === this._keyFieldType.signature
                     && sign.flagSign === false);
               for (const object of fieldSign) {
                  if (!object.flagSign) { // กรณีที่ ยังไม่ได้กด sign จะทำการตั้งค่าให้เหมือนกันกับการ sign
                     if (object.fieldType === this._keyFieldType.signature) {
                        object.fieldWidth = itemSignW;
                        object.fieldHeight = itemSignH;
                        object.flagSign = true;
                     }
                  }
               }
            } else {
               if (this.taskAttribute.docList.hasOwnProperty(Number(i))) {
                  if (this.taskAttribute.docList[Number(i)].signItems !== undefined) {
                     const fieldSign = this.taskAttribute.docList[Number(i)].signItems.filter(sign => sign.signer.toLowerCase() === this.service.user.email.toLowerCase()
                        && parseInt(sign.stepOrder, 10) === this.taskAttribute.currentLevel)
                     this.taskAttribute.docList[Number(i)].signItems = fieldSign;
                     for (const object of this.taskAttribute.docList[Number(i)].signItems) {
                        if (!object.flagSign) { // กรณีที่ ยังไม่ได้กด sign จะทำการตั้งค่าให้เหมือนกันกับการ sign
                           if (object.fieldType === this._keyFieldType.signature) {
                              object.fieldWidth = itemSignW;
                              object.fieldHeight = itemSignH;
                              object.coordinateY += giveYcal;
                              object.flagSign = true;
                           } else if (object.fieldType === this._keyFieldType.initSignature) {
                              object.fieldWidth = itemSignW;
                              object.fieldHeight = itemSignH;
                              object.coordinateY += giveYcalInit;
                              object.flagSign = true;
                           }
                        }
                     }
                  }
               }
            }
         }
      }
   }

   setTextContent() {
      for (const doc of this.taskAttribute.docList) {
         if (doc.signItems) {
            for (const item of doc.signItems) {
               if (item.fieldType === 'text' && item.idSignItem) {
                  const svgText = document.querySelector('svg [id="' + item.idSignItem + '"]');
                  if (svgText) {
                     let textValue = svgText.closest('text').querySelector('tspan').textContent;
                     if (textValue === 'Input Text' || textValue === 'กรอกข้อความ') {
                        textValue = '';
                     }
                     item.content = textValue;
                  }
               }
            }
         }
      }
   }


   /** เมื่อมีการวาด object ลงบนเอกสารจะทำการ bind data เข้า object signItem ใน taskAttribute */
   addItemSign2(index, yMarginSign?) {
      let pageNo, countCurrent = 0, giveArray = [], img;
      if (!this._onClickDelete) {
         if (this._objectSVG) {
            for (const object of this._objectSVG) {
               if (object.svg) {
                  for (const item of object.svg.children()) {
                     if (item.attr('signer')) { // นับค่า object ที่พึ่งวาดลงเอง เพื่อทำการลบออกจาก signItem ให้ถูกต้อง
                        if (this._objDraw) {
                           this._idSignitems = this._objDraw.attr('id');
                           if (this._objDraw.attr('id') !== item.attr('id')) {
                              countCurrent++;
                           } else if (this._isChangeSigner) {
                              countCurrent++;
                           }
                        } else {
                           countCurrent++;
                        }
                     }
                  }
               }
            }
         }
         if (this.taskAttribute.docList[index].signItems) {
            this.taskAttribute.docList[index].signItems.splice(0, countCurrent); // ลบออกตามจำนวนตามเงื่อนไขด้านบน
         }
         if (this.taskAttribute.docList[index].signItems) {
            giveArray = this.taskAttribute.docList[index].signItems.slice(); // copy ค่า array เอาไว้เพื่อที่จะไป bind data เข้าใหม่
         }
      }
      this.taskAttribute.docList[index].signItems = [];
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g') && $(item.node).attr('signer')) {
                     let fieldType, pageType, positionType, idSignItem, y, newX, x, isExists, chkName, chkDate, certId, content, taskSignId, comment, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox, flagSign, stepOrder, taskContactId;
                     pageNo = $(item.node).attr('pageNum');
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = $(item.node).attr('chkName') === 'true';
                     chkDate = $(item.node).attr('chkDate') === 'true';
                     certId = $(item.node).attr('certId');
                     idSignItem = $(item.node).attr('id');
                     isExists = $(item.node).attr('isExists');
                     stepOrder = $(item.node).attr('stepOrder');
                     taskContactId = $(item.node).attr('taskContactId');
                     y = item.y();
                     newX = item.attr('newX');
                     x = item.x();
                     this._signer = $(item.node).attr('signer'); // check why signer Email change
                     fieldType = $(item.node).attr('class');
                     content = '';
                     if (fieldType === 'text') {
                        content = item.node.textContent;
                        fontStyle = $(item.node).attr('fontStyle');
                        fontSize = Number($(item.node).attr('fontSize'));
                        fontColor = $(item.node).attr('fontColor');
                        fontBold = ($(item.node).attr('fontBold') === 'true');
                        fontItalic = ($(item.node).attr('fontItalic') === 'true');
                        fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                        textRequired = ($(item.node).attr('textRequired') === 'true');
                     } else if (fieldType === 'comment') {
                        taskSignId = $(item.node).attr('taskSignId') ?  $(item.node).attr('taskSignId') : null;
                        comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
                     } else if (fieldType === 'image'){
                        idImageItem = $(item.node).attr('ref');
                     } else if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     if (item.type === 'g') {
                        let itemWidth = item.children()[0].width();
                        let itemHeight = item.children()[0].height();
                        flagSign = false;
                        if (fieldType === 'checkbox') {
                           itemWidth = item.children()[1].width();
                           itemHeight = item.children()[1].height();
                           flagSign = true;
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , itemWidth
                           , itemHeight
                           , idSignItem
                           , item.attr('order')
                           , content
                           , flagSign
                           , taskSignId
                           , comment
                           , (isExists === 'true')
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     } else {
                        if (!fieldType) {
                           switch (item.type) {
                              case 'image' :
                                 if ($(item.node).attr('fieldType')  === 'initSignature') {
                                    fieldType = 'initSignature';
                                 } else if ($(item.node).attr('fieldType')  === 'signature') {
                                    fieldType = 'signature';
                                 } else if ($(item.node).attr('fieldType')  === 'image') {
                                    fieldType = 'image';
                                 }
                                 break;
                              default:
                                 break;
                           }
                        }
                        const getOrder = item.attr('orderSignPage') !== undefined ?
                           parseInt(item.attr('orderSignPage').split('_')[1], 10) : 0;
                        let order;
                        if (getOrder > 0) {
                           order = getOrder;
                        } else {
                           order = 0;
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , item.width()
                           , item.height()
                           , idSignItem
                           , order
                           , content
                           , true
                           , taskSignId
                           , comment
                           , (isExists === 'true')
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     }

                     if (this._objDraw !== '') {
                        if (this._objDraw.attr('id') !== item.attr('id') || (!this.isDrawing)) {
                           this.taskAttribute.docList[index].signItems.push(this._signItem);
                        }
                        if (this._onDrag && this._objDraw && (this._objDraw.attr('id') === item.attr('id'))) {
                           if (this._objDraw.attr('class') === 'comment') {
                              this.drawCommentBox(this._signItem, this._objDraw, y);
                           }
                        }
                     } else {
                        this.taskAttribute.docList[index].signItems.push(this._signItem);
                        if (item.attr('class') === 'comment') {
                           this.updatePositionCommentBox(this._signItem, y);
                        }
                     }
                  }
               }
            }

         }
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               this._fieldType = item.fieldType;
            } else {
               if (document.activeElement instanceof HTMLElement) {
                  document.activeElement.blur();
               }
            }
         }
      }
      if (!this._onClickDelete) {
         if (giveArray.length > 0) {
            for (const object of giveArray) {
               this.taskAttribute.docList[index].signItems.push(object);
            }
         }
         if(this.leftPanelComp.show){
            setTimeout(() => {
               this.leftPanelComp.scrollDown();
            },50);
         }
      }
   }

   /** อัพเดทค่า object กรณี sign หลังที่คำนวณ ratio ของรูปเสร็จแล้ว */
   updateItemSign(index, yMarginSign?) {
      let pageNo, img;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'text' || item.type === 'image' || item.type === 'g') && $(item.node).attr('signer')) {
                     let fieldType, pageType, positionType, idSignItem, y, newX, x, isExists, chkName, chkDate, certId, content, taskSignId, comment, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox, flagSign, stepOrder, taskContactId;
                     pageNo = $(item.node).attr('pageNum');
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = $(item.node).attr('chkName') === 'true';
                     chkDate = $(item.node).attr('chkDate') === 'true';
                     certId = $(item.node).attr('certId');
                     idSignItem = $(item.node).attr('id');
                     isExists = $(item.node).attr('isExists');
                     stepOrder = $(item.node).attr('stepOrder');
                     taskContactId = $(item.node).attr('taskContactId');
                     y = item.y();
                     newX = item.attr('newX');
                     x = item.x();
                     this._signer = $(item.node).attr('signer'); // check why signer Email change
                     fieldType = $(item.node).attr('class');
                     content = '';
                     if (fieldType === 'text') {
                        content = item.node.textContent;
                        fontStyle = $(item.node).attr('fontStyle');
                        fontSize = Number($(item.node).attr('fontSize'));
                        fontColor = $(item.node).attr('fontColor');
                        fontBold = ($(item.node).attr('fontBold') === 'true');
                        fontItalic = ($(item.node).attr('fontItalic') === 'true');
                        fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                        textRequired = ($(item.node).attr('textRequired') === 'true');
                     } else if (fieldType === 'comment') {
                        taskSignId = $(item.node).attr('taskSignId') ?  $(item.node).attr('taskSignId') : null;
                        comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
                     } else if (fieldType === 'image'){
                        idImageItem = $(item.node).attr('ref');
                     } else if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     if (item.type === 'g') {
                        let itemWidth = item.children()[0].width();
                        let itemHeight = item.children()[0].height();
                        flagSign = false;
                        if (fieldType === 'checkbox') {
                           itemWidth = item.children()[1].width();
                           itemHeight = item.children()[1].height();
                           flagSign = true;
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , itemWidth
                           , itemHeight
                           , idSignItem
                           , item.attr('order')
                           , content
                           , flagSign
                           , taskSignId
                           , comment
                           , (isExists === 'true')
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     } else {
                        if (!fieldType) {
                           switch (item.type) {
                              case 'image' :
                                 if ($(item.node).attr('fieldType')  === 'initSignature') {
                                    fieldType = 'initSignature';
                                 } else if ($(item.node).attr('fieldType')  === 'signature') {
                                    fieldType = 'signature';
                                 } else if ($(item.node).attr('fieldType')  === 'image') {
                                    fieldType = 'image';
                                 }
                                 break;
                              default:
                                 break;
                           }
                        }
                        const getOrder = item.attr('orderSignPage') !== undefined ?
                           parseInt(item.attr('orderSignPage').split('_')[1], 10) : 0;
                        let order;
                        if (getOrder > 0) {
                           order = getOrder;
                        } else {
                           order = 0;
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , item.width()
                           , item.height()
                           , idSignItem
                           , order
                           , content
                           , true
                           , taskSignId
                           , comment
                           , (isExists === 'true')
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     }
                     if (this.taskAttribute.docList[index].signItems) {
                        const indexSignItem = this.taskAttribute.docList[index].signItems
                           .findIndex(signItem => signItem.idSignItem === idSignItem);
                        if (indexSignItem !== -1) {
                           this.taskAttribute.docList[index].signItems[indexSignItem] = this._signItem;
                        }
                     }
                  }
               }
            }

         }
      }
   }

   deleteItemSign(index, id) {
      if (this.taskAttribute.docList[index].signItems) {
         const indexSignItem = this.taskAttribute.docList[index].signItems.findIndex(signItem => signItem.idSignItem === id);
         if (indexSignItem !== -1) {
            this.taskAttribute.docList[index].signItems.splice(indexSignItem, 1);
         }
      }
   }

   /** bind data เข้า signItem หลังมีการวาด object เข้าใหม่ หรือมีการเปลี่ยนแปลง object นั้น */
   updateItemsSignCurrentPage() {
      this.addItemSign2(this.currentIndex);
   }

   /** ลบ object ที่วาดอยู่ทิ้งทั้งหมด */
   clearAllSign() {
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            obj.svg.clear();
         }
      }
      this._objDraw = '';
   }

   /** ลบรูปเอกสารทิ้งทั้งหมด */
   clearAllPage() {
      $('.imageSign').remove();
      this._objectSVG = [];
      this.maxWidth = 0;
      this.maxHeight = 0;

   }

   /** แก้ไข zoom กลับเป็ย default */
   clearAllZoom() {
      this.setDeselectItem('');
      this.finishSVG('');
      this.pageNo1 = 1;
      this.page = 1;
      this.checkheightpage = 0;
      this.checkUnSelectAll.emit();

      if (this.countZoom > 0) {
         this.checkheightpage = this.checkheightpage / 2;
         this.ZoomPage(false, this.countZoom.toFixed(1));
      }
      this.isZoom = false;
      isZoom = false;
      this.countZoom = 0;
      this.viewDocumentComp.canZoomIn = true;
      this.viewDocumentComp.canZoomOut = false;
      this.isClickPage = true;
      this.isLoopPage = false;
      this._isBreak = false;
   }

   /** ตั้งค่าต่างๆเริ่มต้นใหม่ต่างๆ เมื่อทำการคลิกที่ list document */
   onListClick(object: {
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }) {
      this.clearAllZoom();
      this.setDocId(object.docId);
      this.setDocName(this.taskAttribute.docList[object.index].docName);

      this.currentIndex = object.index;
      this.isAttFile = this.taskAttribute.docList[this.currentIndex].isAttachFile;
      this.checkButton = this.taskAttribute.docList[this.currentIndex].isAttachFile;
      if (this._dataPages) {
         this.canNotFound = false;
         this.mimType = this._dataPages[this.currentIndex].mimType;
         this.namelist = this._dataPages[this.currentIndex].name;
         this.docidlist = this._dataPages[this.currentIndex].docId;
         if ((this.mimType === 'application/msword' || this.mimType === 'application/pdf' || this.mimType === 'application/vnd.ms-excel' || this.mimType === 'application/vnd.ms-powerpoint'
            || this.mimType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || this.mimType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || this.mimType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || this.mimType === 'image/tiff'
            || this.mimType === 'image/jpeg' || this.mimType === 'image/png' || this.mimType === 'image/bmp' || this.mimType.indexOf('text/') === 0)
            && this._dataPages[this.currentIndex].totalPages > 0) {
            this.canNotPreview = false;
            this.isHideCommentPdf = false;
         } else {
            this.canNotPreview = true;
            this.isHideCommentPdf = true;
         }
      } else {
         this.canNotFound = true;
         this.isHideCommentPdf = true;
      }
      this.setTextContent();
      this.clearAllSign();
      this.listClickEvent.emit(object.docId);
      this.addItemSign2(this.currentIndex);
      this.refreshPage(object.index);
      if (this.leftPanelComp.signListComp) {
         this.leftPanelComp.signListComp.setSignList(object.index, this.typeName);
      }
   }

   /** เมื่อคลิกเปลี่ยน dropdown signer */
   onSignerChange($event) {
      this.signerSelected = $event;
      if ($event.signer) {
         this._isChangeSigner = true;
      }
      if (this._objDraw) {
         if (this._objDraw.attr('fieldType') !== 'comment') {
            this._objDraw.attr('signer', this.signerSelected.signer.signerEmail.toLowerCase());
            this._objDraw.attr('stepOrder', this.signerSelected.signer.stepOrder);
            this._objDraw.attr('taskContactId', this.signerSelected.signer.taskContactId);
            this._objDraw.children()[0].fill(this.colors[this.signerSelected.index]);
            this.updateItemsSignCurrentPage();
         }
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         if ($objectDrag.attr('fieldType') !== 'comment') {
            $objectDrag.attr('signer', this.signerSelected.signer.signerEmail.toLowerCase());
            $objectDrag.attr('stepOrder', this.signerSelected.signer.stepOrder);
            $objectDrag.attr('taskContactId', this.signerSelected.signer.taskContactId);
            $($objectDrag.children()[0]).attr('fill', this.colors[this.signerSelected.index]);
            this.updateItemsSignCurrentPage();
         }
      }
   }

   /** หลังจากปิดหน้า sign off route ไปที่หน้า path ล่าสุดที่เข้ามาก่อนหน้านี้ */
   closePage(isDraft?) {
      if (sessionStorage.getItem('taskPath')) {
         this.router.navigate([sessionStorage.getItem('taskPath')]);
      } else {
         this.router.navigate(['/tasks/sign']);
      }
   }

   onClickDelete(objItem, flagDeselect?) {
      if (!this.isDrawing) {
         this._onClickDelete = true;
         let id;
         this.startDrawing = false;
         if (objItem.fieldType === 'comment' && this._objectDrag) {
            this.onDeleteObjDrag(flagDeselect);
         } else {
            if (this._objDraw) {
               this._objDraw.selectize(false);
               id = $(this._objDraw.node).attr('id');
            }
            if (this._objDraw) {
               if (this._objectSVG) {
                  for (const obj of this._objectSVG) {
                     if (obj.svg) {
                        for (const item of obj.svg.children()) {
                           const idItem = $(item.node).attr('id');
                           if (idItem === id) {
                              const isComment = $(item.node).attr('class') === 'comment';
                              if (!flagDeselect) {
                                 this.setDeselectItem('');
                              }
                              this.finishSVG('');
                              if (isComment) {
                                 this.onDeleteComment(id, $(item.node).attr('taskSignId'));
                              }
                              item.remove();
                           }
                        }
                     }
                  }
               }
               this.deleteItemSign(this.currentIndex, id);
            } else if (this._objectDrag) {
               this.onDeleteObjDrag(flagDeselect);
            }
         }
      }
      this._onClickDelete = false;
   }

   onDeleteObjDrag(flagDeselect) {
      const $objectDrag = $(this._objectDrag);
      const id = $objectDrag.attr('id');
      const img = [];
      if (!flagDeselect) {
         this.setDeselectItem('');
      }
      this.finishSVG('');
      if ($objectDrag.attr('class') === 'comment') {
         this.onDeleteComment(id, $objectDrag.attr('taskSignId'));
      } else if ($objectDrag.attr('class') === 'image') {
         let element = (<HTMLImageElement>document
         .getElementById(id));
         img.push(element.getAttribute('ref'));
         this.submitDeleteFile(img);
      }
      $objectDrag.remove();
      this.deleteItemSign(this.currentIndex, id);
   }

   onDeleteComment(id, taskSignId) {
      this._onDeleteComment = false;
      this.commentboxComp.remove(id);
      this._isDeselect = true;
      if (this.leftPanelComp.toolsComp) {
         this.leftPanelComp.toolsComp.isExpanded = true;
      }
      this.leftPanelComp.visiblityState = false;
      if (!this.isDrawing) {
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = '';
      }
      this.deleteCommentTask(taskSignId);
      this.deleteItemSign(this.currentIndex, id);
   }

   onSelectPositionTypeChange(positionTypeValue) {
      let $imageCurrentPage, imgWidthCurrentPage, imgHeightCurrentPage, position, $objectDrag;
      if (this._objDraw) {
         $objectDrag = $(this._objDraw.node);
         this._objDraw.attr('positionType', positionTypeValue);
      } else if (this._objectDrag) {
         $objectDrag = $(this._objectDrag);
         $objectDrag.attr('positionType', positionTypeValue);
      }
      this.positionType = positionTypeValue;
      if (positionTypeValue !== 'CT' && $objectDrag) {
         $imageCurrentPage = this.findParentImageBySignItem($objectDrag);
         imgWidthCurrentPage = parseFloat($imageCurrentPage.attr('width'));
         imgHeightCurrentPage = parseFloat($imageCurrentPage.attr('height'));
         this.setSizeCurrentSignItem($objectDrag);
         position = this.calculatePosition(positionTypeValue, imgWidthCurrentPage, imgHeightCurrentPage);
         this.setPositionCurrentSignItem($objectDrag, position.coordinateX, position.coordinateY);
         const imgCurrentId = $objectDrag.parent().parent().attr('id');
         let heightTotal, scrollTop, scrollLeft;
         heightTotal = this.getTotalPageHeight(imgCurrentId);
         scrollTop = position.coordinateY + heightTotal - 200;
         scrollLeft = position.coordinateX;
         $('#sideNavContent').scrollTop(scrollTop);
         $('#sideNavContent').scrollLeft(scrollLeft);
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.positionType = positionTypeValue;
               if (position) {
                  item.coordinateX = position.coordinateX;
                  item.coordinateY = position.coordinateY;
               }
            }
         }
      }
   }

   onSelectFileuploadChange(files: any){
      const file = files;
      if (files.length === 0) {
         return;
      } else {
         this.uploadDoc(file);
      }
   }
   //** render แสดงรูปภาพที่หน้าเอกสาร */
   renderImage(files) {
      // generate a new FileReader object
      const reader = new FileReader();
      let orderSignIndex, objId, id, id_next;
      if (this._objDraw) {
         objId = this._objDraw.attr('id');
         id_next = $('#' + objId).next().attr('id');
         const reader = new FileReader();
         reader.readAsDataURL(files[0]);
         reader.onload = (e: any) => {
            let element = (<HTMLImageElement>document.getElementById(objId));
            this.itemImageId = element.getAttribute('ref');
            id = 'img_' + element.getAttribute('pageNum');
            let rect = (<HTMLImageElement>document.getElementById(id_next));
               for(const obj of this._objectSVG){
                  if(id===obj.id) {
                     this._draw = obj.svg;
                     break;
                  }
               }
               if (element.getAttribute('orderSignPage')) {
                  orderSignIndex = element.getAttribute('orderSignPage');
               }
               if(rect !== null){
                  element.parentNode.removeChild(element);  // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
                  rect.remove();  /// ลบกรอบของ item
               } else {
                  element.parentNode.removeChild(element);  // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
               }
               this.drawAttachImage(e, objId, orderSignIndex);
         };
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         objId = $objectDrag.attr('id');
         const reader = new FileReader();
         reader.readAsDataURL(files[0]);
         reader.onload = (e: any) => {
            let element = (<HTMLImageElement>document.getElementById(objId));
            id = 'img_' + element.getAttribute('pageNum');
            this.itemImageId = element.getAttribute('ref');
            for (const obj of this._objectSVG) {
               if(id===obj.id) {
                  this._draw = obj.svg;
                  for (const item of obj.svg.children()) { /// ลบกรอบของ item กรณีที่มีการ Drag item
                     let rect = $(item.node);
                     if(rect.attr('fieldType') === undefined) {
                        if(rect.attr('class') === undefined) {
                           rect.remove();
                        }
                     }
                  }
                  break;
               }
            }
            if (element.getAttribute('orderSignPage')) {
               orderSignIndex = element.getAttribute('orderSignPage');
            }
               element.parentNode.removeChild(element); // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
               this.drawAttachImage(e, element.id, orderSignIndex);
         };
      }
   }

   /** ผูก image event ให้แต่ละ object */
   controllAttachImage(item){
      this._objDraw.on('load', (e) => { // โหลดรูปและคำนวณขอบกระดาษกรณี Draft ไว้มุมกระดาษ
         this.calculateOutBoundItemImage(e);
      });
      this._objDraw.on('beforedrag', (e) => {
         this.handleChangeTab();
         if (!this.isDrawing) {
            this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
         }
         this._objectDrag = e.target;
         const $id = e.target.id;
         this.deselectAllWithOutMatchId($id);
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (signItem.idSignItem === $id) {
                  this.setProperties(signItem, $id);
                  if (this.leftPanelComp.toolsComp && this.leftPanelComp.toolsComp.signers) {
                     const index = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail.toLowerCase() === signItem.signer.toLowerCase() || data.reassignEmail.toLowerCase() === signItem.signer.toLowerCase());
                     this.leftPanelComp.toolsComp.selected = index;
                     this.signerSelected.signer = this.leftPanelComp.toolsComp.signers[index];
                     this.signerSelected.index = index;
                  }
                  if (item.isExists) {
                     this.isHideDeleteBtn = item.isExists;
                     this.isHideProperties = item.isExists;
                     this.setVisibleProperty(true);
                     this._isHideProp = false;
                  } else {
                     this.setVisibleProperty(true);
                     this.isHideDeleteBtn = false;
                     this.isHideProperties = false;
                  }
                  break;
               }
            }
         }
      });
      this._objDraw.on('beforedrag', function (e) {
         if (!item.flagSign) {
             if(this.type === 'image'){
               this.attr({'cursor': 'move'});
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
         }
      });
      this._objDraw.on('dragstart.namespace', (e) => {
         this._onDrag = true;
         onDrag = true;
         this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
      });
      this._objDraw.on('dragmove.namespace', function (e) { // need to calculdate diffent Y
         if (changeImage) {
            e.preventDefault();
            this.move(e.detail.event.offsetX, e.detail.event.offsetY);
         }
      });
      this._objDraw.on('dragend.namespace', function (e) {
         if (typeName === 'sign' || typeName === 'signTask') {
            this.attr({'cursor': 'pointer'});
            if (this.type === 'image') {
               this.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            } else {
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
         } else {
            this.attr({'cursor': 'pointer'});
            this.children()[0].attr({'cursor': 'pointer'});
            this.children()[1].attr({'cursor': 'pointer'});
            this.selectize({
               points: false,
               rotationPoint: false
            });
         }
         changeImage = false;
         onDrag = false;
      });
      this._objDraw.on('dragend.namespace', (e) => {
         this.isHideProperties = false;
         this._isHideProp = false;

         this.checkImgFocus(e);
         this._onDrag = false;
         this.isDrawing = false;
         this.calculateOutBoundItemImage(e);
         this.updateItemsSignCurrentPage();
         this.finishSVG('');
      });
      this._objDraw.on('resizing', (e) => {
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = e.target;
      });
      this._objDraw.on('resizedone', (e) => {
         this.updateItemsSignCurrentPage();
      });
      this._objDraw.draggable();
      item.idSignItem = this._objDraw.attr('id');
      this.IdAttachItem = this._objDraw.attr('id');
      this._idSignitems = item.idSignItem;
      this.startDrawing = false;
   }

   //** upload file แนบรูปเอกสารบน Alfresco */
   uploadDoc(files: any) {
      const dateNow = moment(Date.now());
      const dateName = dateNow.format('yyyyMMDD_HHmmssSSS');
      if (this.validateFile(files)) {
         if (this.itemImageId === undefined || this.itemImageId === null) {
            this.itemImageId = null;
         }
          for (let i = 0; i < files.length; i++) {
            let typeName = "."+/[^/]*$/.exec(files[i].type)[0];
            files[i].fullPath = files[i].webkitRelativePath;
            files[i].fileName = dateName+typeName;
            this.init(i).subscribe(result => {
               const key = result.key;
               const fileNo = result.fileNo;
               let offset = 0;
               const file: any = files[i];
               const xhr = new XMLHttpRequest();
               const send = () => {
                  const end = Math.min(offset + this.chunkSize, file.size);
                  xhr.open('PUT', this.service.url + '/upload/' + result.key, true);
                  xhr.setRequestHeader('x-auth-token', this.service.user.token);
                  xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + file.size);
                  const blob = file.slice.call(file, offset, end);
                  xhr.send(blob);
               };
               xhr.onload = () => {
                  if (xhr.status === 308) {
                     if (file.canceled) {
                        this.service.post('/cancel/upload/' + result.key, null).subscribe(() => {
                              // This is intentional.
                           },
                           (err) => {
                              console.error(err);
                           });
                        return;
                     }
                     offset += this.chunkSize;
                     send();
                  } else if (xhr.status === 201) {
                     this.finish(key, file, fileNo);
                  }
               };
               send();
            }, error => {
               files.error = error;
            });

            if (this.typeName === 'template') {
               break;
            }
         }
      }
   }

   finish(key: string, file: any, fileNo: any) {

      const body = {
         name: file.fullPath || file.fileName,
         mimeType: file.type,
         id: this.itemImageId
      };
      // TODO body,fileNo, key
      this.service.uploadDocumentTemp("attachImage", body, fileNo, key).subscribe((response) => {
      const docId = response.docId;
      const img = (<HTMLImageElement>document.getElementById(this.IdAttachItem));
      img.setAttribute('ref', docId);
      if (this.taskAttribute.docList[this.currentIndex]) {
         this.updateItemSign(this.currentIndex);
      }
      }, error => {
         if (error.status === 413) {
            this.itemImageId.error = error.message;
         }
         if (error.status === 401) {

         }
      });
   }

   //** ลบไฟล์แนบเอกสาร */
   submitDeleteFile(array_file: string []) {
      if(array_file !== undefined || array_file.length >0){
         for (let i = 0; i < array_file.length; i++) {
            this.service.deleteDocument(array_file[i])
            .subscribe((response) => {
            },
            (err) => {
               console.error(err);
            });
         }
      }
   }

   private init(i: any): Observable<any> {
      return this.service.get('/init/upload/' + i);
   }

   validateFile(myFile: any) {
      for (let i = 0; i < myFile.length; i++) {
         if (myFile[i] != null) {
            this.ext = myFile[i].type;
            if (this.ext !== '') {
               if (this.validateExtension(this.ext) === false) {
                  this.handleToastError('uploadDoc.errorPdf');
                  return false;
               } else {
                  if (myFile[i].size > this.chunkSize) { // size 15120
                     this.handleToastError('registerSignature.errorFileSize');
                     return false;
                  } else {
                     this.renderImage(myFile);
                     return true;
                  }
               }
            } else {
               this.handleToastError('uploadDoc.errorPdf');
               return false;
            }
         }
      }
      return true;
   }

   validateExtension(v) {
      const allowedExtensions = new Array('image/png', 'image/jpeg', 'image/jpg', 'image/bmp');
      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   onSelectPageTypeChange(value) {
      if (this._objDraw) {
         this._objDraw.attr('pageType', value);
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('pageType', value);
      }
      this.pageType = value;
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.pageType = value;
            }
         }
      }
   }

   onCheckboxIncludeChange(value) {
      this.chkName = value.chkName;
      this.chkDate = value.chkDate;
      this.chkApplyAll = value.chkApplyAll;

      if (!value.chkApplyAll) {
         let $objectDrag;

         if (this._objDraw) {
            $objectDrag = $(this._objDraw.node);
            this._objDraw.attr('chkName', value.chkName);
            this._objDraw.attr('chkDate', value.chkDate);
         } else if (this._objectDrag) {
            $objectDrag = $(this._objectDrag);
            $objectDrag.attr('chkName', value.chkName);
            $objectDrag.attr('chkDate', value.chkDate);
         }
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.fieldType === 'signature' && item.idSignItem === $objectDrag.attr('id')) {
                  item.chkName = value.chkName;
                  item.chkDate = value.chkDate;
               }
            }
         }
         this.editSignature($objectDrag,value.chkName,value.chkDate);
      } else {
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.fieldType === 'signature') {
                  let obj = $('#' + item.idSignItem);
                  item.chkName = value.chkName;
                  item.chkDate = value.chkDate;
                  obj.attr('chkName', value.chkName);
                  obj.attr('chkDate', value.chkDate);
                  this.editSignature(obj,value.chkName,value.chkDate);
               }
            }
         }
      }
   }

   onPageListClick(pageNo) {
      // This is intentional.
   }

   /** เมื่อคลิก sign list ใน menu จะทำการเคลื่อนที่ไปยัง object นั้น */
   onPositionSignClick($event) {
      const pageSign = $event.pageNo + '_' + $event.index;
      if (Number($event.pageNo) > Number(this.listPageNo)) {
         for (let i = this.listPageNo; i < $event.pageNo; i++) {
            if ($(this.allImages.nativeElement.lastChild).attr('id')) {
               this.addItemPage(this._dataPages[this.currentIndex], (i));
            }
         }
         this.moveFocusSignPage($event.pageNo, $event.positionSign.coordinateY, $event.positionSign.coordinateX);
      } else {
         this.moveFocusSignPage($event.pageNo, $event.positionSign.coordinateY, $event.positionSign.coordinateX);
      }
      this.deselectAll();
      this.focusSignIndexItem(pageSign, $event.signerEmail.toLowerCase(), $event.signerReassignEmail.toLowerCase(), $event.positionSign.taskSignId);
   }

   rejectTask(rejectReason) {
      this.handleWaitAction(true);
      this.service.rejectTask(this.taskAttribute.taskId, rejectReason)
         .subscribe((response) => {
            this.handleWaitAction(false);
            this.toast.success(response);
            this.closePage();
         }, error => {
            this.handleWaitAction(false);
            this.errorMessage = error;
            if (error.status === 400) {
               this.toast.warn(error.message);
               this.closePage();
            }
         });
   }

   openFlow() {
      this.viewFlow = this.dialog.open(ViewFlowComponent, {
         disableClose: true,
         data: this,
         minHeight: '550px',
         maxHeight: '1000px',
         width: '630px'
      });
      this.viewFlow.componentInstance.id = this.taskAttribute.taskId;
      this.viewFlow.componentInstance.taskStatus = this.taskAttribute.taskStatus;
   }

   /** หาว่า object ที่รับเข้ามานั้นอยู่ภายในหน้าไหนของเอกสาร */
   findParentImageBySignItem(objectSign) {
      const nameIdImage = 'img_';
      let idImage, isFound = false, $imageObject;
      do {
         objectSign = objectSign.parent();
         idImage = $(objectSign[0]).attr('id');
         isFound = idImage.includes(nameIdImage);
         if (isFound) {
            this.currentPageNo = idImage.split('_')[1];
         }
      } while (!isFound);
      $imageObject = $(objectSign.children()[0]);
      return $imageObject;
   }

   calculatePosition(positionType, width, height) {
      let x, y;
      switch (positionType) {
         case 'TL':
            x = 0;
            y = 0;
            break;
         case 'TR' :
            x = width - this.widthSignItem;
            y = 0;
            break;
         case 'MD' :
            x = (width / 2.0) - (this.widthSignItem / 2.0);
            y = (height / 2.0) - (this.heightSignItem / 2.0);
            break;
         case 'BL' :
            x = 0;
            y = height - this.heightSignItem;
            break;
         case 'BR' :
            x = width - this.widthSignItem;
            y = height - this.heightSignItem;
            break;
         default:

            break;
      }
      return {'coordinateX': x, 'coordinateY': y};
   }

   setPositionCurrentSignItem(groupSignItem, coordinateX, coordinateY) {
      if (groupSignItem.prop('tagName') === 'image') {
         groupSignItem.attr({'x': coordinateX, 'y': coordinateY});
      } else {
         groupSignItem.attr({'x': coordinateX, 'y': coordinateY});
         $(groupSignItem.children()[0]).attr({'x': coordinateX});
      }
   }

   setSizeCurrentSignItem(objectSign) {
      if ($(objectSign).attr('fieldType') === this._keyFieldType.signature) {
         this.widthSignItem = $(objectSign).attr('width');
         this.heightSignItem = $(objectSign).attr('height');
      } else if ($(objectSign).attr('fieldType') === this._keyFieldType.initSignature) {
         this.widthSignItem = $(objectSign).attr('width')-20;
         this.heightSignItem = $(objectSign).attr('height')-10;
      }  else {
         this.widthSignItem = $(objectSign).attr('width') * this.getCountZoom();
         this.heightSignItem = $(objectSign).attr('height') * this.getCountZoom();
      }
   }

   setProperties(item, id) {
      if (item.positionType) {
         this.positionType = item.positionType;
      } else {
         this.setInitialPositionType();
      }
      if (item.pageType) {
         this.pageType = item.pageType;
      } else {
         this.setInitialPageType();
      }
      if (!this.chkApplyAll) {
         this.chkName = item.chkName;
         this.chkDate = item.chkDate;
      } else {
         item.chkName = this.chkName;
         item.chkDate = this.chkDate;
         this.editSignature($('#' + id),this.chkName,this.chkDate);
      }
      this._idSignitems = id;
      this.stepOrder = item.stepOrder;
      this.taskContactId = item.taskContactId;
   }

   setInitialPositionType() {
      this.positionType = 'CT';
   }

   setInitialPageType() {
      this.pageType = 'CP';
   }

   onScroll($event) {
      const currentPage = $($(this.allImages.nativeElement.lastChild).children()[0]);
      const $parent = $($('#all-image').children()[this.page]);
      const $imageChild = $($parent.children()[0]);
      const $parent1 = $($('#all-image').children()[this.page - 1]);
      const $imageChild1 = $($parent1.children()[0]);
      const $parent2 = $($('#all-image').children()[this.page - 2]);
      const $imageChild2 = $($parent2.children()[0]);
      const $parent0 = $($('#all-image').children()[0]);
      const $imageChild0 = $($parent0.children()[0]);
      let scrollTop = $($event.target)[0].scrollTop;
      if (this.page === 1) {
         this.checkheightpage = (Number($imageChild1.attr('height')) + this._margin) - 120;
      }
      if (this.checkheightpage < 400) {
         scrollTop = $($event.target)[0].scrollTop + 120;
      }
      if (this.getScrollDirection($event) === 'down') {
         if (this.page < this._dataPages[this.currentIndex].totalPages) {
            if (scrollTop > this.checkheightpage) {
               this.checkheightpage += Number($imageChild.attr('height')) + this._margin;
               this.page++;
            }
         }
      } else {
         let height1, height2;
         if (this.page - 1 > 0) {
            height1 = Number($imageChild1.attr('height')) + this._margin;
         }
         if (this.page - 2 > 0) {
            height2 = Number($imageChild2.attr('height')) + this._margin;
         }
         const heightTotal = height1 + height2 * 5 / 28;
         if (scrollTop < this.checkheightpage - heightTotal) {
            this.checkheightpage -= Number($imageChild1.attr('height')) + this._margin;
            this.page--;
         }
         if (this.page === 2) {
            if (scrollTop < Number($imageChild0.attr('height')) * 2 / 3) {
               this.page = 1;
            }
         }
      }
      if ($(this.allImages.nativeElement.lastChild).attr('id')) {
         const nextPageNo = parseInt($(this.allImages.nativeElement.lastChild).attr('id').split('_')[1], 10);
         this.listPageNo = Number(nextPageNo);
         const calculate = parseFloat(currentPage.attr('height')) + this._heightDialogShowPage * (nextPageNo - 1);
         if (this._heightDialogShowPage + scrollTop > calculate) {
            if (this._dataPages[this.currentIndex].totalPages > nextPageNo && !this._statusInitial[nextPageNo].isInitial) {
               this.addItemPage(this._dataPages[this.currentIndex], (nextPageNo));
            }
         }
      }
   }

   setTimeLoadThumbnail() {
      this.mytime = setTimeout(() => {
         this.scrollThumbnail.emit(this.page);
      }, 1000);
   }

   /** add หน้าของเอกสารลงตาม items และ หน้า ที่รับเข้ามา */
   addItemPage(items, pageNo) {
      this.pageNo = pageNo;
      const token = this.service.user.token;
      const item = items.pages[pageNo];
      this.imgUrl = this.service.url + '/document/' + items.docId + '/' + item.pageNo + '?taskId=' + this.taskAttribute.taskId +
         '&token=' + token + '&lastmodify=' + Date.now();
      this.append(this.imgUrl, item.width, item.height, this.transformHeight, item.pageNo, this.maxWidth);
      const imgID = 'img_' + item.pageNo;
      this.transformHeight += item.height + this._margin;
      this._objectSVG.push({'id': imgID, 'pageNo': item.pageNo, 'svg': SVG(imgID), 'docId': items.docId});
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         this.removeArrByValue(this.taskAttribute.docList[this.currentIndex].signItems, this.taskAttribute.currentLevel, this.service.user.email);
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            this.numIndex = 0;
            for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
               const userEmail = this.service.user.email.toLowerCase();
               const itemPageNo = parseInt(signItem.pageNum, 10);
               if (this._statusInitial[itemPageNo - 1]) {
                  if ((signItem.signer.toLowerCase() === userEmail || signItem.fieldType === this._keyFieldType.comment)
                     && !this._statusInitial[itemPageNo - 1].isInitial && (pageNo + 1) === itemPageNo) {
                     if (signItem.order) {
                        this.numIndex = parseInt(signItem.order, 10);
                     }
                     this.InitialDrawSvg(signItem);
                     this.numIndex = 0;
                  }
               }
            }
         }
         if (!this.isDrawing) {
            this._objDraw = '';
            this.commentboxComp.setDeselectComment(false);
         }
      }
      this._statusInitial[pageNo].isInitial = true;
   }

   addItemPagePrint(items, pageNo) {
      const token = this.service.user.token;
      const item = items.pages[pageNo];
      this.imgUrl = this.service.url + '/document/' + items.docId + '/' + item.pageNo + '?taskId=' + this.taskAttribute.taskId +
         '&token=' + token + '&lastmodify=' + Date.now();
      this.appendPrint(this.imgUrl, item.width * this.zoomRatio, item.height * this.zoomRatio
         , this.transformHeight * this.zoomRatio, item.pageNo);
   }

   getTotalPageHeight(id) {
      let heightTotal = 0;
      if ($('#' + id).attr('transform')) {
         heightTotal = parseFloat($('#' + id).attr('transform').split(',')[5].replace(')', ''));
      }
      return heightTotal;
   }

   getPageHeight(id) {
      return parseFloat($('#' + id).find('image').attr('height'));
   }

   calculatePageHeightMargin(id) {
      let heightTotal = 0;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (id === object.id) {
               break;
            } else {
               heightTotal += parseFloat($('#' + object.id).find('image').attr('height')) + this._margin * this.getCountZoom();
            }
         }
      }
      return heightTotal;
   }

   calculateScrollCenter(coordinateY, id, pageNo) {
      if (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height >
         this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width) {
         if (!this.isZoom) {
            if (coordinateY >= this.getPageHeight(id) / 2) {
               coordinateY = coordinateY - this.getPageHeight(id) / 2;
               coordinateY += (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 6);
            } else {
               coordinateY -= (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 3);
            }

         } else if (this.countZoom === 2) {
            if (coordinateY >= this.getPageHeight(id) / 2) {
               coordinateY = coordinateY - this.getPageHeight(id) / 2;
               coordinateY += (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 3) * this.countZoom;
            } else {
               coordinateY -= (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 6) * this.countZoom;
            }
         } else {
            if (coordinateY >= this.getPageHeight(id) / 2) {
               coordinateY = coordinateY - this.getPageHeight(id) / 2;
               coordinateY += (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 2.3) * this.countZoom;
            } else {
               coordinateY -= (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 14) * this.countZoom;
            }
         }
      } else {
         if (!this.isZoom) {
            if (coordinateY >= this.getPageHeight(id) / 2) {
               coordinateY = coordinateY - this.getPageHeight(id) / 2;
               coordinateY += (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 12);
            } else {
               coordinateY -= (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 2);
            }

         } else if (this.countZoom === 2) {
            if (coordinateY >= this.getPageHeight(id) / 2) {
               coordinateY = coordinateY - this.getPageHeight(id) / 2;
               coordinateY += (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 3.5) * this.countZoom;
            } else {
               coordinateY -= (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 4.5) * this.countZoom;
            }
         } else {
            if (coordinateY >= this.getPageHeight(id) / 2) {
               coordinateY = coordinateY - this.getPageHeight(id) / 2;
               coordinateY += (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 2.3) * this.countZoom;
            } else {
               coordinateY -= (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].height / 10.5) * this.countZoom;
            }
         }
      }
      return coordinateY;
   }

   findImageParent(target) {
      let next, count = 0;
      const maxIterations = 3;
      while (!$(target).hasClass('imageSign')) {
         next = $(target).parent();
         target = next[0];
         count++;
         if (count >= maxIterations) {
            break;
         }
      }
      return $(target).find('image')[0];
   }

   findParentByClassName(target, key) {
      let next, count = 0;
      while (!$(target).hasClass(key)) {
         next = $(target).parent();
         target = next[0];
         count++;
      }
      return $(target);
   }

   setOutPage($event) {
      this._moveOnPage = false;
      if(!this._objDraw){
         this.isDrawing = false;
      }
   }

   onDragOver($event) {
      $event.preventDefault();
      $event.stopPropagation();
      this.startDrawing = true;
      if (!this._isDrag) {
         this._isDrag = true;
         this.deselectAll();
      }
      if(!this._objDraw){
         this.isDrawing = false;
      }
   }

   onDragOverDisable($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.dataTransfer.effectAllowed = 'none';
      $event.dataTransfer.dropEffect = 'none';
   }

   onDrop($event) {
      switch (this._fieldType) {
         case this._keyFieldType.signature:
            if (!this._hasSignature) {
               this.openUpdateSignatureDraw(undefined, this._fName + ' ' + this._lName, $event);
               this._flagMouseOver = true;
            } else {
               this.drawSVG($event);
               this._isDrag = false;
               this.startDrawing = false;
               $event.preventDefault();
               $event.stopPropagation();
            }
            break;
         case this._keyFieldType.initSignature:
            if (!this._hasInitial) {
               this.openUpdateSignatureDraw(undefined, this._fName + ' ' + this._lName, $event);
               this._flagMouseOver = true;
            } else {
               this.drawSVG($event);
               this._isDrag = false;
               this.startDrawing = false;
               $event.preventDefault();
               $event.stopPropagation();
            }
            break;
         case this._keyFieldType.name:
         case this._keyFieldType.date:
         case this._keyFieldType.text:
         case this._keyFieldType.comment:
         case this._keyFieldType.image:
         case this._keyFieldType.checkbox:
            this.drawSVG($event);
            this._isDrag = false;
            this.startDrawing = false;
            $event.preventDefault();
            $event.stopPropagation();
            break;
         default:
            break;
      }

      if (this._fieldType === this._keyFieldType.text  || this._fieldType === this._keyFieldType.comment) {
         this.setVisibleProperty(false);
      } else {
         this.setVisibleProperty(true);
      }
   }

   onMouseOver($event) {
      switch (this._fieldType) {
         case this._keyFieldType.signature:
            if (this.startDrawing) {
               if (!this._hasSignature) {
                  if (!this._flagMouseOver) {
                     this.openUpdateSignatureDraw(undefined, this._fName + ' ' + this._lName, $event);
                     this._flagMouseOver = true;
                  }
               } else {
                  this.drawSVG($event);
               }
            }
            break;
         case this._keyFieldType.initSignature:
            if (this.startDrawing) {
               if (!this._hasInitial) {
                  if (!this._flagMouseOver) {
                     this.openUpdateSignatureDraw(undefined, this._fName + ' ' + this._lName, $event);
                     this._flagMouseOver = true;
                  }
               } else {
                  this.drawSVG($event);
               }
            }
            break;
         case this._keyFieldType.name:
         case this._keyFieldType.date:
         case this._keyFieldType.text:
         case this._keyFieldType.comment:
         case this._keyFieldType.image:
         case this._keyFieldType.checkbox:
            this.drawSVG($event);
            break;
         default:
            break;
      }
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
         this.handleChangeTab();
      });
   }

   handleDialogSigned(itemIndex) {
      const currentLevel = this.taskAttribute.currentLevel;
      const isZdoxForm = this.taskAttribute.docList[0].docName.split('.').pop().toLowerCase() === 'zdox';
      const signCnt = this.taskAttribute.docList[this.currentIndex].signItems.filter(o => o.flagSign && o.stepOrder === currentLevel).length || 0;
      if (isZdoxForm && this.hasFormSignItem()) {
         const isLastIndex = signCnt === this.taskAttribute.docList[this.currentIndex].signItems.filter(o => o.stepOrder === currentLevel).length || 0;
         if (this.isSignFormAll()) {
            if (!isLastIndex) {
               this.focusSignItem(itemIndex);
               return;
            }
         } else if (this._isDialogShow && isLastIndex) {
            setTimeout(() => this.onListClick({docId: this.taskAttribute.docList[0].docId, index: 0}), 500);
            return;
         }
      }
      this.dialogSignedAll = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('signDoc.endSigned').subscribe(s => {
         this.dialogSignedAll.componentInstance.messageWarning = s;
         this.dialogSignedAll.componentInstance.isSignOff = true;
         if(!this._itemTextItems) {
            this.dialogSignedAll.componentInstance.disableSignButton = true;
         } else {
            this.dialogSignedAll.componentInstance.disableSignButton = false;
         }
      });
      this.dialogSignedAll.afterClosed().subscribe(result => {
         this.dialogSignedAll.componentInstance.isSignOff = false;
         if (!result && !this._isDialogShow) {
            this._isDialogShow = true;
            this.focusSignItem(itemIndex);
         } else if (!result && this._signItems.length === 0) {
            if (isZdoxForm && this.hasFormSignItem() && !this.isSignFormAll()) {
               this.onListClick({docId: this.taskAttribute.docList[0].docId, index: 0});
            }
         }
         if (result && !this.checkTextRequiredAll(true)){
            this.handleToastError('signDoc.errorNoTextRequired');
         }else if ((result && this._signItems.length < 0) || result && this.checkTextRequiredAll(false)) {
            this.autoSignForm(() => {
               this.validateTwoFactorAutoSign();
            });
         }
         this._isHideProp = false;
      });
   }

   handleDialogSignedAll(item, itemIndex) {
      const isZdoxForm = this.taskAttribute.docList[0].docName.split('.').pop().toLowerCase() === 'zdox';
      const signCnt = this.taskAttribute.docList[this.currentIndex].signItems.filter(o => o.flagSign).length || 0;
      if (isZdoxForm && this.hasFormSignItem()) {
         const isLastIndex = signCnt === this.taskAttribute.docList[this.currentIndex].signItems.length;;
         if (this.isSignFormAll()) {
            if (!isLastIndex) {
               this.focusSignItem(itemIndex);
               return;
            }
         } else if (this._isDialogShow && isLastIndex) {
            setTimeout(() => this.onListClick({docId: this.taskAttribute.docList[0].docId, index: 0}), 500);
            return;
         }
      }
      this.dialogSignedAll = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('signDoc.endSignAll').subscribe(s => {
         this.dialogSignedAll.componentInstance.messageWarning = s;
         this.dialogSignedAll.componentInstance.isSignOff = true;
         this.dialogSignedAll.componentInstance.disableSignButton = true;
      });
      this.dialogSignedAll.afterClosed().subscribe(result => {
         this.dialogSignedAll.componentInstance.isSignOff = false;
         if (!result && !this._isDialogShow) {
            this._isDialogShow = true;
            const index = this.getPageNotSign(this.taskAttribute.docList); // TODO : case add new name or date before click need to sign
            if (index !== -1 && index !== this.currentIndex) {
               this.onListClick({docId: this.taskAttribute.docList[index].docId, index: index});
            } else {
               if (!result && this._signItems.length === 0) {
                  if (isZdoxForm && this.hasFormSignItem() && !this.isSignFormAll()) {
                     this.onListClick({docId: this.taskAttribute.docList[0].docId, index: 0});
                  }
               } else {
                  this.focusSignItem(itemIndex);
               }
            }
         } else if (!result && this._signItems.length === 0) {
            if (isZdoxForm) {
               const notSignFormCnt = this.taskAttribute?.docList[0]?.signItems?.filter(o => !o.flagSign)?.length | 0;
               if (notSignFormCnt > 0) {
                  this.onListClick({docId: this.taskAttribute.docList[0].docId, index: 0});
               }
            }
         }
         if(result && !this.checkTextRequiredAll(true)){
            this.handleToastError('signDoc.errorNoTextRequired');
         }else if (result) {
            this.autoSignForm(() => {
               this.validateTwoFactorAutoSign();
            });
         }
      });
   }

   handleDialogSignedAllForm() {
      let o = this.taskAttribute?.docList[0];
      let notSignFormCnt = o?.signItems?.filter(o => !o.flagSign)?.length | 0;
      if (o['isDialogShow']) {
         if (notSignFormCnt === 0) {
            const index = this.getPageNotSign(this.taskAttribute.docList); // TODO : case add new name or date before click need to sign
            if (index !== -1 && index !== this.currentIndex) {
               this.onListClick({docId: this.taskAttribute.docList[index].docId, index: index});
            }
         }
      } else {
         this.dialogSignedAll = this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: this
         });
         this.translate.get('signDoc.endSignAll').subscribe(s => {
            this.dialogSignedAll.componentInstance.messageWarning = s;
            this.dialogSignedAll.componentInstance.isSignOff = true;
            this.dialogSignedAll.componentInstance.disableSignButton = false;
         });
         this.dialogSignedAll.afterClosed().subscribe(result => {
            this.dialogSignedAll.componentInstance.isSignOff = false;
            if (!result && !this._isDialogShow) {
               this._isDialogShow = true;
               o['isDialogShow'] = true;
               if (notSignFormCnt === 0) {
                  const index = this.getPageNotSign(this.taskAttribute.docList); // TODO : case add new name or date before click need to sign
                  if (index !== -1 && index !== this.currentIndex) {
                     this.onListClick({docId: this.taskAttribute.docList[index].docId, index: index});
                  }
               }
            }
            if(result && !this.checkTextRequiredAll(true)){
               this.handleToastError('signDoc.errorNoTextRequired');
            }else if (result) {
               this.autoSignForm(() => {
                  this.validateTwoFactorAutoSign();
               });
            }
         });
      }
   }

   hasFormSignItem(): boolean {
      return this.taskAttribute?.docList[0]?.signItems.length > 0;
   }

   isSignFormAll(): boolean {
      const currentLevel = this.taskAttribute.currentLevel;
      const formSignItem = this.taskAttribute?.docList[0]?.signItems.filter(o => o.stepOrder === currentLevel);
      const signItemLen = formSignItem?.length | 0;
      if (signItemLen === 0) {
         return false;
      }
      const notSignFormCnt = formSignItem?.filter(o => !o.flagSign && o.stepOrder === currentLevel)?.length | 0;
      return notSignFormCnt === 0;
   }

   handleDialogReject() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('signOff.reject').subscribe(s => {
         dialogRef.componentInstance.messageBtnOK = s;
      });
      this.translate.get('signDoc.confirmReject').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isConfirm = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         dialogRef.componentInstance.isConfirm = false;
         if (result) {
            const dialogMsg = this.dialog.open(RejectTaskDialogComponent, {
               disableClose: true,
               data: this
            });

            dialogMsg.afterClosed().subscribe(resultClose => {
               if (resultClose) {
                  this.rejectTask(resultClose);
               }
            });
         }
      });
   }

   handleGetTranslateSignItem() {
      this.translate.get('signTools').subscribe((msg) => {
         this._signature = msg.signature;
         this._initialze = msg.initSignature;
         this._fullName = msg.nameItem;
         this._date = msg.dateItem;
         this._text = msg.textItem;
         this._image = msg.imageItem;
      });
   }

   handleChangeTab() {
      this.leftPanelComp.selectedTab = 1;
   }

   handleMovePageLeftWithMenu($event) {
      if ($event !== 1) {
         this.deselectAll();
         this.setVisibleProperty(false);
      }
   }

   handleToggleOpend() {
      $('#sideNavContent').animate({
         marginLeft: '0px'
      }, 100);
   }

   handleToggleClosed() {
      $('#sideNavContent').animate({
         marginLeft: '250px'
      }, 100);
   }

   handleFitPage(isToggleOpen) {
      this.commentboxComp.setDeselectComment(false);
      if (isToggleOpen) {
         if (!this.isZoom && this.countZoom < 4) {
            this.zoomRatio = 2.0;
            this.ZoomPage(true, this.zoomRatio);
         }
      } else {
         if (this.countZoom !== 0) {
            this.ZoomPage(false, this.zoomRatio);
            this.zoomRatio = 2.0;
         }
      }
   }

   handleCheckLanguage() {
      this.translate.get('langCurrent').subscribe((msg) => {
         if (msg === 'th') {
            this._widthSignature = 23;
            this._widthInitSignature = 26.5;
            this._widthInitName = 26;
            this._widthInitDate = 42;
            this._heightInitNameDate = 13;
            this._y = 0;
            this._fontSize = 9;
         } else if (msg === 'cn'){
            this._widthSignature = 14;
            this._widthInitSignature = 18;
            this._widthInitName = 26;
            this._widthInitDate = 42;
            this._heightInitNameDate = 13;
            this._y = 0;
            this._fontSize = 9;
         }
      });
   }

   setTextStyle() {
      if (this._objDraw) {
         this.fontDetail.fontStyle = this._objDraw.attr('fontStyle');
         this.fontDetail.fontSize = Number(this._objDraw.attr('fontSize'));
         this.fontDetail.fontColor = this._objDraw.attr('fontColor');
         this.fontDetail.fontBold = (this._objDraw.attr('fontBold')  === 'true');
         this.fontDetail.fontItalic = (this._objDraw.attr('fontItalic') === 'true');
         this.fontDetail.fontUnderline = (this._objDraw.attr('fontUnderline') === 'true');
         this.fontDetail.textRequired = (this._objDraw.attr('textRequired') === 'true');
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         this.fontDetail.fontStyle = $objectDrag.attr('fontStyle');
         this.fontDetail.fontSize = Number($objectDrag.attr('fontSize'));
         this.fontDetail.fontColor = $objectDrag.attr('fontColor');
         this.fontDetail.fontBold = ($objectDrag.attr('fontBold') === 'true');
         this.fontDetail.fontItalic = ($objectDrag.attr('fontItalic') === 'true');
         this.fontDetail.fontUnderline = ($objectDrag.attr('fontUnderline') === 'true');
         this.fontDetail.textRequired = ($objectDrag.attr('textRequired') === 'true');

      }
      this.setFontDetail();
   }

   setFontDetail(isChangeFont?) {
      let objId;
      const ratioZoom = this.getCountZoom();
      if (this._objDraw) {
         objId = this._objDraw.attr('id');

      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         objId = $objectDrag.attr('id');
      }

      const objElement = document.getElementById(objId);
      for (let i = 0; i < objElement.getElementsByTagName('tspan').length; i++) {
         if (isChangeFont) {
            /** โหลด font เพื่อไม่ให้แสดงตัวอักษรแล้วกระพริบ */
            if (objElement.getElementsByTagName('tspan')[i]) {
               let o = $('#' + objElement.getElementsByTagName('tspan')[i].id).clone();
               o.attr('id', o.attr('id') + 'tmp');
               o[0].style.fontFamily = this.fontDetail.fontStyle;
               o[0].style.visibility = 'hidden';
               $('#' + objElement.getElementsByTagName('tspan')[i].id).append(o);
               setTimeout(() => {
                  o.remove();
                  objElement.getElementsByTagName('tspan')[i].style.fontFamily = this.fontDetail.fontStyle;
               },350);
            }
            isChangeFont = false;
         }
         objElement.getElementsByTagName('tspan')[i].style.fontSize = (this.fontDetail.fontSize * ratioZoom) + 'px';
         objElement.getElementsByTagName('tspan')[i].style.fill = this.fontDetail.fontColor;
         if (this.fontDetail.fontItalic) {
            objElement.getElementsByTagName('tspan')[i].style.fontStyle = 'italic';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontStyle = 'normal';
         }

         if (this.fontDetail.fontUnderline) {
            objElement.getElementsByTagName('tspan')[i].style.textDecoration = 'underline';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.textDecoration = 'none';
         }

         if (this.fontDetail.fontBold) {
            objElement.getElementsByTagName('tspan')[i].style.fontWeight = 'bold';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontWeight = 'normal';
         }
      }
   }

   onFontDetailTypeChange(value) {
      if (this._objDraw) {
         this._objDraw.attr('fontStyle', value.fontStyle);
         this._objDraw.attr('fontSize', value.fontSize);
         this._objDraw.attr('fontColor', value.fontColor);
         this._objDraw.attr('fontBold', value.fontBold);
         this._objDraw.attr('fontItalic', value.fontItalic);
         this._objDraw.attr('fontUnderline', value.fontUnderline);
         this._objDraw.attr('textRequired', value.textRequired);

      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('fontStyle', value.fontStyle);
         $objectDrag.attr('fontSize', value.fontSize);
         $objectDrag.attr('fontColor', value.fontColor);
         $objectDrag.attr('fontBold', value.fontBold);
         $objectDrag.attr('fontItalic', value.fontItalic);
         $objectDrag.attr('fontUnderline', value.fontUnderline);
         $objectDrag.attr('textRequired', value.textRequired);
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.fontStyle = value.fontStyle;
               item.fontSize = value.fontSize;
               item.fontColor = value.fontColor;
               item.fontBold = value.fontBold;
               item.fontItalic = value.fontItalic;
               item.fontUnderline = value.fontUnderline;
               item.textRequired = value.textRequired;
            }
         }
      }
      this.setFontDetail(true);
   }

   filterSignItemsAll(data , email) {
      const filterData = [];
      const filterTextSignData = [];
      if(data) {
         data.forEach((val) => {
            if ((val.fieldType === 'signature' || val.fieldType === 'initSignature')
               && parseInt(val.taskContactId, 10) === parseInt(this._taskContactId, 10)
               && val.signer.toLowerCase() === email.toLowerCase() && val.order && !val.flagSign) {
               filterData.push(val);
            }
         });
         this._textItems = this.filterTextItemsAll(data, email);
         if (this._textItems.length > 0) {
            this._textRequired = true;
            this._textItems.forEach((val) => {
               if (!val.content) {
                  filterTextSignData.push(val);// for text require no set data
               }
            });
            this._itemTextItems = filterTextSignData;
            filterData.push(...this._textItems);//check text require add to list
         }
      }

      return filterData.slice();
   }

   filterTextItemsAll(data , email){
      const filterTextData = [];
      if(data) {
         data.forEach((val) => { // add text required after signature
            if (val.signer.toLowerCase() === email.toLowerCase() && val.fieldType === 'text' && val.textRequired) {
               filterTextData.push(val);
            }
         });
      }
      return filterTextData;
   }

   removeSignItemsByOrder(arr, targetDel, pageNum) {
      const index = arr.findIndex((data) => data.order === parseInt(targetDel, 10) && data.pageNum === pageNum);
      arr.splice(index, 1);
   }

   removeArrByValue(arr, stepOrder, email) {
      let index = 0;
      while (true) {
         if (index > arr.length - 1) {
            break;
         }
         if (!this.isHideAction) {
            if (arr[index].fieldType !== this._keyFieldType.comment
               && !(parseInt(arr[index].stepOrder, 10) === parseInt(stepOrder, 10)
            && arr[index].signer.toLowerCase() === email.toLowerCase())) {
               arr.splice(index, 1);
            } else {
               index++;
            }
         } else {
            if (arr[index].fieldType !== this._keyFieldType.comment) {
               arr.splice(index, 1);
            } else {
               index++;
            }
         }
      }
      return arr;
   }

   getFirstOrderSignItems(itemIndex) {
      if (this._itemSignItems.length > 0) {
         if (itemIndex < this._itemSignItems.length) {
            const itemSelect =  this._itemSignItems.find((val, index) => {
               if (index >= itemIndex) {
                  if (!val.flagSign || val.textRequired && val.fieldType === 'text') {
                     return val.order;
                  }
               }
            });
            if (itemSelect === undefined) {
               return this._signItems[0];
            } else {
               return itemSelect;
            }
         } else {
            if (this._signItems.length > 0) {
               return this._signItems[0];
            } else {
               return '';
            }
         }
      } else {
         return '';
      }
   }

   getFirstPageNumSignItems() {
      if (this._signItems.length > 0) {
         return this._signItems[0].pageNum;
      } else {
         return '';
      }
   }

   /** เพิ่มกรอบรอบ object ที่ถูก focus */
   focusSignIndexItem(index, signerEmail, signerReassignEmail, taskSignId) {
      let indexSignItem, isFocus = false, signer, fieldType, taskSignIdItem;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if ((item.type === 'g' || item.type === 'text' || item.type === 'image')) {
                     signer = $($(item.node)[0]).attr('signer');
                     indexSignItem = $($(item.node)[0]).attr('orderSignPage');
                     taskSignIdItem = Number($($(item.node)[0]).attr('taskSignId'));
                     fieldType = $($(item.node)[0]).attr('fieldType');
                     if (fieldType === 'comment') {
                        if (taskSignId === taskSignIdItem) {
                           this._objectDrag = item.node;
                           item.selectize({
                              points: ['lt', 'rt', 'rb', 'lb'],
                              rotationPoint: false
                           });
                           isFocus = true;
                           this._isBreak = true;
                           this.setVisibleProperty(true);
                           break;
                        }
                     } else {
                        if (taskSignId === taskSignIdItem && signer.toLowerCase() === signerEmail.toLowerCase()
                           && signerEmail.toLowerCase() === this._user.email.toLowerCase()) {
                           item.selectize({
                              points: false,
                              rotationPoint: false
                           });
                           isFocus = true;
                           this._isBreak = true;
                           break;
                        }
                     }
                  }
               }
            }
         }
      }
   }

   /** เคลื่อน scroll ไปตาม object ที่ถูก focus */
   focusSignItem(itemIndex) {
      this._recursive++;
      let orderSignItem, pageSignItem, isFocus = false;
      const itemSelect = this.getFirstOrderSignItems(parseInt(itemIndex, 10) + 1);
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (object.svg) {
               for (const item of object.svg.children()) {
                  if (item.type === 'g' || item.type === 'text') {
                     orderSignItem = $($(item.node)[0]).attr('order');
                     pageSignItem = $($(item.node)[0]).attr('pageNum');
                     if (itemSelect.order === parseInt(orderSignItem, 10)
                        && parseInt(itemSelect.pageNum, 10) === parseInt(pageSignItem, 10)) {
                        item.selectize({
                           points: false,
                           rotationPoint: false
                        });
                        isFocus = true;
                        this.moveFocusSignItem(pageSignItem, $($(item.node)[0]));
                        this._isBreak = true;
                        break;
                     }
                  }
               }
            }
            if (this._isBreak) {
               break;
            }
         }
      }
      if (!isFocus) {
         if (this._signItems.length > 0) {
            const currentFocusPage = itemSelect.pageNum - 1;
            let index = 1;
            let checkFocus = false;
            if (currentFocusPage !== 0) {
               while (index <= currentFocusPage) {
                  if (!this._statusInitial[index].isInitial) {
                     this.addItemPage(this._dataPages[this.currentIndex], index);
                     this._statusInitial[index].isInitial = true;
                     checkFocus = true;
                  }
                  index++;
               }
            }
            if (checkFocus) {
               this.focusSignItem(itemIndex);
            }
         }
      }
   }

   /** เลื่อน scroll ไปยังตำแหน่ง item ที่ focus */
   moveFocusSignPage(pageNo, coordinateY, coordinateX) {
      if (this.countZoom > 0) {
         coordinateY *= this.countZoom;
         coordinateX *= this.countZoom;
      }
      const imgCurrentId = 'img_' + pageNo;
      let heightTotal, scrollTop, scrollLeft;
      heightTotal = this.getTotalPageHeight(imgCurrentId);
      coordinateY = this.calculateScrollCenter(coordinateY, imgCurrentId, pageNo);
      scrollTop = (coordinateY + heightTotal);
      if (this.maxWidth > this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width && this.countZoom === 2) {
         scrollLeft = coordinateX - (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width / 3.5);
      } else if (this.maxWidth > this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width && this.countZoom === 4) {
         scrollLeft = coordinateX + (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width / 2.5);
      } else {
         scrollLeft = (coordinateX - (this.maxWidth - (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width / 2))) ;
      }
      $('#sideNavContent').animate({
         scrollTop: scrollTop
      });
      $('#sideNavContent').animate({
         scrollLeft: scrollLeft
      });
   }

   /** เลื่อน scroll ไปยังตำแหน่ง item ที่ focus */
   moveFocusSignItem(pageNo, item) {
      const imgCurrentId = 'img_' + pageNo, coordinateX = parseInt(item.attr('x'), 10);
      let heightTotal, scrollTop, scrollLeft, coordinateY = parseInt(item.attr('y'), 10);
      heightTotal = this.getTotalPageHeight(imgCurrentId);
      coordinateY = this.calculateScrollCenter(coordinateY, imgCurrentId, pageNo);
      scrollTop = coordinateY + heightTotal;
      scrollLeft = coordinateX - (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width - (this._dataPages[this.currentIndex].pages[Number(pageNo - 1)].width / 2));

      $('#sideNavContent').animate({
         scrollTop: scrollTop
      });
      $('#sideNavContent').animate({
         scrollLeft: scrollLeft
      });
   }

   /** เคลื่อน scroll ไปตามหน้าที่กำหนดมา */
   warpPage(pageNo) {
      this.deselectAll();
      const imgCurrentId = 'img_' + pageNo;
      let heightTotal, scrollTop;
      while (this._pageCount < pageNo) {
         if (!this._statusInitial[this._pageCount].isInitial) {
            this.addItemPage(this._dataPages[this.currentIndex], this._pageCount);
            this._statusInitial[this._pageCount].isInitial = true;
         }
         this._pageCount++;
      }
      heightTotal = this.getTotalPageHeight(imgCurrentId);
      scrollTop = heightTotal;
      if ((pageNo - this.pageNo1) > 7 || (pageNo - this.pageNo1) < -7) {
         $('#sideNavContent').animate({scrollTop: scrollTop}, 900);
         this.pageNo1 = pageNo;
      } else {
         $('#sideNavContent').animate({scrollTop: scrollTop});
         this.pageNo1 = pageNo;
      }
   }

   showDialogSigned(item, itemIndex) {
      if (this._signItems.length === 0) {
         if (!this._isShowDialogSignAll) {
            this.handleDialogSignedAll(item, itemIndex);
            this._isShowDialogSignAll = true;
         } else {
            const index = this.getPageNotSign(this.taskAttribute.docList); // TODO : case add new name or date before click need to sign
            if (index !== -1 && index !== undefined) {
               if (item.fieldType === this._keyFieldType.signature && this._hasSignature) {
                  this._draw.image(this.picSign).loaded(() => {
                  this.onListClick({docId: this.taskAttribute.docList[index].docId, index: index});
               }); } else if (item.fieldType === this._keyFieldType.initSignature && this._hasInitial) {
                  this._draw.image(this.picInitSign).loaded(() => {
                     this.onListClick({docId: this.taskAttribute.docList[index].docId, index: index});
                  }); }
            } else {
               this.handleDialogSigned(itemIndex);
            }
         }
      } else if (!this._isShowDialogSignAll) {
         this.handleDialogSignedAll(item, itemIndex);
         this._isShowDialogSignAll = true;
      }
   }

   setVisibleProperty(isShow) {
      if (this._objectDrag || this._objDraw) {
         let $objectDrag;
         if (this._objectDrag) {
            $objectDrag = $(this._objectDrag);
         } else {
            $objectDrag = $(this._objDraw.node);
         }
         if ($objectDrag.attr('class') === 'comment' && !this.isDrawing && ($objectDrag.attr('id') !== '')) {
            const comment = $objectDrag.attr('comment');
            const taskContactId = $objectDrag.attr('taskContactId');
            let condition = this.taskAttribute.taskStatus === 'Need to sign'
               && (comment && JSON.parse(comment).postBy.id === this.service.user.email);
            if (taskContactId) {
               condition = this.taskAttribute.taskStatus === 'Need to sign'
                  && (comment && (JSON.parse(comment).postBy.id === this.service.user.email
                     && parseInt(taskContactId, 10) === parseInt(this._taskContactId, 10)))
            }
            if (condition) {
               this.isHideDeleteBtn = false;
               this.leftPanelComp.visiblityState = true;
            } else {
               this.isHideDeleteBtn = true;
               this.leftPanelComp.visiblityState = false;
            }

            this.commentboxComp.setSelectComment($objectDrag.attr('id'), true, this.isHideDeleteBtn);
            setTimeout(() => {
               if (this.isToggleRightOpened) {
                  this._isComment = true;
                  this.toggleRight.emit();
               }
            }, 0);
         } else {
            this.leftPanelComp.visiblityState = isShow;
         }
      } else {
         this.leftPanelComp.visiblityState = isShow;
      }

   }

   getDrawerOpen() {
      return this.drawer.opened;
   }

   getPicSign() {
      let picSign;
      if (!this.isExtSign) {
         const token = this.service.user.token;
         picSign = this.service.url + '/signature?token=' + this.service.user.token + '&lastmodify=' + Date.now() + '&init=false';
      } else {
         picSign = this.service.url + '/signature/ext?key=' + this.key + '&lastmodify=' + Date.now() + '&init=false';
      }
      return picSign;
   }

   getPicSignInit() {
      let picSign;
      if (!this.isExtSign) {
         const token = this.service.user.token;
         picSign = this.service.url + '/signature?token=' + token + '&lastmodify=' + Date.now() + '&isChkName=false&isChkDate=false&init=true';
      } else {
         picSign = this.service.url + '/signature/ext?key=' + this.key + '&lastmodify=' + Date.now() + '&isChkName=false&isChkDate=false&init=true';
      }
      return picSign;
   }

   getPageNotSign(doclist) {
      let isHaveNotSign = false, page = -1;
      const listPageSign = [];
      for (let i = 0; i < doclist.length; i++) {
         const data = doclist[i].signItems;
         if (data) {
            for (let j = 0; j < data.length; j++) {
               if (!data[j].flagSign && (data[j].fieldType === this._keyFieldType.signature || data[j].fieldType === this._keyFieldType.initSignature)
                  && parseInt(data[j].taskContactId, 10) === parseInt(this._taskContactId, 10)
                  || (data[j].fieldType === this._keyFieldType.text && this.checkTextRequired(this.taskAttribute.docList[i].signItems[j]))) {
                  isHaveNotSign = true;
                  page = i;
                  listPageSign.push(page);
                  break;
               }
            }
            /*if (isHaveNotSign) {
               break;
            }*/
         }
      }
      // return ;
      let find = listPageSign.find(item => item === this.currentIndex);
      if (find !== undefined) {
         return find;
      } else {
         if (listPageSign.length > 0) {
            find = listPageSign.find(item => item >= this.currentIndex);
            if (find !== undefined) {
               return find;
            } else {
               find = listPageSign.find(item => item < this.currentIndex);
               return find;
            }
         } else {
            return -1;
         }
      }
   }

   calculateXtext(width, pageNo, pageTotal) {
      return width - this.calculateLenStr(this.getLenNumber(pageNo), this.getLenNumber(pageTotal));
   }

   calculateYtext(height) {
      return height + 15;
   }

   calculateLenStr(strlen1, strlen2) {
      return 20 + (strlen1 * 8) + (strlen2 * 8);
   }

   calculateLenStrSign(str) {
      const widthChar = 5;
      let len = 0;
      for (let i = 0; i < str.length; i++) {
         if ((str[i] === 'ำ' || str[i] === 'ณ' || str[i] === 'ฏ' || str[i] === 'ฐ')) {
            len += 5.3;
         } else if ((str[i] >= 'a' && str[i] <= 'z') || (str[i] >= 'A' && str[i] <= 'Z') || (str[i] >= '0' && str[i] <= '9')
            || (str[i] === '/') || (str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ') || (str[i] === 'ะ')
            || (str[i] === ' ') || str[i] >= 'า' && str[i] <= 'ำ') {
            len += widthChar;
         }
      }
      return len;
   }

   checkThaiLanguage(str) {
      let isThai = false;
      for (let i = 0; i < str.length; i++) {
         if ((str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ') || (str[i] === 'ะ') || str[i] >= 'า'
            && str[i] <= 'ำ') {
            isThai = true;
            break;
         }
      }
      return isThai;
   }

   getLenNumber(number) {
      return number.toString().length;
   }

   calculateCoordinateX(x, str, id) {
      const widthStr = this.calculateLenStrSign(str), widthImage = this.getImageWidth(id), totalWidth = x + widthStr;
      if (totalWidth > widthImage) {
         return totalWidth - widthImage;
      } else {
         return 0;
      }
   }

   getImageWidth(id) {
      const childImg = $('#' + id).children()[0];
      return $(childImg).attr('width');
   }

   findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.taskAttribute.docList[this.currentIndex].signItems.length; i++) {
         if (id === this.taskAttribute.docList[this.currentIndex].signItems[i].idSignItem) {
            index = i;
            break;
         }
      }
      return index;
   }

   printwindow() {
      this.checkload = true;
   }

   getProfile() {
      this.service.getProfile()
         .subscribe((data: any) => {
            this._hasSignature = data.hasSignature;
            this._hasInitial = data.hasInitial;
            this.signatureId = data.signatureId;
            this.initialId = data.initialId;
            this.includeName = data.includeName;
            this.includeDate = data.includeDate;
            this.leftPanelComp.hasSignature = data.hasSignature;
            this.leftPanelComp.hasInitial = data.hasInitial;
            this.leftPanelComp.profile = data;
            this._fName = data.fName;
            this._lName = data.lName;
            this._isTwofacGoogle = data.isTwoFactorSignGoogle;
            this._isTwofacSign = data.isTwoFactorSign;
            this._isFirstSingIn = data.isFirstLogin;
            if (this._isFirstSingIn) {
               this.openChangePassword();
            }

            if (this._hasSignature) {
               this.picSign = this.getPicSign();
            }

            if (this._hasInitial) {
               this.picInitSign = this.getPicSignInit();
            }

            if (this.leftPanelComp) {
               this.leftPanelComp.imageSignatureOriginal = this.picSign;
               this.leftPanelComp.imageInitOriginal = this.picInitSign;
            }
         });
   }

   getProfileExtUser() {
      this._hasSignature = false;
      this._hasInitial = false;
      this.leftPanelComp.hasSignature = this._hasSignature;
      this.leftPanelComp.hasInitial = this._hasInitial;
      this._fName = this._user.name;
      this._isTwofacGoogle = false;
      this._isTwofacSign = false;
      this._isFirstSingIn = false;
   }

   /** แสดง ซ่อน loading page */
   handleWaitAction(isShow) {
      if (isShow) {
         $('#pano-sign-task').show();
         $('#main-page').addClass('blur');
      } else {
         $('#pano-sign-task').hide();
         $('#main-page').removeClass('blur');
         if (this.page >= 1 && (this._signItems.length === 0 || this.taskAttribute.taskStatus === 'Reject'
            || this.taskAttribute.taskStatus === 'Completed')) {
            this.warpPage(this.page);
         }
      }
   }

   /** เมื่อมีการทำ action zoom page */
   ZoomPage(isZoomIn, ratio) {
      if (this.countZoom >= 0 || this.countZoom <= 4) {
         this.ZoomContainerImage(isZoomIn, ratio);
         const $sideNavContent = $('#sideNavContent');
         if (isZoomIn) {
            this.ZoomItemAll(true, ratio);
            this.setHeightObject($('#svg-page'), $('#svg-page').attr('height') * ratio);
            this.setWidthObject($('#svg-page'), $('#svg-page').attr('width') * ratio);
            this.countZoom += 2;
            if (this.countZoom === 4) {
               this.viewDocumentComp.canZoomIn = false;
            } else {
               this.viewDocumentComp.canZoomOut = true;
            }
            $sideNavContent.scrollTop($sideNavContent.scrollTop() * ratio);
         } else {
            $sideNavContent.scrollTop($sideNavContent.scrollTop() / ratio);
            this.ZoomItemAll(false, ratio);
            this.setHeightObject($('#svg-page'), $('#svg-page').attr('height') / ratio);
            this.setWidthObject($('#svg-page'), $('#svg-page').attr('width') / ratio);
            this.countZoom -= 2;
            if (this.countZoom === 0) {
               this.viewDocumentComp.canZoomOut = false;
               this.isZoom = false;
               isZoom = false;
            } else {
               this.viewDocumentComp.canZoomIn = true;
            }
         }
      }
      this.updateItemsSignCurrentPage();
      this.setLeftComment();
   }

   /** ทำการ zoom ทุก object ที่แสดงอยู่ */
   ZoomItemAll(isZoomIn, ratio) {
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            if (obj.svg) {
               for (const item of obj.svg.children()) {
                  this.zoomItem(item, isZoomIn, ratio);
               }
            }
         }
      }
   }

   zoomItem(item, isZoomIn, ratio) {
      const width = item.attr('width');
      const height = item.attr('height');
      const x = item.attr('x');
      const y = item.attr('y');
      if (item.type === 'g' && (item.attr('class') === 'signature' || item.attr('class') === 'initSignature')) {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const wRectChild2 = item.children()[1].attr('width');
         const hRectChild2 = item.children()[1].attr('height');
         const xText = item.children()[1].attr('x');
         const yText = item.children()[1].attr('y');
         const fontSize = item.children()[1].attr('font-size');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('width', wRectChild2 * ratio);
            item.children()[1].attr('height', hRectChild2 * ratio);
            item.children()[1].attr('x', xText * ratio);
            item.children()[1].attr('y', yText * ratio);
            item.children()[1].attr('font-size', fontSize * ratio);
         } else {
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('width', wRectChild2 / ratio);
            item.children()[1].attr('height', hRectChild2 / ratio);
            item.children()[1].attr('x', xText / ratio);
            item.children()[1].attr('y', yText / ratio);
            item.children()[1].attr('font-size', fontSize / ratio);
         }
      } else if ((item.type === 'g') && (item.attr('class') === 'comment' || item.attr('class') === 'image')) {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const xText = item.children()[1].attr('x');
         const yText = item.children()[1].attr('y');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('width', wRectChild * ratio);
            item.attr('height', hRectChild * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('x', xText * ratio);
            item.children()[1].attr('y', yText * ratio);
            item.children()[1].attr('width', wRectChild * ratio);
            item.children()[1].attr('height', hRectChild * ratio);
         } else {
            item.attr('width', wRectChild / ratio);
            item.attr('height', hRectChild / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('x', xText / ratio);
            item.children()[1].attr('y', yText / ratio);
            item.children()[1].attr('width', wRectChild / ratio);
            item.children()[1].attr('height', hRectChild / ratio);
         }
      } else if (item.type === 'image' || item.attr('class') === 'image') {
         if (isZoomIn) {
            item.attr('width', width * ratio);
            item.attr('height', height * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
         } else {
            item.attr('width', width / ratio);
            item.attr('height', height / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
         }
      } else if (item.type === 'text') {
         const fontSize = item.attr('font-size');
         if (isZoomIn) {
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.attr('font-size', fontSize * ratio);
            if (item.attr('class') === 'text') {
               const fontSizeTspan = parseFloat(item.node.lastChild.style.fontSize);
               item.node.lastChild.style.fontSize = (fontSizeTspan * ratio) + 'px';
            }
         } else {
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.attr('font-size', fontSize / ratio);
            if (item.attr('class') === 'text') {
               const fontSizeTspan = parseFloat(item.node.lastChild.style.fontSize);
               item.node.lastChild.style.fontSize = (fontSizeTspan / ratio) + 'px';
            }
         }
      } else if ((item.type === 'g') && (item.attr('class') === 'checkbox')) {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const wRectChild1 = item.children()[1].attr('width');
         const hRectChild1 = item.children()[1].attr('height');
         const wRectChild2 = item.children()[2].attr('width');
         const hRectChild2 = item.children()[2].attr('height');
         const xBox = item.children()[1].attr('x');
         const yBox = item.children()[1].attr('y');
         const xCheck = item.children()[2].attr('x');
         const yCheck = item.children()[2].attr('y');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('width', width * ratio);
            item.attr('height', height * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('x', xBox * ratio);
            item.children()[1].attr('y', yBox * ratio);
            item.children()[1].attr('width', wRectChild1 * ratio);
            item.children()[1].attr('height', hRectChild1 * ratio);
            item.children()[2].attr('x', xCheck * ratio);
            item.children()[2].attr('y', yCheck * ratio);
            item.children()[2].attr('width', wRectChild2 * ratio);
            item.children()[2].attr('height', hRectChild2 * ratio);
         } else {
            item.attr('width', width / ratio);
            item.attr('height', height / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('x', xBox / ratio);
            item.children()[1].attr('y', yBox / ratio);
            item.children()[1].attr('width', wRectChild1 / ratio);
            item.children()[1].attr('height', hRectChild1 / ratio);
            item.children()[2].attr('x', xCheck / ratio);
            item.children()[2].attr('y', yCheck / ratio);
            item.children()[2].attr('width', wRectChild2 / ratio);
            item.children()[2].attr('height', hRectChild2 / ratio);
         }
      }
   }


   setHeightObject($object, height) {
      $object.attr('height', height);
   }

   setWidthObject($object, width) {
      $object.attr('width', width);
   }

   setXobject($object, x) {
      $object.attr('x', x);
   }

   setYobject($object, y) {
      $object.attr('y', y);
   }

   setHeaderWidth(width) {
      $('.viewdoc-toolbar').css('padding-left', width);
   }

   setDocName(docName) {
      this._docName = this.taskAttribute.taskName + ' - ' + docName;
   }

   setDocId(docId) {
      this._docId = docId;
   }

   getDocId() {
      return this._docId;
   }

   getLenDocument() {
      return this.taskAttribute.docList.length;
   }

   getMaxPageDocuments() {
      return this.taskAttribute.docList[this.currentIndex].totalPages;
   }

   ZoomContainerImage(isZoomIn, ratio) {
      for (let i = 0; i < $('#all-image').children().length; i++) {
         const $parent = $($('#all-image').children()[i]);
         const $imageChild = $($parent.children()[0]);
         const $textChild = $($parent.children()[1]);
         const $textWatermark = $($parent.children()[2]);
         const pageNo = parseInt($parent.attr('id').split('_'), 10);
         $($('#all-image').children()[i]).attr('transform', this.ZoomTransform(isZoomIn, $($('#all-image').children()[i]), ratio));
         if (isZoomIn) {
            this.setHeightObject($imageChild, $imageChild.attr('height') * ratio);
            this.setWidthObject($imageChild, $imageChild.attr('width') * ratio);
         } else {
            this.setHeightObject($imageChild, $imageChild.attr('height') / ratio);
            this.setWidthObject($imageChild, $imageChild.attr('width') / ratio);
         }
         this.setXobject($textChild, this.calculateXtext($imageChild.attr('width'), pageNo, this._totalPages));
         this.setYobject($textChild, this.calculateYtext(parseFloat($imageChild.attr('height'))));

         if ($textWatermark) {
            let fontSize = Number($textWatermark.attr('font-size'));
            let transform = $textWatermark.attr('transform');
            if (transform) {
               const strNum = transform?.replace('translate(', '')?.replace(')', '')?.replace(' rotate(-45)', '').split(',');
               let x = Number(strNum[0]);
               let y = Number(strNum[1]);
               if (isZoomIn) {
                  fontSize = fontSize * ratio;
                  x = x * ratio;
                  y = y * ratio;
               } else {
                  fontSize = fontSize / ratio;
                  x = x / ratio;
                  y = y / ratio;
               }
               transform = 'translate(' + x + ',' + y + ') rotate(-45)';
               $textWatermark.attr('font-size', fontSize);
               $textWatermark.attr('transform', transform);
            }
         }
      }
   }

   /** get value from attribute transform from tag image and calculate zoompage */
   ZoomTransform(isZoomIn, $object, translateY) {
      const matrix = this.getValueTransform($object.attr('transform'));
      if (translateY !== -1) {
         if (isZoomIn) {
            matrix[4] = matrix[4] * translateY;
            matrix[5] = matrix[5] * translateY;
         } else {
            matrix[4] = matrix[4] / translateY;
            matrix[5] = matrix[5] / translateY;
         }
      }
      return 'matrix(' + matrix.toString() + ')';
   }

   getValueTransform(value) {
      const transform = value.replace(/[^0-9\-.,]/g, '').split(','); // split get only value matrix(0,0,0,0,0,0) => array
      const matrix = [];
      for (let i = 0; i < transform.length; i++) {
         matrix[i] = parseFloat(transform[i]);
      }
      return matrix;
   }

   findDocumentSign() {
      if (null != this.taskAttribute.docList) {
         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            for (let j = 0; j < this.taskAttribute.docList[i].signItems.length; j++) {

            }
         }
      }
   }


   onZoomIn($event) {
      if (this.countZoom < 4) {
         this.checkheightpage = this.checkheightpage * 2;
         this.isZoom = true;
         isZoom = true;
         this.ZoomPage(true, 2.0);
         if (!this.isDrawing) {
            this.deselectAll();
            if (this._objDraw) {
               this._objectDrag = this._objDraw.node;
            }
            this._objDraw = '';
            this.commentboxComp.setDeselectComment(false);
         }
         this.updateItemsSignCurrentPage();
      }
   }

   onZoomOut($event) {
      if (this.countZoom > 0) {
         this.checkheightpage = this.checkheightpage / 2;
         this.ZoomPage(false, 2.0);
         if (!this.isDrawing) {
            this.deselectAll();
            if (this._objDraw) {
               this._objectDrag = this._objDraw.node;
            }
            this._objDraw = '';
            this.commentboxComp.setDeselectComment(false);
         }
         this.updateItemsSignCurrentPage();
      }
   }

   onPrint($event) {
      this.handleWaitActionPrint(true);
      if (this.isClickPage) {
         if (document.getElementById('print')) {
            $('#print').empty();
         }
      }

      if (!this.isLoopPage) {
         for (let i = 0; i < this._dataPages[this.currentIndex].totalPages; i++) {
            if (!this._statusInitial[i].isInitial) {
               this.addItemPagePrint(this._dataPages[this.currentIndex], i);
            }
         }
         this.maxheightprint = this._dataPages[this.currentIndex].totalPages * 100;
         this.isClickPage = false;
         this.isLoopPage = true;
      }

      const divToPrint = document.getElementById('print').innerHTML;
      const newWindow = window.frames['prints'];
      // language=HTML
      newWindow.document.write(`
          <html>
              <head>
                <title></title>
                <style>

                </style>
                <script>
                 function printt() {
                    window.print();
                    window.close();
                 };
               </script>
              </head >
              <body onload="printt();" >
              ${divToPrint}
              </body>
            </html>
          `);
      newWindow.document.close();
      this.handleWaitActionPrint(false);
   }

   getCountZoom() {
      return this.countZoom === 0 ? 1 : this.countZoom;
   }

   /** แปลงค่า signitem กลับเป็นขนาดปกติเริ่มต้น */
   revertDataToNormalSize(data, checkZoom) {
      if (checkZoom || this.countZoom > 0) {
         if (data[this.currentIndex].signItems) {
            for (const j of data[this.currentIndex].signItems) {
               const index = parseInt(j.pageNum, 10) - 1;
               if (this._statusInitial[index].isInitial) {
                  if (j.flagSign) {
                     j.fieldWidth /= this.getCountZoom();
                     j.fieldHeight /= this.getCountZoom();
                     j.coordinateX /= this.getCountZoom();
                     j.coordinateY /= this.getCountZoom();
                  } else {
                     j.coordinateX /= this.getCountZoom();
                     j.coordinateY /= this.getCountZoom();
                     j.flagSign = true;
                  }
               } else {
                  if (!j.flagSign) {
                     if (j.fieldType === this._keyFieldType.signature) { // check case not initial page add y margin to signature
                        j.coordinateY += giveYcal;
                        j.flagSign = true;
                     } else if (j.fieldType === this._keyFieldType.initSignature) { // check case not initial page add y margin to initSignature
                        j.coordinateY += giveYcalInit;
                        j.flagSign = true;
                     }
                  }
               }
            }
         }
      } else {
         if (data[this.currentIndex].signItems) {
            for (const j of data[this.currentIndex].signItems) {
               const index = parseInt(j.pageNum, 10) - 1;
               if (this._statusInitial[index]?.isInitial) {
                  if (!j.flagSign) {
                     j.flagSign = true;
                  }
               } else {
                  if (!j.flagSign) {
                     if (j.fieldType === this._keyFieldType.signature) { // check case not initial page add y margin to signature
                        j.coordinateY += giveYcal;
                        j.flagSign = true;
                     } else if (j.fieldType === this._keyFieldType.initSignature) { // check case not initial page add y margin to initSignature
                        j.coordinateY += giveYcalInit;
                        j.flagSign = true;
                     }
                  }
               }
            }
         }
      }
   }

   getScrollDirection($event) {
      const scrollTop = $($event.target)[0].scrollTop;
      if (this.giveScroll < scrollTop) {
         this.giveScroll = scrollTop;
         return 'down';
      } else {
         this.giveScroll = scrollTop;
         return 'up';
      }
   }

   onEnableDownloadAll() {
      this.downloadAll.emit();
   }

   onDownload(docId) {
      window.open(this.service.url + '/downloadAdmin?id=' + docId + '&token=' + this.service.user.token +
         '&name=' + this.service.user.email + '&taskId=' + this.taskAttribute.taskId + '&device=Web', '_blank');
   }

   /** คำนวณว่ารูปที่วางลงนั้นหลุดออกนอกหรอบหรือไม่ */
   calculateOutBoundItem(e) {
      const target = $(e.target);
      const parentSvg = $(e.target.parentNode);
      const fieldType = target.attr('fieldType');
      let itemWidth, itemHeight;
      if (((fieldType === this._keyFieldType.text) || (fieldType === this._keyFieldType.image)) && (target.attr('ref')) != undefined) {
         itemWidth = parseFloat($(parentSvg.find('rect')[0]).attr('width'));
         itemHeight = parseFloat($(parentSvg.find('rect')[0]).attr('height'));
      } else {
         itemWidth = parseFloat(target.attr('width'));
         itemHeight = parseFloat(target.attr('height'));
      }
      const xItem = parseFloat(target.attr('x')), yItem = parseFloat(target.attr('y'));
      const imgWidth = this._imgFocusCal.width.baseVal.value, imgHeight = this._imgFocusCal.height.baseVal.value;
      let calShiftXitem;
      let calShiftYitem;
      let calXitem;
      let calYitem;
      if (fieldType === this._keyFieldType.signature || fieldType === this._keyFieldType.initSignature) {
         calShiftXitem = imgWidth - itemWidth; // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
         calShiftYitem = imgHeight - itemHeight;
         calXitem = xItem + itemWidth;
         calYitem = yItem + itemHeight;
         if (xItem < 0) {
            $(e.target).attr('x', 0);
         } else if (calXitem > imgWidth) {
            $(e.target).attr('x', calShiftXitem);
         }

         if (yItem < 0) {
            $(e.target).attr('y', 0);
         } else if (calYitem > imgHeight) {
            $(e.target).attr('y', calShiftYitem);
         }
      } else if (fieldType === this._keyFieldType.name || fieldType === this._keyFieldType.date || fieldType === this._keyFieldType.text || fieldType === this._keyFieldType.comment || fieldType === this._keyFieldType.image) {
         // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
         if ((fieldType === this._keyFieldType.text) || (fieldType === this._keyFieldType.image)) {
            calShiftXitem = imgWidth - itemWidth;
            calShiftYitem = imgHeight - itemHeight;
            calXitem = xItem + itemWidth;
            calYitem = yItem + itemHeight;
         } else {
            calShiftXitem = imgWidth - (itemWidth * this.getCountZoom());
            calShiftYitem = imgHeight - (itemHeight * this.getCountZoom());
            calXitem = xItem + (itemWidth * this.getCountZoom());
            calYitem = yItem + (itemHeight * this.getCountZoom());
         }
         if (xItem < 0) {
            $(e.target).attr('x', 0);
            $($(e.target).children()[0]).attr('x', 0);
         } else if (calXitem > imgWidth) {
            $(e.target).attr('x', calShiftXitem);
            $($(e.target).children()[0]).attr('x', calShiftXitem);
         }

         if (yItem < 0) {
            $(e.target).attr('y', 0);
         } else if (calYitem > imgHeight) {
            $(e.target).attr('y', calShiftYitem);
         }
      }
   }

   /** คำนวณ Type Image ที่วางลงนั้นหลุดออกนอกกรอบ*/
   calculateOutBoundItemImage(e) {
      const target = $(e.target);
      const fieldType = target.attr('fieldType');
      const ref = target.attr('ref');
      let itemWidth, itemHeight, xItem, yItem, imgWidth, imgHeight, calShiftXitem, calShiftYitem, calXitem, calYitem;
      if (fieldType === this._keyFieldType.image && (ref !== undefined || e.type === 'load')) { /// เช็คเงื่อนไข Type Image ที่ถูก brwose file เรียบร้อย
         itemWidth = target.attr('width') ? parseFloat(target.attr('width')) : 0;
         itemHeight = target.attr('height') ? parseFloat(target.attr('height')) : 0;
         xItem = parseFloat(target.attr('x')), yItem = parseFloat(target.attr('y'));
         imgWidth = this._imgFocusCal.width ? this._imgFocusCal.width.baseVal.value : 0;
         imgHeight = this._imgFocusCal.height ? this._imgFocusCal.height.baseVal.value : 0;
         calShiftXitem = imgWidth - itemWidth;
         calShiftYitem = imgHeight - itemHeight;
         calXitem = xItem + itemWidth;
         calYitem = yItem + itemHeight;
         if (xItem < 0) {
            $(e.target).attr('x', 0);
            $($(e.target).children()[0]).attr('x', 0);
         } else if (calXitem > imgWidth) {
            $(e.target).attr('x', calShiftXitem);
            $($(e.target).children()[0]).attr('x', calShiftXitem);
         }

         if (yItem < 0) {
            $(e.target).attr('y', 0);
         } else if (calYitem > imgHeight) {
            $(e.target).attr('y', calShiftYitem);
         }
      } else {  // เงื่อนไข checkbox ใช้ Tag G & Rect
         itemWidth = parseFloat($(e.target).find('rect').width());
         itemHeight = parseFloat($(e.target).find('rect').height());
         const transforms = this.getValueTransform(target.attr('transform'));
         xItem = parseFloat(transforms[4]), yItem = parseFloat(transforms[5]);
         imgWidth = parseFloat($($(target.parent()[0]).parent()).children().width());
         imgHeight = parseFloat($($(target.parent()[0]).parent()).children().height());
         const transform = Math.abs(this.getValueTransform('rotate(0,0,0)')[0]);
         let widthReal = 0, heightReal = 0;
         switch (transform) {
            case 0:
               widthReal = imgWidth;
               heightReal = imgHeight;
               break;
            case 90:
               widthReal = imgHeight;
               heightReal = imgWidth;
               break;
            case 180:
               widthReal = imgWidth;
               heightReal = imgHeight;
               break;
            case 270:
               widthReal = imgHeight;
               heightReal = imgWidth;
               break;
            default:
               widthReal = imgWidth;
               heightReal = imgHeight;
               break;
         }
          calShiftXitem = widthReal - itemWidth; // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
          calShiftYitem = heightReal - itemHeight;
          calXitem = xItem + itemWidth;
          calYitem = yItem + itemHeight;
          if (xItem < 0) {
            if (yItem < 0) {
               yItem = 0;
            } else if (yItem + itemHeight > heightReal) {
               yItem = calShiftYitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), 0, yItem);
         } else if (calXitem > widthReal) {
            if (yItem < 0) {
               yItem = 0;
            } else if (yItem + itemHeight > heightReal) {
               yItem = calShiftYitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), calShiftXitem, yItem);
         } else if (yItem < 0) {
            if (xItem < 0) {
               xItem = 0;
            } else if (xItem + itemWidth > widthReal) {
               xItem = calShiftXitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), xItem, 0);
         } else if (calYitem > heightReal) {
            if (xItem < 0) {
               xItem = 0;
            } else if (xItem + itemWidth > widthReal) {
               xItem = calShiftXitem;
            }
            this.setPositionCurrentSignItemImage($(e.target), xItem, calShiftYitem);
         }
      }
   }

   setPositionCurrentSignItemImage(groupSignItem, coordinateX, coordinateY) {
      const matrix = 'matrix(1,0,0,1,' + coordinateX + ',' + coordinateY + ')';
      groupSignItem.attr('transform', matrix);
   }

   /** ตั้งค่า tutorial ในหน้านี้ */
   onStartTutorial(): void {
      if (!this._isFirstSingIn) {
         const isHideSigner = this.leftPanelComp.isHideSigner;
         enjoyhint_instance = new EnjoyHint({});
         let enjoyhint_script_steps = [];
         let hintMsg_M: any;
         hintMsg_M = new Map<string, string>();
         this.translate.get('tutorial').subscribe((msg) => {
            setTimeout(() => {
               hintMsg_M.set('next', msg.next);
               hintMsg_M.set('close', msg.close);
               hintMsg_M.set('documentBar', msg.signOff.documentBar);
               hintMsg_M.set('toolsBar', msg.signOff.toolsBar);
               hintMsg_M.set('signBar', msg.signOff.signBar);
               hintMsg_M.set('toolsOption', msg.signOff.toolsOption);
               hintMsg_M.set('action', msg.signOff.action);
               hintMsg_M.set('sign', msg.signOff.sign);
               if (isHideSigner) {
                  enjoyhint_script_steps = [
                     {
                        'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(0)': hintMsg_M.get('documentBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                     {
                        'click .mat-tab-label.mat-ripple.ng-star-inserted:eq(1)': hintMsg_M.get('toolsBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                     {
                        'next #tools-menu-hint': hintMsg_M.get('toolsOption'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                        'left': -20,
                        'right': 40
                     },
                  ];
               } else {
                  enjoyhint_script_steps = [
                     {
                        'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(0)': hintMsg_M.get('documentBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                     {
                        'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(1)': hintMsg_M.get('signBar'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     },
                  ];
               }
               if (isHideSigner) {
                  enjoyhint_script_steps.push({
                     'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(2)': hintMsg_M.get('signBar'),
                     'nextButton': {text: hintMsg_M.get('next')},
                     'skipButton': {text: hintMsg_M.get('close')},
                  });
                  enjoyhint_script_steps.push({
                     'next #action-hint': hintMsg_M.get('action'),
                     'nextButton': {text: hintMsg_M.get('next')},
                     'skipButton': {text: hintMsg_M.get('close')},
                  });
                  if (this._signItems.length > 0) {
                     enjoyhint_script_steps.push({
                        'next rect:first': hintMsg_M.get('sign'),
                        'nextButton': {text: hintMsg_M.get('next')},
                        'skipButton': {text: hintMsg_M.get('close')},
                     });
                  }
               }
               const lengthStep = enjoyhint_script_steps.length - 1;
               enjoyhint_script_steps[lengthStep].nextButton = {'text': hintMsg_M.get('close')};
               enjoyhint_script_steps[lengthStep].showSkip = false;
               enjoyhint_instance.set(enjoyhint_script_steps);
               enjoyhint_instance.run();
            }, 500);
         });
      }
   }
   download() {
      location.href = this.service.downloadFileUrl(this.docidlist) + '&token=' + this.service.user.token;
   }
   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }
   updatefile(value) {
      this.updatefile2.emit(value);
   }

   handleWainAction(value) {
      this.handleWaitAction(value);
   }

   generateTextControl(objText: any, defaultText: any) {
      const that = this;
      objText.node.addEventListener('dblclick', function (e) {
         let parentId = e.target.parentNode.id;
         const textId = parentId;
         let svgId = parentId;
         if (e.target.parentNode.nodeName === 'text') {
            svgId = e.target.parentNode.parentNode.id;
            const textChildren = e.target.parentNode.parentNode.childNodes;
            for (let i = 0; i < textChildren.length; i++) {
               const contrlText = <HTMLImageElement>textChildren[i];
               if (textChildren[i].nodeName === 'g'
                  && contrlText.getAttribute('class') !== 'signature' && contrlText.getAttribute('class') !== 'initSignature' && contrlText.getAttribute('class') !== 'image' && contrlText.getAttribute('class') !== 'checkbox') {
                  parentId = contrlText.id;
                  break;
               }
            }
         }
         const txtEle = document.getElementById(textId);
         const ele = document.getElementById(parentId);
         let parentWidth = ele.getBoundingClientRect().width;
         const parentHeight = ele.getBoundingClientRect().height;
         const transformValue = ele.getAttribute('transform');
         const eleValue = txtEle.textContent;
         const calWidth = calculateLenStrSign(eleValue);
         if (calWidth > parentWidth) {
            parentWidth = calWidth;
         }

         const children = ele.parentNode.parentNode.childNodes;
         let pageWidth, maxWidth;
         const coX = transformValue.split(',')[4];
         for (let i = 0; i < children.length; i++) {
            if (children[i].nodeName === 'image') {
               pageWidth = (<HTMLImageElement>children[i]).getBoundingClientRect().width;
               break;
            }
         }
         maxWidth = pageWidth - parseInt(coX, 10);
         const fo = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
         fo.setAttribute('id', 'svg-' + parentId);
         fo.setAttribute('width', String(parentWidth));
         fo.setAttribute('height', String(parentHeight));
         fo.style.maxWidth = maxWidth + 'px';
         fo.setAttribute('transform', transformValue);

         const fontSize = txtEle.getAttribute('font-size');
         const ratioZoom = parseInt(fontSize, 10) / Number(fontSize);
         const ta = document.createElementNS('http://www.w3.org/1999/xhtml', 'input');
         const required = txtEle.getAttribute('textRequired'); //check text required
         let order = txtEle.getAttribute('order'); //order text box to next focus
         ta.setAttribute('id', 'txt-' + parentId);
         ta.setAttribute('type', 'text');
         ta.setAttribute('maxlength', String(150));
         ta.setAttribute('placeholder', defaultText);
         ta.style.fontSize = fontSize + 'px';
         ta.style.resize = 'none';
         ta.style.width = parentWidth + 'px';
         ta.style.maxWidth = maxWidth + 'px';
         ta.style.height = parentHeight + 'px';
         ta.style.background = 'white';
         if (!(eleValue === 'Input Text' || eleValue === 'กรอกข้อความ' || eleValue === '')) {
            ta.setAttribute('value', eleValue);
         }

         function  calculateLenStrSign(str) {
            const widthChar = 6;
            let len = 0;
            for (let i = 0; i < str.length; i++) {
               if ((str[i] === 'ำ' || str[i] === 'ณ' || str[i] === 'ฏ' || str[i] === 'ฐ')) {
                  len +=  6.3;
               } else if ((str[i] >= 'a' && str[i] <= 'z') || (str[i] >= 'A' && str[i] <= 'Z' || (str[i] >= '0' && str[i] <= '9'))
                  || (str[i] === '/') || (str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ') || (str[i] === 'ะ')
                  || (str[i] === ' ') || str[i] >= 'า' && str[i] <= 'ำ') {
                  len += widthChar;
               }
            }
            return len;
         }

         ta.addEventListener('input', function () {
            const w = calculateLenStrSign((<HTMLInputElement>this).value) * ratioZoom;
            if (w > parentWidth && w <= maxWidth) {
               this.style.width = w + 'px';
               fo.style.width = this.style.width;
            }
         });

         ta.addEventListener('keyup', function (evt) {
            const inputEle = <HTMLInputElement>this;
            if (evt.ctrlKey) {
               if (evt.key === 'a' || evt.key === 'A') {
                  inputEle.setSelectionRange(0, inputEle.value.length);
               }
            }
         });

         ta.addEventListener('keydown', function (evt) {
            const inputEle = <HTMLInputElement>this;
            const w = calculateLenStrSign(inputEle.value) * ratioZoom;
            if (evt.metaKey && (evt.key === 'a' || evt.key === 'A')) {
               inputEle.setSelectionRange(0, inputEle.value.length);
            } else if (['Enter', 'Escape'].includes(evt.key)) {
               this.blur();
               return false;
            } else if (w > maxWidth
               && !(evt.key === 'Backspace' || evt.key === 'Delete'
                  || evt.key === 'ArrowRight' || evt.key === 'ArrowLeft')) {
               // to cancel the event:
               if (evt.preventDefault) {
                  evt.preventDefault();
               }
               return false;
            }
         });

         $(ta).on('focusout', () => {
            const txtCtrl = document.getElementById('txt-' + parentId);
            let txtValue = (<HTMLInputElement>txtCtrl).value;

            if (required && txtValue !== '') {
               setTimeout(() => { //delay chack font in text box
                  that._itemTextItems.forEach((val, index) => {
                     const indexPageNotSign = that.getPageNotSign(that.taskAttribute.docList);
                     if (order == val.order && that.checkTextRequiredAll(false) && that._isfirstTextFinish && indexPageNotSign === -1) { // all text and sign confirm
                        that._isfirstTextFinish = false;
                        that.handleDialogSigned(val.order);
                     } else if (order == val.order && index >= that._itemTextItems.length - 1) {
                        if(indexPageNotSign !== -1){ // check focus all signature in page
                           that.onListClick({
                              docId: that.taskAttribute.docList[indexPageNotSign].docId,
                              index: indexPageNotSign
                           });
                        }else if(!that.checkTextRequiredAll(true)){
                           that.moveFocusSignPage(that._itemTextItems[0].pageNum, that._itemTextItems[0].coordinateY, that._itemTextItems[0].coordinateX);
                           that.focusSignIndexItem(that._itemTextItems[0].pageNum, that._itemTextItems[0].signer.toLowerCase(), that._itemTextItems[0].signer, that._itemTextItems[0].taskSignId);
                        }
                     } else if (order == val.order && index < that._itemTextItems.length - 1 && !that.checkTextRequiredAll(false)) {
                        if (that.page < that._itemTextItems[index + 1].pageNum ) { //move focus text item
                           that.focusTextItem(that._itemTextItems[index + 1]);
                        } else  {
                           that.moveFocusSignPage(that._itemTextItems[index + 1].pageNum, that._itemTextItems[index + 1].coordinateY, that._itemTextItems[index + 1].coordinateX);
                           that.focusSignIndexItem(that._itemTextItems[index + 1].pageNum, that._itemTextItems[index + 1].signer.toLowerCase(), that._itemTextItems[index + 1].signer, that._itemTextItems[index + 1].taskSignId);
                        }
                     }
                  });
               }, 0);
            }
            if (txtValue === '') {
               txtValue = defaultText;
            }
            document.querySelector('svg [id="' + textId + '"]').closest('text').
            querySelector('tspan').textContent = txtValue;

            document.getElementById(svgId).removeChild(fo);
         });

         $(ta).on('click', () => {
            that.setVisibleProperty(true);
         });

         $(ta).on('select', () => {
            that.setVisibleProperty(true);
         });

         fo.appendChild(ta);
         document.getElementById(svgId).appendChild(fo);
         ta.focus();
         const controlTextbox = <HTMLInputElement>ta;
         const textValueLen = controlTextbox.value.length;
         controlTextbox.setSelectionRange(textValueLen, textValueLen);
         e.preventDefault();
      });
   }

   /** สร้าง comment list */
   drawCommentBox(item: any, objDraw: any, y: any) {
      let setDrawCommentY: number;
      try {
         if (item) {
            if (objDraw.attr('pageNum') === 1 ) {
               setDrawCommentY = y;
            } else {
               let $imageCurrentPage, imgHeightCurrentPage, $objectDrag;
               if (this._objDraw) {
                  $objectDrag = $(this._objDraw.node);
               } else if (this._objectDrag) {
                  $objectDrag = $(this._objectDrag);
               }
               if ($objectDrag) {
                  $imageCurrentPage = this.findParentImageBySignItem($objectDrag);
                  imgHeightCurrentPage = parseFloat($imageCurrentPage.attr('height'));
                  setDrawCommentY = (imgHeightCurrentPage + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               } else {
                  const imgCurrentId = 'img_' + item.pageNum;
                  setDrawCommentY = (this.getPageHeight(imgCurrentId) + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               }
            }
            this.commentboxComp.createComponent(item, objDraw.attr('id'), setDrawCommentY, this.isHideAction);
         }
      } catch (e) {
         console.error(e);
      }
   }

   /** update ตำแหน่ง comment list เมื่อมีการ active */
   updatePositionCommentBox(item: any, y: any) {
      let setDrawCommentY: number;
      try {
         if (item) {
            if (item.pageNum === 1) {
               setDrawCommentY = y;
            } else {
               let $imageCurrentPage, imgHeightCurrentPage, $objectDrag;
               if (this._objDraw) {
                  $objectDrag = $(this._objDraw.node);
               } else if (this._objectDrag) {
                  $objectDrag = $(this._objectDrag);
               }
               if ($objectDrag) {
                  $imageCurrentPage = this.findParentImageBySignItem($objectDrag);
                  imgHeightCurrentPage = parseFloat($imageCurrentPage.attr('height'));
                  setDrawCommentY = (imgHeightCurrentPage + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               } else {
                  const imgCurrentId = 'img_' + item.pageNum;
                  setDrawCommentY = (this.getPageHeight(imgCurrentId) + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               }
            }
            this.commentboxComp.setPosition(item.idSignItem, setDrawCommentY);
            this.updateCommentTask(item);
         }
      } catch (e) {
         console.error(e);
      }
   }

   /** เมื่อคลิกที่ comment list จะทำการ select ที่ comment icon */
   onSelectDrawComment($event) {
      if (this._objectSVG) {
         this.deselectAll();
         for (const object of this._objectSVG) {
            for (const item of object.svg.children()) {
               if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                  if (item.attr('signer') && item.attr('id') === $event.id) {
                     if ($event.isActive) {
                        if (!this.isHideAction && item.attr('signer') === this.service.user.email) {
                           this.handleChangeTab();
                        }
                        this._onDrag = true; // ตั้งค่าตัวแปร flag drag
                        onDrag = true;
                        this._objectDrag = item.node;
                        this._idSignitems =  $event.id; // เก็บค่า id ของ object ล่าสุด
                        this._fieldType = item.attr('fieldType');
                        if (item.attr('isExists')) {
                           this.isHideDeleteBtn = item.attr('isExists');
                           this.isHideProperties = item.attr('isExists');
                           this.setVisibleProperty(true);
                           this._isHideProp = false;
                        } else {
                           if (item.attr('fieldType') === this._keyFieldType.comment || item.attr('fieldType') === this._keyFieldType.checkbox) {
                              this.isHideProperties = true;
                           } else {
                              this.isHideProperties = false;
                           }
                           this.setVisibleProperty(true);
                           this.isHideDeleteBtn = false;
                        }
                        setTimeout(() => {
                           item.selectize({
                              points: ['lt', 'rt', 'rb', 'lb'],
                              rotationPoint: false,
                           });
                        }, 0);
                        break;
                     }
                  }
               }
            }
         }
      }
   }

   /** เมื่อมีการอัพเดท comment จะทำการกลับมาอัพเดทค่าให้ signItem */
   saveCommentTask($event) {
      const data = Object.assign({}, $event);
      data.signItems.fieldWidth /= this.getCountZoom();
      data.signItems.fieldHeight /= this.getCountZoom();
      data.signItems.coordinateX /= this.getCountZoom();
      data.signItems.coordinateY /= this.getCountZoom();
      const signItemsList = Object.assign([], this.taskAttribute.docList[this.currentIndex].signItems);
      const countSignItem = signItemsList.filter(item => item.pageNum === data.signItems.pageNum && item.signer.toLowerCase() === this.service.user.email.toLowerCase());
      data.signItems.order = undefined;
      data.signItems.comment.notifyFlag = true;
      const signItems = data.signItems;
      this.service.saveCommentTask(this.taskAttribute.taskId, this.docidlist, signItems)
         .subscribe(
            (res) => {
               data.signItems.comment.id = res.postId;
               data.signItems.taskSignId = res.signItemId;
               const comment = JSON.stringify(data.signItems.comment);
               if (!this.isDrawing) {
                  if (this._objDraw) {
                     this._objDraw.attr({'taskSignId': res.signItemId, 'comment': comment});
                  } else if (this._objectDrag) {
                     const $objectDrag = $(this._objectDrag);
                     $objectDrag.attr({'taskSignId': res.signItemId, 'comment': comment});
                  }
               }
               this.updateItemSign(this.currentIndex);
            },
            error => {
               console.error(error);
            });
   }

   /** เมื่อมีการอัพเดท position comment จะทำการกลับมาอัทค่าให้ signItem */
   updateCommentTask($event) {
      const data = Object.assign({}, $event);
      let getObjId;
      if (this._objDraw) {
         getObjId = this._objDraw.attr('id');
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         getObjId = $objectDrag.attr('id');
      }
      if (getObjId === data.idSignItem) {
         if (data.comment && data.comment != null) {
            data.fieldWidth /= this.getCountZoom();
            data.fieldHeight /= this.getCountZoom();
            data.coordinateX /= this.getCountZoom();
            data.coordinateY /= this.getCountZoom();
            this.service.updateCommentTask(data)
               .subscribe(
                  () => {
                     this.updateItemSign(this.currentIndex);
                  },
                  error => {
                     console.error(error);
                  });
         }
      }


   }

   /** delete comment */
   deleteCommentTask(id) {
      if (id) {
         this.service.deleteCommentTask(this.taskAttribute.taskId, id)
            .subscribe(
               () => {
                  this.updateItemSign(this.currentIndex);
               },
               error => {
                  console.error(error);
               });
      }
   }

   /** เมื่อมีการ reply comment จะทำการกลับมาอัพเดทค่าให้ signItem */
   saveReplyTask($event) {
      const data = Object.assign({}, $event);
      const signItems = data.signItems;
      const reply = data.reply;
      data.reply['notifyFlag'] = true;
      this.service.saveReplyTask(this.taskAttribute.taskId, signItems.taskSignId, signItems.comment.id, reply)
         .subscribe(
            (res) => {
               const response = JSON.parse(res);
               signItems.comment.reply.forEach((item, i) => {
                  if (item.id === 0) {
                     item.id = response.id;
                  }
               });
               const comment = JSON.stringify(signItems.comment);

               if (!this.isDrawing) {
                  if (this._objDraw) {
                     this._objDraw.attr({'taskSignId': signItems.taskSignId, 'comment': comment});
                  } else if (this._objectDrag) {
                     const $objectDrag = $(this._objectDrag);
                     $objectDrag.attr({'taskSignId': signItems.taskSignId, 'comment': comment});
                  }
               }
               this.updateItemSign(this.currentIndex);
            },
            error => {
               console.error(error);
            });
   }

   /** สร้าง check box */
   renderCheckBox(item, checkbox, flag, yMarginSign?) {
      const that = this;
      let pageNo, img, fieldType, pageType, positionType, idSignItem, y, newX, x, isExists, chkName, chkDate, certId,
         content, taskSignId, comment, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox, stepOrder, taskContactId;
      flagCheckbox = ($(item.node).attr('flagCheckbox')  === 'true');

      if (flagCheckbox) {
         $(flag.node).attr('style', 'visibility: visible');
      } else {
         $(flag.node).attr('style', 'visibility: hidden');
      }

      const fnClickCheckbox = (e) => {
         flagCheckbox = !flagCheckbox;
         if (flagCheckbox) {
            $(flag.node).attr('style', 'visibility: visible');
         } else {
            $(flag.node).attr('style', 'visibility: hidden');
         }
         $(item.node).attr('flagCheckbox', flagCheckbox);
         pageNo = $(item.node).attr('pageNum');
         pageType = $(item.node).attr('pageType');
         positionType = $(item.node).attr('positionType');
         chkName = ($(item.node).attr('chkName') === 'true');
         chkDate = ($(item.node).attr('chkDate') === 'true');
         certId = parseInt($(item.node).attr('certId'), 10);
         idSignItem = $(item.node).attr('id');
         isExists = $(item.node).attr('isExists');
         stepOrder = $(item.node).attr('stepOrder');
         taskContactId = $(item.node).attr('taskContactId');

         if (yMarginSign) {
            y = item.y() + yMarginSign;
         } else {
            y = item.y();
         }
         newX = item.attr('newX');
         x = item.x();
         that._signer = $(item.node).attr('signer');
         fieldType = $(item.node).attr('class');
         content = '';
         if (fieldType === 'text') {
            content = item.node.textContent;
            fontStyle = $(item.node).attr('fontStyle');
            fontSize = Number($(item.node).attr('fontSize'));
            fontColor = $(item.node).attr('fontColor');
            fontBold = ($(item.node).attr('fontBold') === 'true');
            fontItalic = ($(item.node).attr('fontItalic') === 'true');
            fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
            textRequired = ($(item.node).attr('textRequired') === 'true');
         } else if (fieldType === 'comment') {
            taskSignId = $(item.node).attr('taskSignId') ?  $(item.node).attr('taskSignId') : null;
            comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
         } else if (fieldType === 'image'){
            idImageItem = $(item.node).attr('ref');
         }

         that.setSignItem(that._signer
            , fieldType
            , pageType
            , pageNo
            , positionType
            , chkName
            , chkDate
            , certId
            , x
            , y
            , item.children()[1].width()
            , item.children()[1].height()
            , idSignItem
            , item.attr('order')
            , content
            , true
            , taskSignId
            , comment
            , (isExists === 'true')
            , idImageItem
            , fontStyle
            , fontSize
            , fontColor
            , fontBold
            , fontItalic
            , fontUnderline
            , textRequired
            , flagCheckbox
            , stepOrder
            , taskContactId
         );
         if (that.taskAttribute.docList[that.currentIndex].signItems) {
            for (let i = 0; i < that.taskAttribute.docList[that.currentIndex].signItems.length; i++) {
               if (that.taskAttribute.docList[that.currentIndex].signItems[i].idSignItem === idSignItem) {
                  that.taskAttribute.docList[that.currentIndex].signItems[i] = that._signItem;
                  break;
               }
            }
         }
         e.preventDefault();
      };
      checkbox.node.addEventListener('click', function (e) {
         fnClickCheckbox(e);
      });

      flag.node.addEventListener('click', function (e) {
         fnClickCheckbox(e);
      });
   }

   /** ตั้งค่าตำแหน่ง comment list */
   setLeftComment() {
      try {
         setTimeout(() => {
            let left = 0, screenWidth = 0, marginPage = 0;
            screenWidth = window.innerWidth;
            const widthPage = Number($('#svg-page').attr('width'));
            if (screenWidth > widthPage) {
               marginPage = screenWidth;
               if (this.isToggleLeftOpened) {
                  marginPage -= 250;
               }
               if (this.isToggleRightOpened) {
                  marginPage -= 320;
               }
               if (marginPage > widthPage) {
                  marginPage -= widthPage;
                  marginPage = marginPage / 2;
                  left = marginPage + widthPage + 20;
               } else {
                  left = widthPage + 20;
               }
            } else {
               left = widthPage + 20;
            }
            (document.querySelector('#comment-box') as HTMLElement).style.left = `${left}px`;
         }, 0);
      } catch (e) {
         console.error(e);
      }
   }

   editSignature(img,chkName,chkDate){
      let imgTmp = new Image();
      imgTmp.crossOrigin="anonymous"
      let width = 0;
      imgTmp.onload = () => {
         if (chkName || chkDate) {
            width = 50;
            let canvas = this.canvasOriginal.nativeElement;
            let context = canvas.getContext("2d");
            var hRatio = canvas.width / imgTmp.width;
            var vRatio = canvas.height / imgTmp.height;
            var ratio = Math.min(hRatio, vRatio);
            var centerShiftX = ( canvas.width - imgTmp.width*ratio ) / 2;
            var centerShiftY = ( canvas.height - imgTmp.height*ratio ) / 2;
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(imgTmp,0,0, imgTmp.width+width, imgTmp.height, centerShiftX, centerShiftY,
               (imgTmp.width+width) * ratio, imgTmp.height * ratio);
            const tmp = this.editPatternCanvas(this.canvasOriginal.nativeElement, 'original',chkName,chkDate);
            img.attr('href', tmp.toDataURL());
         } else {
            img.attr('href', imgTmp.src);
         }

      }
      if (img.attr('fieldType') === this._keyFieldType.signature) {
         imgTmp.src = this.getPicSign();
      } else {
         imgTmp.src = this.getPicSignInit();
      }
   }

   editPatternCanvas(oldCanvas: HTMLCanvasElement , type: string,chkName,chkDate) {
      let canvasTmp = this.canvasPatternTmp.nativeElement;
      const ctx = canvasTmp.getContext('2d');
      ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

      if ((chkName || chkDate) && type !== 'init') {
         canvasTmp.width = oldCanvas.width + 75;
         canvasTmp.height = oldCanvas.height;

         ctx.drawImage(oldCanvas, -10, 0);

         const datepipe: DatePipe = new DatePipe('en-US');
         const formatDate = datepipe.transform(this.currentDate, 'dd/MM/yyyy');
         const formatTime = datepipe.transform(this.currentDate,  'HH:mm:ss Z');

         ctx.font = '200 8px Arial';
         const width = ctx.measureText(formatDate + ' ' + formatTime).width - 10;

         const x = canvasTmp.width - width;
         let y = canvasTmp.height / 2;
         if (chkName && chkDate) {
            y -= 10;
         }

         const lineSpace = 8;

         this.fillIncludeText(ctx,chkName,chkDate, x, y, lineSpace, formatDate, formatTime);
      } else {
         canvasTmp.width = oldCanvas.width;
         canvasTmp.height = oldCanvas.height;
         ctx.drawImage(oldCanvas, 0, 0);
      }
      return canvasTmp;
  }

  fillIncludeText(ctx: any,chkName: boolean,chkDate: boolean, x: number, y: number, lineSpace: number, date: string, time: string) {
      const user = JSON.parse(localStorage.getItem('idex-user'));
      if (chkName) {
         ctx.fillText('Digital signed by', x, y);
         y = y + lineSpace;
         let limit = 19;
         if (user.name.length <= limit) {
            ctx.fillText(user.name, x, y);
            y = y + lineSpace;
         } else {
            let len = user.name.length;
            let startIndex = 0;
            let endIndex = len - 1;
            while(startIndex <= endIndex){
               let str = user.name.substring(startIndex,startIndex + limit);
               startIndex += limit;
               ctx.fillText(str, x, y);
               y = y + lineSpace;
            }
         }
      }
      if (chkDate) {
         ctx.fillText('Date: ' + date, x, y);
         y = y +  lineSpace;
         ctx.fillText(time, x, y);
      }
   }
   switchViewer($event) {
      if ($event != 'notSave') {
         this.taskAttribute.tempId = $event;

      } else {
         this.checkNotSave = $event;
      }
      document.getElementById('main-page').style.display = 'flex';

   }

   checkView($event){
      document.getElementById('main-page').style.display = 'none';
      document.getElementById('print').style.display = 'none';
      this.service.getDocumentAdmin($event, 0, 'task')
            .subscribe((data) => {
                  this.initDocument(data);
               },
               err => {
                  this.handleWaitAction(false);
                  console.error(err);
               });
   }

   initDocument(data: any): void {

      if (document.getElementById('pdftronViewTask')) {
         document.getElementById('pdftronViewTask').style.width = '100%';
         document.getElementById('pdftronViewTask').style.height = '100%';
         document.getElementById('pdftronViewTask').style.left = '4000px';

      }

      const token = this.service.user.token;
      let mimeType = this.mimType;
      if (this.namelist.endsWith('.csv')) {
         mimeType = 'text/csv';
      }
      let contentUrl = '/content';

      const watermark = this.watermark;
      const url = contentUrl + '?id=' + data.id + '&token=' + token;
      const checkType = Mimetype.checkMimeType(mimeType);
      if (checkType === 'doc') {
         const file = encodeURIComponent(this.service.url + url + '&' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         this.docUrl = this.service.url + url + '&isPdfTron=true&' + '&' + Date.now();
         this.documentData = {
            url: this.docUrl,
            fileName: data.name,
            fileFormat: "pdf", // Office files stored in zDOX are converted to PDF, but the file name/extension may not change to .pdf
            type: "",
            mimeType: mimeType,
            docId: data.id,
            path: data.path,
            statusStartFlow: false,
            isPermissions: data.permissions,
            watermark: watermark,
            actionType: "switchTask",
            statusDocument: data.statusDocument,
            owner: data.creator.id,
         };
      } else if (checkType === 'img') {
         const file = encodeURIComponent(this.service.url + url + '&' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         this.docUrl = this.service.url + url + '&' + Date.now();
         this.documentData = {
            url: this.docUrl,
            fileName: data.name,
            type: "",
            mimeType: mimeType,
            docId: data.id,
            path: data.path,
            statusStartFlow: false,
            isPermissions: data.permissions,
            watermark: watermark,
            actionType: "switchTask",
            statusDocument: data.statusDocument,
            owner: data.creator.id,
         };
      }  else if (checkType === 'text') {
         this.service.get(url, {responseType: 'text'}).subscribe(() => {});
      }
      this.annoComp.changeDoc(this.documentData);
   }

   onSubmitFormSign() {
      this.dynamicFormComp.onSubmit(false);
   }

   onCheckSubmit(event: any) {
      if (event) {
         this.submitEForm('view-form', true);
      }
   }

   checkSubmit(isNavigate: boolean) {
      this.submitEForm('view-form', isNavigate);
   }

   submitEForm(actions: string, isNavigate: boolean, options?: boolean) {
      this.saveInProgress = true;
      const docId = this.eformService.formValue.docId === undefined ? '0' : this.eformService.formValue.docId;
      const formId = this.eformService.formValue.id === undefined ? 0 : this.eformService.formValue.id;
      const formInfo = {
         form: this.eformService.eForm.value,
         tin: localStorage.getItem('tin'),
         formType: 'VF',
         path: localStorage.getItem('form-path'),
         fileName: this.fileFormName ? this.fileFormName : localStorage.getItem("filename")
      };

      if (formInfo.form.value && typeof formInfo.form.value === 'object') {
         formInfo.form.value = JSON.stringify(formInfo.form.value);
      }

      this.api.submitEForm(actions, formId, formInfo, docId).subscribe((res) => {
            this.toast.success(res.message);
            if (actions === 'new-form' || actions === 'view-form' || options) {
               this.saveInProgress = false;
               if (isNavigate) {
                  this.router.navigate(['/tasks/all']);
               }
            } else {
               const _transformDate = new MomentPipe();
               this.eformService.formValue.id = res.formId;
               this.eformService.formValue.lastUpdate = {when: _transformDate.transform(res.lastUpdate)};
               this.eformService.formValue.version = res.version;
               this.eformService.eForm.markAllAsTouched();
            }
         }, (err) => {
            this.saveInProgress = false;
            this.toast.error(err.message)
         },
         () => {
            this.saveInProgress = false;
            this.eformService.eForm.reset(this.eformService.eForm.value);
            this.eformService.eForm.markAllAsTouched();
         });
   }

   eformSubmitPayload() {
      const docId = this.eformService.formValue.docId === undefined ? '0' : this.eformService.formValue.docId;
      const formId = this.eformService.formValue.id === undefined ? 0 : this.eformService.formValue.id;

      const formInfo = {
         form: this.eformService.eForm.value,
         tin: localStorage.getItem('tin'),
         formType: 'VF',
         path: localStorage.getItem('form-path'),
         fileName: this.fileFormName ? this.fileFormName : localStorage.getItem("filename")
      };

      if (formInfo.form.value && typeof formInfo.form.value === 'object') {
         formInfo.form.value = JSON.stringify(formInfo.form.value);
      }

      const payload = {
         docId: docId,
         formId: formId,
         formInfo: formInfo,
         actions: 'view-form'
      }

      return payload;
   }

   checkEFormValid() {
      if (this.dynamicFormComp?.form.status) {
         if (this.dynamicFormComp.form.status.toLowerCase() === 'valid') {
            return true;
         } else {
            return false
         }
      } else {
         if (this.eformService.statusForm && this.eformService.statusForm.toLowerCase() === 'valid') {
            return true;
         } else {
            return false
         }
      }
   }
}
